import React, { useState, useEffect, useRef } from "react";
import signOutWarning from "../../../Common/signOutWarning";
import { copyConfirmText } from "../../../Common/aiDisclaimer";
import { photoDefaultName, leftoverNamesNote } from "../../../Common/placeNaming";
import { guideShareLink } from "../../../Common/GuideLink";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import queryString from "query-string";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";

import "./MobileBottomNavBar.css";
// import { Link } from "react-router-dom";
// import GuideInfo from "../../modals/GuideInfo";
import logo from "../../../assets/images/logo1.jpg";

import DataBase, { logAnalyticsEvent } from "../../../dataBase/liquidGuides";
import Guide, { GuideAttributes } from "../../../Models/Guide";
import { stashConflictSnapshot } from "../../../Common/ConflictSnapshot";
import Place from "../../../Models/Place";
import { slice1Actions } from "../../../store/reducer";
import Common, { Settings, SortByEnum, AUTHORIZATION_LEVEL, COLORS, SAMPLE_GUIDE_ID, API_BASE_URL, isVersionBelow } from "../../../Common/Common";
import { generateTripHTML, printTripAsPDF } from "../../../Common/exportTripHTML";
import HTMLEditorModal from "../../modals/HTMLEditorModal";
import ImageUploadModal from "../../modals/ImageUploadModal";
import UserInfoModal from "../../modals/UserInfoModal";
import MenuModal from "../../modals/MenuModal";
import { openReportGuide, canReportGuide } from "../../modals/ReportGuideModal";
import useInvitationCount from "../../../Common/useInvitationCount";
import store from "../../../store/store";
import LoginModal from "../../modals/LoginModal";
import YouModal from "../../modals/YouModal";
import AlertModal from "../../modals/AlertModal";
import SaveConflictDiffModal from "../../modals/SaveConflictDiffModal";
import GeoCharts from "../../modals/GeoCharts";
import CommandPalette from "../../modals/CommandPalette";
import GuideDownload from "../../modals/GuideDownload/GuideDownload";
import ImageDialog, { forceNextImageDialogSource } from "../../modals/ImageDialog";
import GroupsDialog from "../../modals/GroupsDialog";
import PlacesOfInterest from "../../modals/PlacesOfInterest";
import CustomIcons from "../../modals/CustomIcons";

import CategoriesDialog from "../../modals/CategoriesDialog";
import SectionsDialog from "../../modals/SectionsDialog";
import GuideEditModal from "../../modals/GuideEditModal";
import SettingsDialog from "../../modals/SettingsDialog";
import AiDialog from "../../modals/AiDialog";
import FlightStatusDialog from "../../modals/FlightStatusDialog";
import ClimateDialog from "../../modals/ClimateDialog";
import { geocode } from "../../../Models/ClimateData";
import ReviewDialog from "../../modals/ReviewDialog";
import GuideSettingsDialog from "../../modals/GuideSettingsDialog";
import PDFModal from "../../modals/PDFModal";
import HTMLReader from "../../modals/HTMLReader";
import MultiSelectModal from "../../modals/MultiSelectModal";
import GuideTranslate from "../../modals/GuideTranslate";
import PhotoJournalWizardModal from "../../modals/PhotoJournalWizardModal";
import WikipediaArticlesModal from "../../modals/WikipediaArticlesModal";
import { applyPhotoExtras } from "../../../Common/photoCredit";
import PhotoJournalReviewModal from "../../modals/PhotoJournalReviewModal";
import GoogleDrivePicker from "../../modals/GoogleDrivePicker";
import ExportOptionsModal from "../../modals/ExportOptionsModal";
import ShareModal from "../../modals/ShareModal";
import DestinationsScreen from "../../modals/DestinationsScreen";
import PreferencesScreen from "../../modals/PreferencesScreen";
import AdminDashboard from "../../modals/AdminDashboard";
import { cleanDestination } from "../../../Common/DestinationValidation";
import CommentDismiss from "../../../Common/CommentDismiss";
import CommentsListModal from "../../modals/CommentsListModal";
import PhotoBookPreviewModal from "../../modals/PhotoBookPreviewModal";
import GuideDiscussionModal from "../../modals/GuideDiscussionModal";
import PollsModal from "../../modals/PollsModal";
import ExpensesModal from "../../modals/ExpensesModal";
import TripMembersModal from "../../modals/TripMembersModal";
import { deriveCandidatesFromEvents } from "../../modals/ScheduleDestinationsFlow";
import Section from "../../../Models/Section";
import Group from "../../../Models/Group";

import { DateTime } from "luxon";

import { urlSchemeToFunctions } from "../../../CommonWeb/Common";
//import { Offcanvas } from "react-bootstrap";

import User from "../../../Models/User";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import Appointment from "../../../Models/Event";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid, regular, brands, icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import KMLInput from "../../modals/KMLInput";
// Old Build Trip with AI planner, unhooked 2026-10-19 (Build My Trip stage 4:
// every AI trip now goes through Build My Trip's AI source). Its file is kept;
// restore this import (and remove the stub) to bring it back.
// import TripAI from "../../modals/TripAI";
import BuildMyTripWizard from "../../modals/BuildMyTripWizard";
import WalkAI from "../../modals/WalkAI";
import ExportTripModal from "../../modals/ExportTripModal";
import ImportTripModal from "../../modals/ImportTripModal";
import ImportConfirmationModal from "../../modals/ImportConfirmationModal";
import ImportItineraryImageModal from "../../modals/ImportItineraryImageModal";
import ExportVideoModal from "../../modals/ExportVideo/ExportVideoModal";
import PackingListDialog from "../../modals/PackingListDialog";
import { setFeatureFlags, isPhotoBookEnabled } from "../../../Common/featureFlags";
import { journalEventEnd } from "../../../Common/journalEventEnd";
// Stand-in for the unhooked old Build Trip with AI planner (see the
// commented import above).
const TripAI = () => null;

// Sentinel for Photo Journal's "Which schedule?" picker's "create a new
// schedule" option — matches BuildMyTripWizard.js's own NEW_SCHEDULE_VALUE.
const PHOTO_JOURNAL_NEW_SCHEDULE = "__new__";

const MobileBottomNavBar = (props) => {
  const [guideInfoModal, setGuideInfoModal] = useState(false);

  const [ShowHTMLEditorModal, setHTMLEditorModal] = useState(false);
  const [HTMLEditorModalContent, setHTMLEditorModalContent] = useState("");
  const [HTMLEditorModalCallback, setHTMLEditorModalCallback] = useState(null);
  const [EditNotesMode, setEditNotesMode] = useState(false);

  const [ImageDialogShow, setImageDialogShow] = useState(false);
  const [ImageDialogMode, setImageDialogMode] = useState("upload");
  const [ImageDialogExif, setImageDialogExif] = useState(false);
  // Create Places from Photos' web sources (2026-10-17): the image chooser
  // limited to free web photos, and the Wikipedia articles picker.
  const [ImageDialogWeb, setImageDialogWeb] = useState(false);
  // Web photos' group choice (2026-10-22): { places, useGroup, name } while
  // the "Add N places" dialog is open.
  const [webPhotoGroupChoice, setWebPhotoGroupChoice] = useState(null);
  const [wikipediaArticlesShow, setWikipediaArticlesShow] = useState(false);

  const [photoJournalWizardShow, setPhotoJournalWizardShow] = useState(false);
  const [gdriveJournalPickerShow,   setGdriveJournalPickerShow]  = useState(false);
  const [gdriveJournalOptions, setGdriveJournalOptions] = useState(null);
  // { guideTarget: "new"|"add"|"replace", newGuideName, scheduleTarget
  // (an existing schedule's exact name, or PHOTO_JOURNAL_NEW_SCHEDULE),
  // groupName } — set right before updateImageCallBack runs. Matches
  // BuildMyTripWizard.js's guideTarget model instead of the old single
  // "Clear and overwrite guide" toggle, which could only ever act on the
  // current guide.
  const journalOptionsRef = useRef({ guideTarget: "add", newGuideName: "", scheduleTarget: PHOTO_JOURNAL_NEW_SCHEDULE, groupName: "Photo" });
  const [photoJournalReviewShow, setPhotoJournalReviewShow] = useState(false);
  const [photoJournalReviewClusters, setPhotoJournalReviewClusters] = useState([]);
  const [photoJournalSensitivity, setPhotoJournalSensitivity] = useState(200);
  const [photoJournalMaxSpan, setPhotoJournalMaxSpan] = useState(1000);
  const photoJournalExifImagesRef = useRef([]);
  const photoJournalScheduleRef = useRef("");
  const photoJournalGroupIdRef = useRef(null);
  const [showExportOptions, setShowExportOptions] = useState(false);
  const [showExportVideo, setShowExportVideo] = useState(false);
  const [shareLinkShow, setShareLinkShow] = useState(false);
  const [exportTripShow, setExportTripShow] = useState(false);
  const [importTripShow, setImportTripShow] = useState(false);
  const [importConfirmationShow, setImportConfirmationShow] = useState(false);
  const [importItineraryImageShow, setImportItineraryImageShow] = useState(false);
  // Import Confirmation Email's post-import "Generate an AI-enhanced trip?"
  // offer — derives destination candidates from just the events that import
  // created and persists them straight onto the guide (Guide.destinations is
  // the single source of truth TripAI/BuildMyTripWizard now read from
  // read-only; see DestinationsScreen.js and memory:
  // project_destinations_first_redesign_idea), then opens TripAI to build
  // from them like any other already-persisted destinations.
  const offerTripAIFromImport = (createdEvents) => {
    const candidates = deriveCandidatesFromEvents(createdEvents || []).map(cleanDestination);
    // Handed to Build My Trip as data (2026-10-20): it replaces the guide's
    // destinations only when Create is pressed. Writing them here lost the
    // guide's own destinations if Build My Trip was then closed — the bug
    // fixed for Image or Text import on 2026-09-28.
    if (candidates.length > 0) {
      setBuildMyTripInitialDestinations(candidates);
      setBuildMyTripReplaceDestinations(true);
    }
    // 2026-10-19 (Build My Trip stage 4): Build My Trip with the AI source,
    // adding to this guide in a NEW schedule — the imported flights/hotels
    // in "Main" stay as they are (the old TripAI replaced events on those
    // days). Was: setTripAIShow(true);
    setBuildMyTripInitialTarget("add");
    setBuildMyTripInitialScheduleTarget("__new__");
    setBuildMyTripAutoOpenAI(true);
    setBuildMyTripWizardShow(true);
  };

  const [ShowUserInfoModal, setUserInfoModal] = useState(false);
  const [ShowLoginModal, setShowLoginModal] = useState(false);
  const [ShowYouModal, setShowYouModal] = useState(false);
  const [LoginModalMode, setLoginModalMode] = useState("Login");
  // Dismissed once the guest commits to either signing in or starting fresh —
  // from the banner itself, the welcome screen's buttons, or TripAI's inline
  // Sign In link. Not tied to guide_meta, so it stays hidden across all of
  // those entry points rather than just the one that was clicked.
  const [TravelDocumentBannerDismissed, setTravelDocumentBannerDismissed] = useState(false);
  // Object identity — port of andiamo-places' MainScreen.js
  // _dismissedUnsavedGuideRef, as React state (not a plain ref) since
  // dismissing needs to trigger a re-render here to actually hide the
  // banner. A new/loaded guide is a new window.guide_obj reference, so
  // dismissing one guide's banner never suppresses the next guide's.
  const [dismissedUnsavedGuide, setDismissedUnsavedGuide] = useState(null);
  // CommentDismiss itself (localStorage) is read synchronously at render
  // time — this counter just forces a re-render after a dismiss-write,
  // since writing to localStorage alone doesn't trigger one.
  const [commentDismissVersion, setCommentDismissVersion] = useState(0);
  const [showCommentsList, setShowCommentsList] = useState(false);
  const [showPhotoBookPreview, setShowPhotoBookPreview] = useState(false);
  const [showGuideDiscussion, setShowGuideDiscussion] = useState(false);
  const [showPolls, setShowPolls] = useState(false);
  const [showExpenses, setShowExpenses] = useState(false);
  const [showTripMembers, setShowTripMembers] = useState(false);
  const [showDestinations, setShowDestinations] = useState(false);
  const [showPreferences, setShowPreferences] = useState(false);
  const [showAdminDashboard, setShowAdminDashboard] = useState(false);

  // Hidden admin unlock — typing the exact word "admin" into the Command
  // Palette triggers this instead of listing a normal, always-partially-
  // visible command. Not real access control (no sensitive data involved),
  // just keeps the Dashboard/"Featured" toggle out of casual users' way.
  // See memory: DIY Firestore analytics plan.
  const handleAdminSecretMatch = () => {
    // Close the Command Palette first — it's a react-bootstrap Modal with
    // its own focus trap, and leaving it mounted/shown underneath
    // AdminDashboard fights AdminDashboard's own inputs for focus (this is
    // what caused the lookupId text field to silently reject typed input,
    // and the recent-guides <select> dropdown to close right after opening).
    setCommandPaletteShow(false);
    if (window.admin_unlocked) {
      setShowAdminDashboard(true);
      return;
    }
    const entered = window.prompt("Admin password:");
    if (entered && entered === process.env.REACT_APP_ADMIN_PASSWORD) {
      window.admin_unlocked = true;
      setShowAdminDashboard(true);
    }
  };

  const [MenuModalShow, setMenuModalShow] = useState(false);
  const [MenuModalImage, setMenuModalImage] = useState(null);
  const [MenuModalList, setMenuModalList] = useState([]);
  const [MenuModalHeading, setMenuModalHeading] = useState("");
  const [MenuModalPlace, setMenuModalPlace] = useState(null);
  const [MenuModalBackFn, setMenuModalBackFn] = useState(null);
  const [AlertModalShow, setAlertModalShow] = useState(false);
  const [diffModalShow, setDiffModalShow] = useState(false);
  const [diffModalConflict, setDiffModalConflict] = useState(null);
  const [AlertModalTitle, setAlertModalTitle] = useState("");
  const [AlertModalMessage, setAlertModalMessage] = useState("");
  const [AlertModalButtons, setAlertModalButtons] = useState([]);
  const afterGuideLoadRef = useRef(null);
  const [GeoChartsShow, setGeoChartsShow] = useState(false);
  const [GeoChartsData, setGeoChartsData] = useState(false);
  const [commandPaletteShow, setCommandPaletteShow] = useState(false);
  const [activityIndicator, setActivityIndicator] = useState(false);
  const [GuideDownloadMode, setGuideDownloadMode] = useState("list");
  const [GuideDownloadType, setGuideDownloadType] = useState("read");
  // Overrides the Mine/Viewed default below, only when opening the dialog
  // should land on a specific tab (e.g. "Featured" from WelcomeOverlay) —
  // cleared on close so a later plain "Library" click goes back to normal.
  const [GuideDownloadInitialType, setGuideDownloadInitialType] = useState(null);
  const [GuideDownloadShow, setGuideDownloadShow] = useState(false);
  const [GuideDownloadCategory, setGuideDownloadCategory] = useState("Mine");

  const [GroupsDialogShow, setGroupsDialogShow] = useState(false);
  const [CategoriesDialogShow, setCategoriesDialogShow] = useState(false);
  const [PlacesOfInterestShow, setPlacesOfInterestShow] = useState(false);

  const [SectionsDialogShow, setSectionsDialogShow] = useState(false);
  const [GuideEditModalShow, setGuideEditModalShow] = useState(false);
  const [GuideEditModalMode, setGuideEditModalMode] = useState("VIEW");

  const [SettingsDialogShow, setSettingsDialogShow] = useState(null);

  const [AiDialogShow, setAiDialogShow] = useState(null);
  const [FlightStatusShow, setFlightStatusShow] = useState(false);
  // Redux, not local state — lets Home.js's "climatelink" scheme open this
  // dialog too (see reducer.js's ClimateDialogParams).
  let ClimateDialogParams = useSelector((state) => state.ClimateDialogParams);

  const [ReviewDialogShow, setReviewDialogShow] = useState(null);
  const [CustomIconsShow, setCustomIconsShow] = useState(false);
  const [GuideSettingsDialogShow, setGuideSettingsDialogShow] = useState(false);
  const [PackingListDialogShow, setPackingListDialogShow] = useState(false);
  const [PDFModalShow, setPDFModalShow] = useState(false);
  const [HTMLReaderModal, setHTMLReaderModal] = useState(false);
  const [HTMLContent, setHTMLContent] = useState("");

  const [ShowMultiselect, setShowMultiselect] = useState(false);
  const [MultiselectItems, setMultiselectItems] = useState([]);
  const [MultiselectSelectedItems, setMultiselectSelectedItems] = useState([]);
  const [MultiselectMode, setMultiselectMode] = useState("uni");
  const [MultiselectTitle, setMultiselectTitle] = useState("Select");
  const [MultiselectSearchText, setMultiselectSearchText] = useState("");
  const [MultiselectCallback, setMultiselectCallback] = useState(null);
  
  //const [guideInfoID, setGuideInfoID] = useState("");
  const [documentHTML, setdocumentHTML] = useState("");
  const [KMLInputShow, setKMLInputShow] = useState(false);
  const [KMLFileType, setKMLFileType] = useState("KML");
  const [KMLPresetFiles, setKMLPresetFiles] = useState(null);
  
  const [TripAIShow, setTripAIShow] = useState(null);
  const [BuildMyTripWizardShow, setBuildMyTripWizardShow] = useState(false);
  // Set by the "openBuildMyTripWizard" window event (DestinationsScreen.js's
  // "Find Places" offer, Places.js's empty-guide hint) — those callers
  // already have real content (destinations) on the CURRENT guide, so the
  // wizard must default to "Add to this guide," not its normal "A new
  // guide" default, or Create would silently discard what was just saved.
  const [buildMyTripInitialTarget, setBuildMyTripInitialTarget] = useState(undefined);
  // ImportItineraryImageModal's destinations-only import — passed as DATA,
  // not written onto window.guide_obj here, so the wizard itself is the
  // only thing that ever touches the guide (inside its own onCreate,
  // matching mobile's identical fix). Requested 2026-09-28 — see project
  // memory: destinations were previously written onto the guide the moment
  // Import was tapped, before the user ever reached/committed in the
  // wizard, so backing out of it still left the guide's real destinations
  // overwritten.
  const [buildMyTripInitialDestinations, setBuildMyTripInitialDestinations] = useState(undefined);
  // The imported destinations replace the guide's own (Import Confirmation
  // AI offer) instead of being added to them (Image or Text import).
  const [buildMyTripReplaceDestinations, setBuildMyTripReplaceDestinations] = useState(false);
  const [buildMyTripAutoStart, setBuildMyTripAutoStart] = useState(false);
  // True for BOTH nudge variants (Auto-Build and Let Me Pick) — unlike
  // buildMyTripAutoStart (which only skips the setup dialog for "Let Me
  // Pick"), this tells the wizard the guide already has destinations but
  // zero places, so it must build a fresh itinerary even though the
  // existing document isn't blank/placeholder. Without this, "Auto-Build"
  // (which never sets autoStart) silently left the guide with no itinerary.
  const [buildMyTripFromNudge, setBuildMyTripFromNudge] = useState(false);
  // Set by the command palette's "Build Trip with AI" entry — that's now the
  // one place in the app still searchable by that name, per the user's
  // decision to fold the old standalone entry point away everywhere else
  // but keep it discoverable by search. Rather than opening a second
  // top-level modal, it opens Build My Trip and has it immediately hand off
  // to Build Trip with AI via the exact same onSwitchToAI path the in-wizard
  // link uses — see BuildMyTripWizard.js's autoOpenAI effect. 2026-10-04.
  const [buildMyTripAutoOpenAI, setBuildMyTripAutoOpenAI] = useState(false);
  // Starting "Which schedule?" choice (e.g. "__new__" from Import
  // Confirmation's AI-trip offer). 2026-10-19.
  const [buildMyTripInitialScheduleTarget, setBuildMyTripInitialScheduleTarget] = useState(undefined);
  // "Build Trip from Guides" — the same wizard, opened with "From existing
  // guides" already chosen under "How should places be chosen?". 2026-10-13.
  const [buildMyTripFromGuides, setBuildMyTripFromGuides] = useState(false);
  // "Build Trip from Places" (Places menu) and Build Trip from Image or Text
  // open Build My Trip with "This guide's places" chosen (2026-10-17) —
  // { placeIds } limits it to those places (null = all). Sent as the
  // "andiamo-build-my-trip-this-guide" event (PlacesHeader.js).
  const [buildMyTripFromThisGuide, setBuildMyTripFromThisGuide] = useState(null);
  useEffect(() => {
    const handler = (e) => {
      const ids = e?.detail?.placeIds;
      setBuildMyTripFromThisGuide({ placeIds: Array.isArray(ids) && ids.length > 0 ? ids : null });
      setBuildMyTripWizardShow(true);
    };
    window.addEventListener("andiamo-build-my-trip-this-guide", handler);
    return () => window.removeEventListener("andiamo-build-my-trip-this-guide", handler);
  }, []);
  // Which of the two nudge variants was picked — "Auto-build" (fully
  // automated: choose places, build schedule/itinerary, no review) vs.
  // "Pick places myself" (guided: review/choose places, schedule/itinerary
  // still build automatically once done). Passed through as
  // e.detail.pickPlacesAuto on the openBuildMyTripWizard event.
  const [buildMyTripPickPlacesAuto, setBuildMyTripPickPlacesAuto] = useState(true);
  // This nudge's own Pace choice — its "Let Me Pick" variant autoStarts
  // straight past BuildMyTripWizard's own setup screen (and the Pace picker
  // on it), so the nudge needs its own. Defaults to Relaxed (1.3), not
  // Normal (1) — see BuildMyTripWizard.js.
  const [buildMyTripPaceMultiplier, setBuildMyTripPaceMultiplier] = useState("1.3");
  const [WalkAIShow, setWalkAIShow] = useState(false);
  const [GuideTranslateShow, setGuideTranslateShow] = useState(false);

  const dispatch = useDispatch();
  let creator_info = useSelector((state) => state.creator_info);
  let owner_info = useSelector((state) => state.owner_info);
  let user_info = useSelector((state) => state.user_info);
  let user_info_id = useSelector((state) => state.user_info_id);
  let AppSettings = useSelector((state) => state.AppSettings);
  let Authorization = useSelector((state) => state.Authorization);
  let PreviewingConflictSnapshot = useSelector((state) => state.PreviewingConflictSnapshot);
  const advancedMode = user_info?.advanced_mode === "On";
  // let guide_info = useSelector((state) => state.guide_info);
  let guide_meta = useSelector((state) => state.guide_meta);
  // Share invitations waiting (4.10.55): a badge on Library, which then
  // opens on Shared where they're listed.
  const inviteCount = useInvitationCount(user_info?.uid);

  let HTMLStack = useSelector((state) => state.HTMLStack);
  let htmlString = useSelector((state) => state.homeScreen);
  let GuideSortOption = useSelector((state) => state.GuideSortOption);
  let MenuModalArgs = useSelector((state) => state.MenuModalArgs);
  let GuideStack = useSelector((state) => state.GuideStack);
  let ViewedGuides = useSelector((state) => state.ViewedGuides);
  let MobileMode = useSelector((state) => state.MobileMode);
  let GuideEditMode = useSelector((state) => state.GuideEditMode);
  let HomeFullScreen = useSelector((state) => state.HomeFullScreen);
  let GuideSettings = useSelector((state) => state.GuideSettings);
  let GuideHasUnsavedChanges = useSelector((state) => state.GuideHasUnsavedChanges);
  let ContentFontZoom = useSelector((state) => state.ContentFontZoom);
  let GuidesOrPlaces = useSelector((state) => state.GuidesOrPlaces);
  let HidePlaces = useSelector((state) => state.HidePlaces);
  let HideSchedule = useSelector((state) => state.HideSchedule);
  let HideMap = useSelector((state) => state.HideMap);
  let HideHome = useSelector((state) => state.HideHome);
  let HideSideMenu = useSelector((state) => state.HideSideMenu);

  let GuideType = useSelector((state) => state.GuideType);
  let GuideInfoArray = useSelector((state) => state.GuideInfoArray);
  let GuideInfoArrayMine = useSelector((state) => state.GuideInfoArrayMine);

  let SizeMapToFit = useSelector((state) => state.SizeMapToFit);

  let NoAds = useSelector((state) => state.NoAds);
  let TripAIShown = useSelector((state) => state.TripAIShown);
  let imageFolder = useSelector((state) => state.imageFolder);
  let ScheduleName = useSelector((state) => state.ScheduleName);
  let GuideFormat = useSelector((state) => state.GuideFormat);
  let ShowHiddenPlaces = useSelector((state) => state.ShowHiddenPlaces);
  
  
    let _MultiselectItems = useSelector((state) => state.MultiselectItems);
    let _MultiselectSelectedItems = useSelector((state) => state.MultiselectSelectedItems);
    let _MultiselectMode = useSelector((state) => state.MultiselectMode);
    let _MultiselectSearchText = useSelector((state) => state.MultiselectSearchText);
    let _MultiselectTitle = useSelector((state) => state.MultiselectTitle);
    let _MultiselectCallback = useSelector((state) => state.MultiselectCallback);
    let _ShowMultiselect = useSelector((state) => state.ShowMultiselect);

  //console.log("HomeHeader HTMLStack.length:", HTMLStack.length);

  //let search = window.location.search;
  // let params = new URLSearchParams(search);
  // let foo = params.get('query');
  //console.log(foo);

  // const reportWindowSize = (evt) => {
  //   console.log("reportWindowSize", evt.currentTarget.innerWidth, evt.currentTarget.innerHeight);
  // };
  let htmlStackLength = HTMLStack.length;
  useEffect(() => {
    //Runs on the first render
    //And any time any dependency value changes
    htmlStackLength = HTMLStack.length
  }, [HTMLStack]);

  // A guide built locally while a guest (createLocalGuide) never had
  // an owner — GuideAttributes defaults user_id/creator_id to "" and access
  // to [] — so once signed in, neither a direct save (needs user_id === uid)
  // nor a copy (needs at least COPY access, which an empty access array
  // doesn't grant) can succeed. The findUserByUIDCallback ->
  // guest_generated_unsaved_trip -> persistLocalGuide path is meant to fix
  // this on sign-in, but only fires if that flag was actually set (i.e. the
  // guest went through TripAI's create flow) — this is a robust fallback
  // that doesn't depend on that flag: whenever a real sign-in is detected
  // and the current in-memory guide is still genuinely unclaimed
  // (guide_info_id == null means it was never persisted, so there's no
  // existing real owner to be overwriting), claim it directly.
  useEffect(() => {
    if (
      window.guide_obj &&
      user_info?.uid != null &&
      user_info.uid !== "guest" &&
      guide_meta?.guide_info_id == null &&
      (!window.guide_obj?.attributes?.user_id || window.guide_obj.attributes.user_id === "guest")
    ) {
      window.guide_obj.attributes.user_id = user_info.uid;
      window.guide_obj.attributes.creator_id = user_info.uid;
      window.guide_obj.attributes.owner_name = `${user_info.first_name || ""} ${user_info.last_name || ""}`.trim();
      window.guide_obj.attributes.access = [user_info.uid];
      dispatch(slice1Actions.setGuide({ guide: null }));
    }
  }, [user_info]);

  const handleLoad = () => {
    //const parsed = queryString.parse(window.location.search);

    // if (typeof parsed.id != "undefined") loadGuide(parsed.id);
    // else loadGuide("IQrZiedo7oJWa9GgLR6L");

    // const parsed = queryString.parse(window.location.search);
    // console.log("*********parsed", parsed);
    // if (typeof parsed.no_ads != "undefined") dispatch(slice1Actions.setNoAds({ value: true }));
    // if (typeof parsed.featured_guides != "undefined") setTimeout(() => ShowGuidesOrGuide("Guides", "Featured"), 7000);
    // else if (typeof parsed.my_guides != "undefined") setTimeout(() => ShowGuidesOrGuide("Guides", "Mine"), 7000);
    DataBase.onAuthStateChanged(onAuthStateChanged);
    DataBase.readSettings(readSettingsCallback);
    dispatch(slice1Actions.ClearAllFilters());
    //window.addEventListener("resize", reportWindowSize);
  };
  
  // useEffect(() => {
  //   console.log("TripAIShown", TripAIShown)
  //   if(TripAIShown === false){
  //     if(window.guide_obj !== "undefined"){
  //       //delayTripAILaunch();
  //       //dispatch(slice1Actions.setTripAIShown({ value: true }));
  //       setTimeout(() => delayTripAILaunch(), 3000);
  //     } //else delayTripAILaunch();
  //   }
  // }, [window.guide_obj]);

  // const delayTripAILaunch = () => {
  //   setTripAIShow(true);
  //   dispatch(slice1Actions.setTripAIShown({ value: true }));
  // }

// const delayTripAILaunch = () => {
  //   if(TripAIShown === false){
  //     if(window.guide_obj !== "undefined"){
  //       dispatch(slice1Actions.setTripAIShown({ value: true }));
  //       setTimeout(() => setTripAIShow(true), 3000);
  //     }
  //   }
  // }

  const readSettingsCallback = (res) => {
    console.log("readSettingsCallback");
    if (res.pass === true) {
      setFeatureFlags(res.res);
      // Platform targeting + version gate — matches HomeHeader.js's/
      // mobile's identical MainScreen.js readSettingsCallback. Requested
      // 2026-09-28 — see project memory: project_firestore_rules_hardening.
      const announcePlatforms = res.res.announce_platforms;
      const announceTargetsWeb =
        !Array.isArray(announcePlatforms) || announcePlatforms.length === 0 || announcePlatforms.includes("web");
      // NODE_ENV is "production" only for a real `npm run build` output,
      // "development" for the dev server — lets an admin preview an
      // announcement without it ever reaching real users.
      const announceAllowedForBuild = !res.res.announce_test_only || process.env.NODE_ENV !== "production";
      const minVersion = res.res.min_supported_version;
      const minVersionForWeb = minVersion && typeof minVersion === "object" ? minVersion.web : null;
      const updateRequired =
        typeof minVersionForWeb === "string" &&
        minVersionForWeb !== "" &&
        isVersionBelow(process.env.REACT_APP_VERSION, minVersionForWeb);
      if (updateRequired) {
        setHTMLContent(
          "<h3>A new version of Andiamo Places is available</h3><p>Please refresh this page to get the latest version.</p>"
        );
        setHTMLReaderModal(true);
      } else if (
        typeof res.res.announce !== "undefined" &&
        res.res.announce !== "" &&
        announceTargetsWeb &&
        announceAllowedForBuild
      ) {
        setHTMLContent(res.res.announce);
        setHTMLReaderModal(true);
      }
      dispatch(slice1Actions.setAppSettings({ value: res.res }));
    }
  };

  useEffect(() => {
    window.addEventListener("load", handleLoad);
    return () => window.removeEventListener("load", handleLoad);
  }, []);

  // Lets "N more options in Advanced Mode" hints in other components
  // (PlacesHeader.js, Map.js, ScheduleHeader.js/SchedulePanel.js) flip
  // Advanced Mode directly from here — those components don't own this
  // toggle themselves. Opening the full Settings dialog for this used to
  // fail for guests (Settings' own save blocks guest writes outright);
  // toggleAdvancedMode applies locally and only syncs to the cloud when
  // signed in, so it works for everyone.
  const toggleAdvancedModeRef = useRef(null);
  useEffect(() => {
    toggleAdvancedModeRef.current = toggleAdvancedMode;
  });
  useEffect(() => {
    const handler = () => { if (toggleAdvancedModeRef.current) toggleAdvancedModeRef.current(); };
    window.addEventListener("toggleAdvancedMode", handler);
    return () => window.removeEventListener("toggleAdvancedMode", handler);
  }, []);

  // Reopen the same menu after toggling Advanced Mode from its own
  // "N more options" hint, so the newly-revealed items are visible right
  // away instead of the menu just closing — same fix already applied to
  // PlacesHeader.js/Map.js/ScheduleHeader.js/SchedulePanel.js's hints, but
  // this file owns four of its own hint sites (GuideMenu,
  // ImportUploadShareMenu, ExportShareMenu, EditMenu) that were missed.
  const guideMenuRef = useRef(null);
  const importUploadShareMenuRef = useRef(null);
  const exportShareMenuRef = useRef(null);
  const editMenuRef = useRef(null);
  const tripCommunicationMenuRef = useRef(null);
  useEffect(() => {
    guideMenuRef.current = GuideMenu;
    importUploadShareMenuRef.current = ImportUploadShareMenu;
    exportShareMenuRef.current = ExportShareMenu;
    editMenuRef.current = EditMenu;
    tripCommunicationMenuRef.current = TripCommunicationMenu;
  });

  // WelcomeScreen (first-run) and TripAI's disabled "A new guide" hint both
  // need to open Sign In without owning LoginModal state themselves.
  useEffect(() => {
    const handler = (e) => {
      setLoginModalMode(e?.detail?.mode || "Login");
      setShowLoginModal(true);
    };
    window.addEventListener("openLoginModal", handler);
    return () => window.removeEventListener("openLoginModal", handler);
  }, []);

  // "Find Places" offers elsewhere (DestinationsScreen.js after Save,
  // Places.js/SchedulePanel.js/Map.js's empty-guide hints) — always opens
  // against the current guide ("add", never the wizard's normal "new guide"
  // default), since destinations already exist on it. Two variants:
  // e.detail.pickPlacesAuto === false ("Let Me Pick") skips the setup dialog
  // entirely (autoStart) since that flow benefits most from getting straight
  // to the point; true/omitted ("Auto-Build") just opens the normal wizard —
  // its own defaults (Google search, auto-pick places) already ARE the
  // fully-automated experience, so there's nothing to skip ahead of, just
  // destinations already pre-filled and Create ready to tap.
  useEffect(() => {
    const handler = (e) => {
      // A Trip Builder link (?build=, App.js): its destinations as a NEW guide, the normal wizard
      if (e?.detail?.buildLink) {
        if (window.__andiamoBuildLinkTaken) return; // one wizard only, whichever layout is mounted
        window.__andiamoBuildLinkTaken = true;
        // the trip starts from an empty guide, not the sample guide the app opened with (nothing is saved until Create);
        // addToGuide (a "Continue in the app" trip's extra days, 2026-11-01): added to the trip just opened
        if (!e.detail.addToGuide) createLocalGuide("New Guide", () => {});
        setBuildMyTripInitialTarget(e.detail.addToGuide ? "add" : "new");
        setBuildMyTripInitialDestinations(e.detail.buildLink);
        setBuildMyTripAutoStart(false);
        setBuildMyTripFromNudge(false);
        setBuildMyTripWizardShow(true);
        return;
      }
      const pickPlacesAuto = e?.detail?.pickPlacesAuto ?? true;
      setBuildMyTripInitialTarget("add");
      setBuildMyTripAutoStart(!pickPlacesAuto);
      setBuildMyTripPickPlacesAuto(pickPlacesAuto);
      if (e?.detail?.paceMultiplier) setBuildMyTripPaceMultiplier(String(e.detail.paceMultiplier));
      setBuildMyTripFromNudge(true);
      setBuildMyTripWizardShow(true);
    };
    window.addEventListener("openBuildMyTripWizard", handler);
    return () => window.removeEventListener("openBuildMyTripWizard", handler);
  }, []);

  // The desktop side menu's "AI Guide Creator" (VerticalSidebar.js) lives
  // outside this component: same as "Build Trip with AI" (2026-10-19).
  useEffect(() => {
    const handler = () => { setBuildMyTripAutoOpenAI(true); setBuildMyTripWizardShow(true); };
    window.addEventListener("openBuildTripWithAI", handler);
    return () => window.removeEventListener("openBuildTripWithAI", handler);
  }, []);

  // Shortcuts from the guide name bar's Edit menu (GuideNameBar.js), which
  // can't reach this component's dialog state directly. e.detail.name:
  // "buildMyTrip" (same as the menu's Build My Trip), "guideSettings",
  // "editNotes", "clearGuide", "reloadGuide". Goes through a ref
  // refreshed every render (same pattern as the welcome screen actions
  // below) so it always calls the current handlers.
  const appDialogActionRef = useRef(null);
  useEffect(() => {
    appDialogActionRef.current = (name) => {
      if (name === "buildMyTrip") setBuildMyTripWizardShow(true);
      else if (name === "guideSettings") setGuideSettings();
      else if (name === "editNotes") EditNotes();
      else if (name === "clearGuide") clearGuide();
      else if (name === "reloadGuide") RefreshGuide();
    };
  });
  useEffect(() => {
    const handler = (e) => appDialogActionRef.current?.(e?.detail?.name);
    window.addEventListener("openAppDialog", handler);
    return () => window.removeEventListener("openAppDialog", handler);
  }, []);

  // WelcomeScreen's 4 CTAs — see e.detail.action. Uses a ref for the same
  // reason the old openMainMenu listener did: the underlying handlers
  // (ShowGuidesOrGuide, _clearGuide) close over state that changes across
  // renders.
  const welcomeScreenActionRef = useRef(null);
  useEffect(() => {
    welcomeScreenActionRef.current = (action) => {
      dispatch(slice1Actions.setShowWelcomeScreen({ value: false }));
      if (action === "featured") {
        // Mobile's Library tab shows the inline "Guides" view (ShowGuidesOrGuide);
        // desktop's Library button opens the GuideDownload modal instead — match
        // whichever one is the real Library entry point for the current layout.
        if (MobileMode) ShowGuidesOrGuide("Guides", "Featured");
        else {
          setGuideDownloadInitialType("Featured");
          setGuideDownloadType("read");
          setGuideDownloadMode("download");
          setGuideDownloadShow(true);
        }
      }
      else if (action === "blank") {
        _clearGuide();
        setBuildMyTripWizardShow(true);
      }
      else if (action === "blank-manual") {
        // Tapped before the sample guide finished loading there's no guide to
        // clear yet — start a fresh local one instead (2026-10-25).
        if (window.guide_obj) _clearGuide();
        else { window.__guideLoadGen = (window.__guideLoadGen || 0) + 1; createLocalGuide("New Guide", () => {}); }
      }
      // "signin" is dispatched as openLoginModal directly by WelcomeScreen, not routed through here.
    };
  });
  useEffect(() => {
    const handler = (e) => {
      if (welcomeScreenActionRef.current) welcomeScreenActionRef.current(e?.detail?.action);
    };
    window.addEventListener("welcomeScreenAction", handler);
    return () => window.removeEventListener("welcomeScreenAction", handler);
  }, []);

  const lastLibraryTypeRef = useRef(null);
  useEffect(() => {
    if (GuidesOrPlaces === "Guides" && GuideType && GuideType !== "None") {
      lastLibraryTypeRef.current = GuideType;
    }
  }, [GuidesOrPlaces, GuideType]);
  window.loadGuide = loadGuide;
  function loadGuide(guide_info_id, afterLoad) {
    //const guide_info_id = "wHvagurBLMmZ6zt4Cw6z"; // Imperia
    //const guide_info_id = "IQrZiedo7oJWa9GgLR6L"; // Florence
    afterGuideLoadRef.current = afterLoad ?? null;
    window.record_last_guide_read = true;
    dispatch(slice1Actions.SetLoadingGuide({ value: true }));
    setTimeout(timeoutFunc, 5000);
    // A load that finishes after the user has already moved on (e.g. the
    // welcome screen's sample guide, still loading when "Start with a Blank
    // Guide" is tapped) is dropped — it used to replace the blank guide
    // (2026-10-25). _clearGuide and every newer load bump the generation.
    const gen = (window.__guideLoadGen = (window.__guideLoadGen || 0) + 1);
    DataBase.readGuideTransaction(guide_info_id, (res) => {
      if (window.__guideLoadGen !== gen) return;
      readGuideDataReturnNew(res);
    }, user_info.uid);
  }

  const timeoutFunc = () => {
    dispatch(slice1Actions.SetLoadingGuide({ value: false }));
  };

  const setGuideSortOption = (value) => {
    dispatch(slice1Actions.setGuideSortOption({ value: value }));
  };

  const readGuideDataReturnNew = (res) => {
    let GuideObj = null;
    if (res.pass === true) {
      GuideObj = new Guide(res.guide_id);
      const guide_json = res.res.data;
      console.log(`Guide Size is: ${guide_json.length}`);
      var guide_obj = JSON.parse(guide_json);
      const decoded = GuideObj.decodeGuideFb(guide_obj, res.infoDoc);
      if (decoded === true) {
        GuideObj.schedule.getPlaces_InSchedule();
        window.guide_obj = GuideObj;
        dispatch(
          slice1Actions.setGuide({
            guide: "new",
            guide_meta: { guide_info: res.infoDoc, guide_info_id: res.guide_info_id, guide_id: res.guide_id },
          })
        );
        dispatch(slice1Actions.setCreatorInfo({ value: res.creator_info }));
        dispatch(slice1Actions.setOwnerInfo({ value: res.owner_info }));
        dispatch(slice1Actions.pushGuideStack({ value: res.guide_info_id }));
        dispatch(slice1Actions.addViewedGuide({ id: res.guide_info_id, data: res.infoDoc }));
        dispatch(slice1Actions.setGuidesOrPlaces({ value: "Places", GuideType: "None" }));
        setTimeout(fitPlaces, 1000);
        // user_info (the Redux-selected value), not user_info_retrieved — the
        // latter is a plain `let` re-declared to null on every render of this
        // function component, only ever reassigned by findUserByUIDCallback
        // on the initial auth-state-change render. Any much-later call into
        // this same readGuideDataReturnNew closure (e.g. "View Latest
        // Version", clicked long after mount) was hitting this line with
        // user_info_retrieved still null, throwing "Cannot read properties
        // of null (reading 'uid')" — which, since this was a synchronous
        // throw inside the readGuideTransaction promise chain's .then(),
        // got silently swallowed by that chain's own .catch() (logged as
        // "readGuideTransaction failed") and aborted the rest of this
        // function, including the final afterGuideLoadRef callback a few
        // lines down. The guide itself had already loaded correctly by this
        // point (dispatch(setGuide) above already ran) — only this
        // analytics check and everything after it in the function never
        // ran. Found 2026-10-03 via "View Latest Version worked but no
        // banner showed" + explicit debug logging.
        if (window.record_last_guide_read === true && user_info.uid !== "guest") {
          window.record_last_guide_read = false;
          recordLastGuideRead(res.guide_info_id);
        }
        console.log("Guide read");
        // dispatch(slice1Actions.setGuideInfo({ value: res.infoDoc }));
        // dispatch(slice1Actions.setAuthorization({ guide_info: res.infoDoc, uid: user_info.uid }));
        //dispatch(slice1Actions.setOwnerInfo({ value: res.user_info }));
        //console.log(res.owner_info);
      } else {
        console.log("decode failed");
      }
    } else {
      //console.log(res.res);
    }
    window.record_last_guide_read = false;
    if (window.guide_obj) {
      const _gs = window.guide_obj.guide_settings;
      const _isMosaic = _gs.itinerary.directions === false && _gs.itinerary.info === false && _gs.itinerary.photo === true && _gs.itinerary.place_menu === false;
      if (_isMosaic && user_info.uid !== "guest") {
        dispatch(slice1Actions.clearHTMLStack())
        setTimeout(() => updateHomePage(window.guide_obj.guide_settings), 500);
      }
    }
    dispatch(slice1Actions.SetLoadingGuide({ value: false }));
    if (afterGuideLoadRef.current) {
      const cb = afterGuideLoadRef.current;
      afterGuideLoadRef.current = null;
      // success arg added for "View Latest Version" (see
      // purring-humming-mountain plan), which needs to know the load
      // actually succeeded before flipping on PreviewingConflictSnapshot —
      // every existing afterLoad caller ignores extra args, so this is
      // purely additive.
      setTimeout(() => cb(res.pass === true), 300);
    }
  };
  const fitPlaces = (user) => {
    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
  };
  const onAuthStateChanged = (user) => {
    console.log("onAuthStateChanged", user);
    if (user) {
      // A real sign-in — whether from WelcomeScreen's own button, the
      // sample-guide banner, or TripAI's inline link — means the welcome
      // gate no longer applies, regardless of which of those triggered it.
      dispatch(slice1Actions.setShowWelcomeScreen({ value: false }));
      lastAuthUid = user.uid;
      User.findUserByUID(user.uid, findUserByUIDCallback);
    } else {
      // Signed out (or a cold start as a guest): the next sign-in may open
      // that person's own last guide again (4.10.55, 2026-10-26) — before,
      // a second account signing in on the same device stayed on the sample.
      guide_loaded = false;
      const parsed = queryString.parse(window.location.search);
      console.log("*********parsed2", parsed);
      let guide_to_load = SAMPLE_GUIDE_ID;
      if (typeof parsed.id != "undefined") guide_to_load = parsed.id;
      // No explicit ?id= (not a shared link) means this is a cold-start visitor —
      // gate the render tree behind WelcomeScreen while the sample guide loads
      // in the background, so there's an intentional first action instead of
      // silently dropping them into someone else's content. A Trip Builder link (?build=, App.js) skips it:
      // that visitor's first action is Build My Trip, which opens on its own (2026-10-30); so does a
      // "Continue in the app" link (?plan=, App.js): its trip opens as a new guide (2026-11-01).
      else if (typeof parsed.build == "undefined" && typeof parsed.plan == "undefined") dispatch(slice1Actions.setShowWelcomeScreen({ value: true }));
      loadGuide(guide_to_load);

      if (typeof parsed.no_ads != "undefined" || window.self !== window.top)
        dispatch(slice1Actions.setNoAds({ value: true }));

      if (typeof parsed.featured_guides != "undefined") setTimeout(() => ShowGuidesOrGuide("Guides", "Featured"), 7000);
      else if (typeof parsed.my_guides != "undefined") setTimeout(() => ShowGuidesOrGuide("Guides", "Mine"), 7000);
      // else {
      //   if (typeof parsed.id != "undefined") guide_to_load = parsed.id;
      //   loadGuide(guide_to_load);
      // }
    }
  };

  let user_info_retrieved = null;
  let guide_loaded = false;
  let user_doc_id = null;
  let lastAuthUid = null;
  let findUserByUIDRetried = false;

  // Captured here (outer scope) since findUserByUIDCallback below declares
  // its own local `user_info` that shadows this one for its whole body.
  const wasGuestOrNullBeforeSignIn = user_info.uid == null || user_info.uid === "guest";

  const findUserByUIDCallback = async (res) => {
    console.log("findUserByUIDCallback", res);
    // A brand-new account (just registered) can have its Firestore user doc
    // momentarily miss this find-by-uid query — the account is genuinely
    // signed in, just the doc lookup raced the write. Retry once before
    // giving up, rather than silently leaving user_info/Authorization
    // exactly as they were pre-sign-in (this used to just no-op here).
    if (res.pass !== true) {
      if (!findUserByUIDRetried && lastAuthUid) {
        findUserByUIDRetried = true;
        const uid = lastAuthUid;
        setTimeout(() => User.findUserByUID(uid, findUserByUIDCallback), 1200);
      }
      return;
    }
    findUserByUIDRetried = false;
    if (res.pass === true) {
      const user_info = res.res;
      // A guest generated a trip in-memory (new guide or edits to the sample
      // guide) before signing in — give it a real cloud home under this
      // account instead of discarding it in favor of the account's own last
      // guide.
      if (window.guest_generated_unsaved_trip === true && !guide_loaded) {
        guide_loaded = true;
        window.guest_generated_unsaved_trip = false;
        user_info_retrieved = user_info;
        dispatch(slice1Actions.setUserInfo({ value: user_info }));
        dispatch(slice1Actions.setUserInfoId({ value: res.doc_id }));
        if (wasGuestOrNullBeforeSignIn && user_info.uid != null && user_info.uid !== "guest") {
          logAnalyticsEvent("login", { uid: user_info.uid });
        }
        user_doc_id = res.doc_id;
        DataBase.persistLocalGuide(window.guide_obj, user_info, (res2) => {
          if (res2.pass === true) readGuideDataReturnNew(res2);
          else load_default_gide();
        });
        return;
      }
      user_info_retrieved = user_info;
      dispatch(slice1Actions.setUserInfo({ value: user_info }));
      dispatch(slice1Actions.setUserInfoId({ value: res.doc_id }));
      if (wasGuestOrNullBeforeSignIn && user_info.uid != null && user_info.uid !== "guest") {
        logAnalyticsEvent("login", { uid: user_info.uid });
      }
      user_doc_id = res.doc_id;
      console.log("findUserByUIDCallback", user_info.last_guide_id);
      // Only replaces the sample guide (or nothing yet): a guide a guest
      // opened before signing in stays open.
      const openId = store.getState().guide_meta?.guide_info_id;
      const showingSample = openId == null || openId === SAMPLE_GUIDE_ID;
      if (!showingSample) guide_loaded = true;
      if (user_info.last_guide_id !== "" && !guide_loaded) {
        guide_loaded = true;
        DataBase.doesGuideInfoExist(user_info.last_guide_id, doesGuideInfoExistCallback);
        return;
      }
      else if(!guide_loaded) load_default_gide();
    }
  };

  const load_default_gide = () => {
    let guide_to_load = SAMPLE_GUIDE_ID;
    loadGuide(guide_to_load);
  };


  const doesGuideInfoExistCallback = (res) => {
    let guide_to_load = SAMPLE_GUIDE_ID;
    //console.log("doesGuideInfoExistCallback", user_info.last_guide_id);
    if (res.pass === true) {
      guide_to_load = user_info_retrieved.last_guide_id;
    }
    const parsed = queryString.parse(window.location.search);
    console.log("*********parsed3", parsed);
    if (typeof parsed.id != "undefined") guide_to_load = parsed.id;
    loadGuide(guide_to_load);
    if (typeof parsed.no_ads != "undefined" || window.self !== window.top)
      dispatch(slice1Actions.setNoAds({ value: true }));
    if (typeof parsed.featured_guides != "undefined") setTimeout(() => ShowGuidesOrGuide("Guides", "Featured"), 7000);
    else if (typeof parsed.my_guides != "undefined") setTimeout(() => ShowGuidesOrGuide("Guides", "Mine"), 7000);
    // else {
    //   if (typeof parsed.id != "undefined") guide_to_load = parsed.id;
    //   loadGuide(guide_to_load);
    // }
  };

  const purchaseTickets = () => {
    window.open("/Docs/Tickets.html", "_blank");
  };

  const goBack = () => {
    //console.log("handleLeftArrow", HTMLStack.length);
    if (htmlStackLength <= 1) {
      dispatch(slice1Actions.clearHTMLStack());
      //dispatch(slice1Actions.setShowHTMLReader({ value: false }));
      return;
    }
    const htmlString = HTMLStack[htmlStackLength - 2];
    dispatch(slice1Actions.popHTMLStack());
    dispatch(slice1Actions.setHomeScreen({ value: htmlString }));
  };

  const DisplayHomeScreen = () => {
    console.log("DisplayHomeScreen");
    //dispatch(slice1Actions.resetHomeScreen({ value: null }));
    dispatch(slice1Actions.setCurrentAppScreen({ value: "Home" }));
    let html = window.guide_obj.document;
    if(GuideFormat === "Photo Mosaic")
       html = window.guide_obj.createHTMLItinerary("Main", GuideSettings.itinerary, { ...user_info, showHiddenPlaces: ShowHiddenPlaces }, GuideSettings);
      //////5/25////
    //window.guide_obj.document = html;
    /////////
    dispatch(slice1Actions.clearHTMLStack());
    //dispatch(slice1Actions.popHTMLStack());
    dispatch(slice1Actions.setHomeScreen({ value: html }));
    
    // {
    //   const html = window.guide_obj.createHTMLItinerary("Main", null);
    //   window.guide_obj.document = html
    // }

    // if (HTMLStack.length < 1) {
    //   //dispatch(slice1Actions.clearHTMLStack());
    //   return;
    // }
    // const htmlString = HTMLStack[0];
    // dispatch(slice1Actions.clearHTMLStack());
    // // dispatch(slice1Actions.setHTMLStack({ value: [htmlString] }));
    // dispatch(slice1Actions.setHomeScreen({ value: htmlString }));
  };

  const HTMLEdit = () => {
    // if(GuideFormat === "Photo Mosaic")
    //   myAlert("In Photo Mosaic mode, this content is not displayed", "Message");
    setEditNotesMode(false);
    let html = window.guide_obj.document;
    if (html === null || html === "" || html === "<!-- Comment -->") {
      html = window.guide_obj.createGuideHTML();
    }
    setHTMLEditorModalContent(html);
    setHTMLEditorModalCallback(HTMLEditCallback);

    setHTMLEditorModal(true);
  };
  
  const HTMLEditCallback = (html) => {
    if(html === null || typeof html === "undefined") return;
    if(EditNotesMode === false){
      console.log("HTMLEditCallback");
      window.guide_obj.document = html;
      dispatch(slice1Actions.clearHTMLStack());
      //dispatch(slice1Actions.popHTMLStack());
      dispatch(slice1Actions.setHomeScreen({ value: html }));
      return;
    }
    EditNotesCallback(html);
  };
  
  const EditNotes = () => {
    setEditNotesMode(true);
    let section = GetNotesSection();
    if(section === null){
      myAlert("Could not find Guide Notes", "Message");
      return;
    }

    let html = section.html;
    if (html === null || html === "" || html === "<!-- Comment -->") {
      html = window.guide_obj.createGuideHTML();
    }
    setHTMLEditorModalContent(html);
    setHTMLEditorModalCallback(EditNotesCallback);
    
    setHTMLEditorModal(true);
  };
  
  const EditNotesCallback = (html) => {
    console.log("EditNotesCallback");
    if(html === null || typeof html === "undefined") return;
    let section = GetNotesSection();
    if(section === null){
      myAlert("Could not find Guide Notes", "Message");
      return;
    }
    section.html = html;
    //////5/25////
    //window.guide_obj.document = html;
    ////////
    dispatch(slice1Actions.clearHTMLStack());
    //dispatch(slice1Actions.popHTMLStack());
    dispatch(slice1Actions.setHomeScreen({ value: html }));
  };

  const ViewHomeContent = () => {
    let html = window.guide_obj.document;
    if (html === null)
       html = ""; 
    
    dispatch(slice1Actions.clearHTMLStack());
    //dispatch(slice1Actions.popHTMLStack());
    dispatch(slice1Actions.setHomeScreen({ value: html }));
  };
    
  const ViewGuideNotes = () => {
    let section = GetNotesSection();
    if(section === null){
      myAlert("Could not find Guide Notes", "Message");
      return;
    }

    let html = section.html;
    if (html === null)
       html = ""; 
    
    dispatch(slice1Actions.clearHTMLStack());
    //dispatch(slice1Actions.popHTMLStack());
    dispatch(slice1Actions.setHomeScreen({ value: html }));
  };

  const GetNotesSection = () => {
    let section = null;
    for(let c = 0; c < window.guide_obj.chapters.length; c++){
      if(window.guide_obj.chapters[c].Title === "My notes"){
        for(let s = 0; s < window.guide_obj.chapters[c].sections.length; s++){
          if(window.guide_obj.chapters[c].sections[s].Title === "Notes1"){
            section = window.guide_obj.chapters[c].sections[s];
            break;
          }
        }
        if(section !== null) break;
      }
    }

    if(section === null){
      let new_chapter = null;
      const index = window.guide_obj.chapters.findIndex((x) => x.Title === "My notes");
      if (index === -1)
        new_chapter = window.guide_obj.addChapter("My notes");
      let new_section = new Section(window.guide_obj.chapters, "Notes1");
      const index2 = window.guide_obj.addSection(new_chapter.ID, new_section);
      if (index2 === -1) section = null;
      else section = new_section;
    }
    return section
  };

  const FormatHomePageCallbackDelayed = (format) => {
    //console.log("format", format[0].name);
    const places = window.guide_obj.places.getPlacesToDisplay(null);
    dispatch(slice1Actions.setMultiselectCallback({ value: selectPlacesCallBack }));
    dispatch(slice1Actions.setMultiselectItems({ value: places }));
    dispatch(slice1Actions.setMultiselectSelectedItems({ value: places }));
    dispatch(slice1Actions.setMultiselectMode({ value: "multi" }));
    dispatch(slice1Actions.setMultiselectSearchText({ value: "" }));
    dispatch(slice1Actions.setMultiselectTitle({ value: "Select Places" }));
    dispatch(slice1Actions.setShowMultiselect({ value: true }));
    // setMultiselectItems(places);
    // setMultiselectSelectedItems(places);
    // setMultiselectMode("multi");
    // setMultiselectTitle(`Select Zoom`);
    // setShowMultiselect(true);
    // setMultiselectCallback(selectPlacesCallBack);
  };

  const selectPlacesCallBack = (Places) => {
    if(Places.length === 0) return;
    console.log("selectPlacesCallBack", Places)
    if (Places == null) return;
    let main_page = "";
    let gs = JSON.parse(JSON.stringify(GuideSettings));
    if(GuideFormat === "Photo Mosaic"){
      gs.itinerary.directions = false;
      gs.itinerary.info = false; 
      gs.itinerary.photo = true;
      gs.itinerary.place_menu = false;
      dispatch(slice1Actions.setGuideSettings({ value: gs }));
      Places.sort((a, b) => (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1));
      Places.forEach((place_id) => {
        const place = window.guide_obj.places.getPlace(place_id.value);
        if(place !== null) 
            main_page += `<a href="maplink:${place.ID}||"><button style="border: none; background: none; border-radius: 10%; font-size: 70%; padding: 5px; background-size: cover;"> <img style="border-radius: 10%;" referrerpolicy="no-referrer" src="${Common.getImageURL(place.Photo_m || place.Photo, null, false) || 'https://andiamotravelapp.com/Images/App/IllustratedImage.jpg'}" data-photo="${place.Photo || ''}" onerror="window.imgFallback(this)" width="100" height="125" /><br />${place.Name}</button></a>`;
      });
      // dispatch(slice1Actions.setHideHome({ value: !HideHome }));
    }
    else 
    {
      if(GuideFormat === "User Content") {
        gs.itinerary.directions = true;
        gs.itinerary.info = true; 
        gs.itinerary.photo = true;
        gs.itinerary.place_menu = true;
      }
    }
    dispatch(slice1Actions.setGuideSettings({ value: gs }));
    // HTMLEditCallback(main_page)
    setTimeout(() => {
      updateHomePage(gs)
    }, 500);

    return;
  }

  const updateHomePage = (gs) => {
    let it = gs.itinerary;
    let htmlString =  window.guide_obj.document;
    if(it.directions === false && it.info === false && it.photo === true && it.place_menu === false && user_info.uid !== "guest")
      htmlString = window.guide_obj.createHTMLItinerary("Main", gs.itinerary, { ...user_info, showHiddenPlaces: ShowHiddenPlaces }, GuideSettings);
    dispatch(slice1Actions.setHTMLTitle({ value: "Itinerary" }));
    dispatch(slice1Actions.setHTMLToSHow({ value: htmlString }));
    dispatch(slice1Actions.setShowHTMLReader({ value: true }));
    dispatch(slice1Actions.resetHTMLScreen());
    
    
    // window.location.href = "#home-start";
    // var homeDiv = document.getElementById("home-content-start");
    // if (MobileMode) dispatch(slice1Actions.setCurrentAppScreen({ value: "Home" }));
    // else homeDiv.scrollIntoView();

  }

  // const updateHomePage2 = (gs) => {
  //   const htmlString = window.guide_obj.createHTMLItinerary("Main", gs.itinerary);

  //   dispatch(slice1Actions.setHTMLTitle({ value: "Itinerary" }));
  //   dispatch(slice1Actions.setHTMLToSHow({ value: htmlString }));
  //   dispatch(slice1Actions.setShowHTMLReader({ value: true }));
  //   window.location.href = "#home-start";
  //   var homeDiv = document.getElementById("home-content-start");
  //   if (MobileMode) dispatch(slice1Actions.setCurrentAppScreen({ value: "Home" }));
  //   else homeDiv.scrollIntoView();
  // }

  const formatPlacesInSchedule = () => {
    // const AllScheduledPlaces = window.guide_obj.getAllScheduledPlaces(ScheduleName);
    // let places = [];
    // for (let m = 0; m < AllScheduledPlaces.length; m++) {
    //   places.push({
    //     value: AllScheduledPlaces[m].ID,
    //     name: AllScheduledPlaces[m].Name,
    //   })
    // }
    // selectPlacesCallBack(places);
  }

  const ImageUpload = () => {
    if (Authorization === AUTHORIZATION_LEVEL.GUEST) {
      myAlert("Cannot upload images in guest mode. You must be registered and logged in", "Message");
      return;
    }
    setImageDialogMode("upload");
    setImageDialogExif(false);
    setImageDialogShow(true);
  };

  const ImageDialogCallback = (res, folderName, searchText) => {
    console.log("ImageDialogCallback", res);
    if (ImageDialogMode !== "select") return;
    if (ImageDialogWeb) {
      // Ask which group the new places go in: by default one named after
      // the search (2026-10-22); no group is also allowed.
      askWebPlacesGroup((res || []).map(_placeFromWebPhoto), "photo", searchText);
    }
    else updateImageCallBack(res, folderName);
  };

  const myAlert = (message, title, buttons) => {
    setAlertModalMessage(message);
    setAlertModalTitle(title == null ? "Notice" : title);
    setAlertModalButtons(buttons == null ? [{ Title: "OK", Method: null }] : buttons);
    setAlertModalShow(true);
  };

  const myConfirm = (message, buttons) => {
    setAlertModalTitle("Confirmation");
    setAlertModalMessage(message);
    setAlertModalButtons(buttons);
    setAlertModalShow(true);
  };

  const ViewMenu = () => {
    const menuList = [
      {
        label: "View My Guides",
        method: () => ShowGuidesOrGuide("Guides", "Mine"),
        icon: <FontAwesomeIcon icon={solid("book-open-reader")} />,
        visible: MobileMode,
        info: "View guides owned by you",
      },
      {
        label: "View Featured Guides",
        method: () => ShowGuidesOrGuide("Guides", "Featured"),
        icon: <FontAwesomeIcon icon={solid("book-open-reader")} />,
        visible: MobileMode,
        info: "View ready made guides from Andiamo Places",
      },
      {
        label: "View Shared Guides",
        method: () => ShowGuidesOrGuide("Guides", "Shared"),
        icon: <FontAwesomeIcon icon={solid("book-open-reader")} />,
        visible: MobileMode,
        info: "View guides shared by community",
      },
    ];
    setMenuModalList(menuList);
    setMenuModalHeading("Library Menu");
    setMenuModalImage(<FontAwesomeIcon icon={solid("eye")} />);
    setMenuModalPlace(null);
    setMenuModalShow(true);
  };

  const setSizeMapToFit = () => {
    dispatch(slice1Actions.setSizeMapToFit({ value: !SizeMapToFit }));
  };

  const ViewSubMenu = () => {
    const menuList = [
      {
        label: "View Home Content",
        method: () => ViewHomeContent(),
        icon: <FontAwesomeIcon icon={solid("book-open-reader")} />,
        visible: true,
        info: "View home content",
      },
      {
        label: "View My Notes",
        method: () => ViewGuideNotes(),
        icon: <FontAwesomeIcon icon={solid("book-open-reader")} />,
        visible: true,
        info: "View guide notes",
        videoKey: "edit-itinerary-and-notes",
      },
      {
        label: "View My Guides",
        method: () => ShowGuidesOrGuide("Guides", "Mine"),
        icon: <FontAwesomeIcon icon={solid("book-open-reader")} />,
        visible: !MobileMode && (GuidesOrPlaces === "Places" || GuideType !== "Mine"),
        info: "View guides owned by you",
      },
      {
        label: "View Featured Guides",
        method: () => ShowGuidesOrGuide("Guides", "Featured"),
        icon: <FontAwesomeIcon icon={solid("book-open-reader")} />,
        visible: !MobileMode && (GuidesOrPlaces === "Places" || GuideType !== "Featured"),
        info: "View ready made guides from Andiamo Places",
      },
      {
        label: "View Shared Guides",
        method: () => ShowGuidesOrGuide("Guides", "Shared"),
        icon: <FontAwesomeIcon icon={solid("book-open-reader")} />,
        visible: !MobileMode && (GuidesOrPlaces === "Places" || GuideType !== "Shared"),
        info: "View guides shared by community",
      },
      {
        // Hidden 2026-10-19: the desktop side menu's Library → "Current
        // Guide" does this; mobile mode has its own Library/Trip tabs.
        label: "View Current Guide",
        method: () => ShowGuidesOrGuide("Places", "Featured"),
        icon: <FontAwesomeIcon icon={solid("book-open")} />,
        visible: false,
        info: "View the current guide places",
      },
      {
        label: `${HidePlaces === true ? "View" : "Hide"} list of ${GuidesOrPlaces === "Places" ? "Places" : "Guides"}`,
        method: () => dispatch(slice1Actions.setHidePlaces({ value: !HidePlaces })),
        icon: null,
        visible: !MobileMode,
        info: "View a list of the places or guides",
      },
      {
        label: `${HideSchedule === true ? "View" : "Hide"} Schedule`,
        method: () => dispatch(slice1Actions.setHideSchedule({ value: !HideSchedule })),
        icon: null,
        visible: !MobileMode && GuidesOrPlaces === "Places",
        info: "View the schedules for the current guide",
      },
      {
        label: `${HideHome === true ? "View" : "Hide"} Home`,
        method: () => showHome(),
        icon: null,
        visible: !MobileMode,
        info: "Display the Home screen that has html content",
      },
      {
        label: `${HideMap === true ? "View" : "Hide"} Map`,
        method: () => showMap(),
        icon: null,
        visible: !MobileMode,
        info: "Display the places or guides in a map at the bottom",
      },
      {
        label: `${HideSideMenu === true ? "View" : "Hide"} Side Menu`,
        method: () => showSideMenu(),
        icon: null,
        visible: !MobileMode,
        info: "Display the vertical menu on the left side",
      },
    ];
    setMenuModalList(menuList);
    setMenuModalHeading("View Menu");
    setMenuModalImage(<FontAwesomeIcon icon={solid("eye")} />);
    setMenuModalPlace(null);
    setMenuModalShow(true);
  };

  const GuideStyleMenu = () => {
    const menuList = [
      {
        label: "Build Trip with AI",
        method: () => GuideFromAI(),
        icon: null,
        visible: true,
        info: "Use artificial intelligence to automatically create a trip",
      },
      {
        label: "Create Paths w/AI",
        method: () => WalksFromAI(),
        icon: null,
        visible: true,
        info: "Use artificial intelligence to generate walking tours with paths and points of interest",
        videoKey: "walks-and-paths",
      },
      {
        label: "Create Journal from Photos",
        method: CreateJournalFromPhotos,
        icon: null,
        visible: true,
        info: "Create guide content from photos that have location and date info — choose a new/current/replaced guide and schedule, then optionally identify each place by name. You can also start from free photos from the web or Wikipedia articles.",
        videoKey: "create-journal-from-photos",
      },
      {
        label: "Travel Wizard",
        method: () => setAiDialogShow(true),
        icon: null,
        visible: true,
        info: "Ask the AI any travel question — packing, best time to visit, getting around, food, budgets — or start from a sample question. Uses your trip's destination and dates.",
      },
      {
        label: "Auto Size Map",
        method: setSizeMapToFit,
        icon: null,
        visible: !MobileMode,
        info: "Automatically size the map to fit all places",
      },
    ];
    setMenuModalList(menuList);
    setMenuModalHeading("Guide Style");
    setMenuModalImage(<FontAwesomeIcon icon={solid("wand-magic-sparkles")} />);
    setMenuModalPlace(null);
    setMenuModalShow(true);
  };

  const UserMenu = () => {
    const menuList = [
      {
        label: "Sign Out",
        method: logout,
        icon: null,
        visible: user_info.uid !== null && user_info.uid !== "guest" && Authorization !== AUTHORIZATION_LEVEL.GUEST,
        info: "Log out from this app",
      },
      {
        label: "Reset Password",
        method: resetPassword,
        icon: null,
        visible: true,
        info: "Reset the password. An email will be sent to allow you to reset the password.",
      },
      {
        label: "User Details",
        method: showUserInfoModal,
        icon: null,
        visible: true,
        info: "Display the details of the logged in user, e.g. name, id etc.",
      },
      {
        label: "Settings",
        method: showSettingsDialog,
        icon: null,
        visible: true,
        info: "Change the settings for this app. Works as a guest — changes are kept on this device; sign in and save again to add them to your account.",
      },
      {
        label: "Sign In",
        method: showLogin,
        icon: null,
        visible: user_info.uid === null || user_info.uid === "guest" || Authorization === AUTHORIZATION_LEVEL.GUEST,
        info: "Login to this app. Note: you need to be logged in to: save changes, copy guide, create a guide, rate a guide or change settings",
      },
      {
        label: "Register",
        method: Register,
        icon: null,
        visible: user_info.uid === null || user_info.uid === "guest" || Authorization === AUTHORIZATION_LEVEL.GUEST,
        info: "Register for the app. Note that you need to register before you can log in and it's free of charge.",
      },
      {
        label: "Upload Images",
        method: ImageUpload,
        icon: null,
        visible: true,
        info: "This will allow you to upload your own images for including in guides",
        videoKey: "upload-images",
      },
      {
        label: "Partner Offers",
        // Must call synchronously, not via setTimeout — purchaseTickets() now
        // does a real window.open(), which browsers only allow within the
        // direct call stack of a user gesture. Deferring it even by a few ms
        // makes the popup blocker silently swallow it.
        method: purchaseTickets,
        icon: null,
        visible: true,
        info: "View partner offers including tickets and travel deals",
      },
    ];
    setMenuModalList(menuList);
    setMenuModalHeading("User Menu");
    setMenuModalImage(<FontAwesomeIcon icon={solid("user")} />);
    setMenuModalPlace(null);
    setMenuModalShow(true);
  };

  const Register = () => {
    setLoginModalMode("Register");
    setShowLoginModal(true);
  };

  const showLogin = () => {
    setLoginModalMode("Login");
    setShowLoginModal(true);
  };

  const resetPassword = () => {
    setLoginModalMode("Forgot Password");
    setShowLoginModal(true);
  };

  const logout = () => {
    setAlertModalTitle("Confirmation");
    setAlertModalMessage("Do you want to log out?" + signOutWarning());
    setAlertModalButtons([
      { Title: "YES", Method: _logout },
      { Title: "NO", Method: _logout },
    ]);
    setAlertModalShow(true);
  };

  const _logout = (resp) => {
    if (resp !== "YES") return;
    setActivityIndicator(true);
    DataBase.Logout(logoutCallback);
  };

  const logoutCallback = (res) => {
    //console.log(res);
    setActivityIndicator(false);
    if (res.pass === true) {
      // Prevent any in-flight guide load from recording last-guide for the signed-out user.
      window.record_last_guide_read = false;
      user_info_retrieved = null;
      const user_info = {
        distance_unit: "kilometers",
        date_format: "Month first",
        edit_mode: false,
        email: "guest@gmail.com",
        first_name: "guest",
        last_name: "user",
        uid: "guest",
        create_date: "",
        modify_date: "",
        travel_payouts_marker: "",
      };
      dispatch(slice1Actions.setUserInfo({ value: user_info }));
      dispatch(slice1Actions.setUserInfoId({ value: null }));
      //dispatch(slice1Actions.setAuthorization({ guide_info: guide_info, uid: user_info.uid }));
    }
  };

  const showSettingsDialog = () => {
    setSettingsDialogShow(true);
  };

  // Guests have no account to persist to — apply the change locally (same
  // as a signed-in save) and skip only the cloud write, matching the RN
  // app's Settings screen. Preferences need to work for guests too, not
  // just registered users.
  const SettingsDialogCallback = (new_user_info) => {
    dispatch(slice1Actions.setUserInfo({ value: new_user_info }));
    dispatch(slice1Actions.setGuide({ guide: null }));
    if (user_info?.uid == null || user_info?.uid === "guest") return;
    DataBase.updateUser(new_user_info, user_info.uid, () => {});
  };

  // Advanced Mode discovery hint ("N more options in Advanced Mode") used to
  // open the full Settings dialog just to flip one toggle — the RN app
  // switched this to a direct one-tap toggle (still cloud-syncing only when
  // signed in), which is a better UX for everyone and, unlike the Settings
  // dialog route, works for guests too. Mirrored here for parity.
  const toggleAdvancedMode = () => {
    const newValue = user_info?.advanced_mode === "On" ? "Off" : "On";
    const updated = { ...user_info, advanced_mode: newValue };
    dispatch(slice1Actions.setUserInfo({ value: updated }));
    if (user_info?.uid == null || user_info?.uid === "guest") return;
    DataBase.updateUser(updated, user_info.uid, () => {});
  };

  const GuideMenu = () => {
    const buildMenuList = (advancedMode) => [
      {
        label: "Guide Settings",
        method: setGuideSettings,
        icon: null,
        visible: true,
        info: "Interaction Behavior (Default/Custom click & map-hover handling), Guide Mode (Mosaic/Custom), and other guide-wide settings.",
        videoKey: "guide-settings",
      },
      {
        label: "Destinations",
        method: () => setShowDestinations(true),
        icon: null,
        visible: GuideEditMode,
        info: "View or edit this guide's destinations — add/remove/reorder, paste as text, derive from the schedule, or import from a confirmation email; independent of Build My Trip/Build Trip with AI",
        videoKey: "destinations-and-preferences",
      },
      {
        label: "Preferences",
        method: () => setShowPreferences(true),
        icon: null,
        visible: GuideEditMode,
        info: "Trip type, focus, activities, budget, pace, transportation, and excursions — used by both Destinations from AI and Build Trip with AI",
        videoKey: "destinations-and-preferences",
      },


      {
        // Hidden 2026-10-19: the desktop side menu's Library → "Current
        // Guide" does this; mobile mode has its own Library/Trip tabs.
        label: "View Current Guide",
        method: () => ShowGuidesOrGuide("Places", "Featured"),
        icon: <FontAwesomeIcon icon={solid("book-open")} />,
        visible: false,
        info: "Switch from the guides list to the current guide's places",
      },
      // {
      //   label: "Display Home Screen",
      //   method: DisplayHomeScreen,
      //   icon: null,
      //   visible: GuidesOrPlaces === "Places",
      //   info: "Remove any HTML overlay and display the home screen",
      // },

      {
        label: "View Itinerary",
        method: () => ViewHomeContent(),
        icon: <FontAwesomeIcon icon={solid("book-open-reader")} />,
        visible: true,
        info: "View home content",
      },
      {
        label: "View My Notes",
        method: () => ViewGuideNotes(),
        icon: <FontAwesomeIcon icon={solid("book-open-reader")} />,
        visible: true,
        info: "View guide notes",
        videoKey: "edit-itinerary-and-notes",
      },

      // {
      //   label: "Clear Guide",
      //   method: clearGuide,
      //   icon: null,
      //   visible: GuidesOrPlaces === "Places",
      //   info: "Clear the current guide content. Save to cloud to make it permanent",
      // },
      {
        label: "Previous Guide",
        method: PreviousGuide,
        icon: null,
        visible: GuideStack.length > 1,
        info: "Go back to the previously loaded guide",
      },
      {
        label: "View Guide Info",
        method: showGuideInfo,
        icon: null,
        visible: true,
        info: "Display the properties of the guide, e.g. name",
      },
      {
        label: `${HidePlaces === true ? "View" : "Hide"} list of ${GuidesOrPlaces === "Places" ? "Places" : "Guides"}`,
        method: () => dispatch(slice1Actions.setHidePlaces({ value: !HidePlaces })),
        icon: null,
        visible: !MobileMode,
        info: "View a list of the places or guides",
      },
      {
        label: `${HideSchedule === true ? "View" : "Hide"} Schedule`,
        method: () => dispatch(slice1Actions.setHideSchedule({ value: !HideSchedule })),
        icon: null,
        visible: !MobileMode && GuidesOrPlaces === "Places",
        info: "View the schedules for the current guide",
      },
      {
        label: `${HideHome === true ? "View" : "Hide"} Home`,
        method: () => showHome(),
        icon: null,
        visible: !MobileMode,
        info: "Display the Home screen that has html content",
      },
      {
        label: `${HideMap === true ? "View" : "Hide"} Map`,
        method: () => showMap(),
        icon: null,
        visible: !MobileMode,
        info: "Display the places or guides in a map at the bottom",
      },
      // {
      //   label: `${HideSideMenu === true ? "View" : "Hide"} Side Menu`,
      //   method: () => showSideMenu(),
      //   icon: null,
      //   visible: !MobileMode,
      //   info: "Display the vertical menu on the left side",
      // },
      // {
      //   label: "Save Guide to Cloud",
      //   method: SaveGuide,
      //   icon: null,
      //   visible: GuidesOrPlaces === "Places",
      //   info: "Save the current guide to the cloud",
      // },
      // {
      //   label: "Save Guide to Device",
      //   method: writeGuideToFile,
      //   icon: null,
      //   visible: GuideEditMode && GuidesOrPlaces === "Places",
      //   info: "Save the guide as a file to your device",
      // },
      // {
      //   label: "New Guide",
      //   method: newGuide,
      //   icon: null,
      //   visible: GuidesOrPlaces === "Places",
      //   info: "Create a new guide and open it",
      // },
      // {
      //   label: "Copy Guide",
      //   method: copyGuide,
      //   icon: null,
      //   visible: GuidesOrPlaces === "Places",
      //   info: "Make a copy of the current guide and open the new guide",
      // },
      // {
      //   label: "Overwrite Guide",
      //   method: overWriteGuide,
      //   icon: null,
      //   visible: GuideEditMode && GuidesOrPlaces === "Places",
      //   info: "Overwrite a selected guide with the contents of the current guide",
      // },
    ];
    let menuList = buildMenuList(advancedMode);
    if (!advancedMode) {
      const hiddenCount = buildMenuList(true).filter((i) => i.visible).length - menuList.filter((i) => i.visible).length;
      if (hiddenCount > 0) {
        menuList = [
          ...menuList,
          {
            label: `Turn on Advanced Mode to see ${hiddenCount} more option${hiddenCount === 1 ? "" : "s"}`,
            method: () => {
              toggleAdvancedMode();
              setTimeout(() => { if (guideMenuRef.current) guideMenuRef.current(); }, 350);
            },
            icon: null,
            visible: true,
            highlight: true,
            info: "Turns on Advanced Mode right away — no account needed.",
          },
        ];
      }
    }
    setMenuModalBackFn(() => MainMenu);
    setMenuModalList(menuList);
    setMenuModalHeading("Guide Menu");
    setMenuModalImage(<FontAwesomeIcon icon={solid("book-open")} />);
    setMenuModalPlace(null);
    setMenuModalShow(true);
  };

  // Trip Discussion, Comments, Polls, Rate this Guide, Trip Members, and
  // Expenses — split out of Guide Menu into their own Main Menu entry,
  // 2026-10-03, since they're all "communicate/collaborate with your travel
  // companions" actions rather than guide-content views. Same
  // buildMenuList/advanced-mode-hint pattern as GuideMenu/ExportShareMenu
  // above.
  const TripCommunicationMenu = () => {
    const buildMenuList = (advancedMode) => [
      {
        label: "Trip Discussion",
        method: () => setShowGuideDiscussion(true),
        icon: null,
        visible: true,
        info: "Discuss the trip as a whole with your collaborators — not tied to any one place or event.",
      },
      {
        label: "Comments",
        videoKey: "comments",
        method: () => setShowCommentsList(true),
        icon: null,
        // Always visible (not gated on comment_count, unlike the banner) —
        // comment_count is a running total only bumped going forward, so a
        // guide with comments that predate that counter would otherwise
        // hide this entirely despite having real comments to show. Opening
        // is cheap either way; the jump-list's own empty state handles
        // "nothing here" gracefully.
        visible: true,
        info: "See every comment left on this guide's places and events, and jump straight to any of them.",
      },
      {
        label: "Polls",
        videoKey: "polls",
        method: () => setShowPolls(true),
        icon: null,
        visible: true,
        info: "Create a quick poll for your travel companions to vote on — e.g. which restaurant, which day to visit somewhere.",
      },
      {
        label: "Trip Members",
        method: () => setShowTripMembers(true),
        icon: null,
        visible: true,
        info: "Keep a record of who's on this trip — a lightweight roster (just names, not app accounts) used to split expenses, plus a running history of who paid/owes what.",
      },
      {
        label: "Expenses",
        videoKey: "expense-tracking",
        method: () => setShowExpenses(true),
        icon: null,
        visible: true,
        info: "Track trip expenses, split costs among trip members by percentage, and see each person's running balance.",
      },
      {
        label: "Rate this Guide",
        method: ReviewGuide,
        icon: null,
        visible: advancedMode,
        info: "Rate the current guide",
      },
      {
        label: "Report this Guide",
        method: openReportGuide,
        icon: null,
        visible: canReportGuide(guide_meta, user_info),
        info: "Report a guide someone else made that has sexual, violent, hateful or spam content. Only the Andiamo team sees reports.",
      },
    ];
    let menuList = buildMenuList(advancedMode);
    if (!advancedMode) {
      const hiddenCount = buildMenuList(true).filter((i) => i.visible).length - menuList.filter((i) => i.visible).length;
      if (hiddenCount > 0) {
        menuList = [
          ...menuList,
          {
            label: `Turn on Advanced Mode to see ${hiddenCount} more option${hiddenCount === 1 ? "" : "s"}`,
            method: () => {
              toggleAdvancedMode();
              setTimeout(() => { if (tripCommunicationMenuRef.current) tripCommunicationMenuRef.current(); }, 350);
            },
            icon: null,
            visible: true,
            highlight: true,
            info: "Turns on Advanced Mode right away — no account needed.",
          },
        ];
      }
    }
    setMenuModalBackFn(() => MainMenu);
    setMenuModalList(menuList);
    setMenuModalHeading("Collaborate");
    setMenuModalImage(<FontAwesomeIcon icon={solid("comments")} />);
    setMenuModalPlace(null);
    setMenuModalShow(true);
  };

  // "Build Trip with AI" (menus, side menu): Build My Trip with the AI source
  // chosen (2026-10-19, Build My Trip stage 4). Was the separate TripAI
  // dialog — kept commented in case we go back:
  //   dispatch(slice1Actions.ClearAllFilters());
  //   setTripAIShow(true);
  const GuideFromAI = () => {
    setBuildMyTripAutoOpenAI(true);
    newGuide();
  }

  const WalksFromAI = () => {
    setMenuModalShow(false);
    setWalkAIShow(true);
  };

  // Opens the native file picker SYNCHRONOUSLY, within the menu item's own
  // click handler — required by newer Chrome versions to count
  // input[type=file].click() as a genuine user gesture. KMLInput.js used to
  // own this (a hidden <input> it clicked itself, after mounting, via a
  // setTimeout) but that click no longer happens synchronously with the
  // original click at all once React has to render/mount the modal first,
  // so Chrome silently ignores it — no error, no dialog, every KML/KMZ/GPX/
  // TCX/CSV/JSON import menu item affected identically. Found 2026-09-27.
  // The already-picked files are handed to KMLInput via presetFiles, which
  // skips its own (now-blocked) picker trigger and processes them directly.
  const openFilePicker = (fileType, accept) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = accept;
    input.multiple = true;
    input.style.display = "none";
    input.onchange = (e) => {
      const files = e.target.files;
      document.body.removeChild(input);
      if (!files || files.length === 0) return; // user cancelled
      setKMLFileType(fileType);
      setKMLPresetFiles(files);
      setKMLInputShow(true);
    };
    document.body.appendChild(input);
    input.click();
  };

  const inputCSVFile = () => openFilePicker("CSV", ".csv");
  const inputKmlFile = () => openFilePicker("KML", ".kml,.kmz,.gpx,.tcx");
  const inputJSONFile = () => openFilePicker("JSON", ".json");

   const getGuideStatistics = () => {
      if (MobileMode) {
        // Narrow-viewport mobile: App.js renders a dedicated full-screen
        // "Wanderlist" panel off this same state — showing the local dialog
        // too would duplicate the GeoChart's "regions_div" id and leave one
        // of the two maps blank.
        dispatch(slice1Actions.setGuidesOrPlaces({ value: "Wanderlist", GuideType: GuideType }));
        return;
      }
      // Desktop: there's no separate Wanderlist panel, so this dialog is
      // the only way to show guide statistics.
      let stats = window.guide_obj.getGuideStatistics();
      setGeoChartsData(stats);
      setGeoChartsShow(true);
   }

  const openWanderlist = () => {
    getGuideStatistics();
  };

  const StarMenu = () => EditMenu();

  const SaveMenu = () => {
    const menuList = [
      {
        label: "Save Guide to Cloud",
        method: SaveGuide,
        icon: null,
        visible: true,
        info: "This will save the changes to the current guide to the cloud",
      },
      {
        label: "New Guide",
        method: newGuide,
        icon: null,
        visible: true,
        info: "This will create a new guide and open the new guide. The new guide name will be 'New Guide'",
        videoKey: "build-my-trip",
      },
      {
        label: "Copy Guide",
        method: copyGuide,
        icon: null,
        visible: true,
        info: "This will make a copy of the current guide and open the new guide. The new guide name will be the current guide name appended with '_C'",
        videoKey: "blank-create-reload-clear-guide",
      },
      {
        label: "Overwrite Guide",
        method: overWriteGuide,
        icon: null,
        visible: GuideEditMode,
        info: "This will overwrite a selected guide with the contents of the current guide. It will preserve the ownership of the overwritten file",
      },
      // {
      //   label: "Write Guide To Device",
      //   method: writeGuideToFile,
      //   icon: null,
      //   visible: user_info.uid === process.env.ADMIN_ID && GuideEditMode && GuidesOrPlaces === "Places",
      //   info: "This will write the guide to the local computer.",
      // },
      // {
      //   label: "Read Guide From Device",
      //   method: readGuideFromFile,
      //   icon: null,
      //   visible: user_info.uid === process.env.ADMIN_ID && GuideEditMode && GuidesOrPlaces === "Places",
      //   info: "This will read the guide from the local computer.",
      // },
      {
        label: "Export Places as KML",
        method: ExportGuideAsKML,
        icon: null,
        visible: true,
        checked: false,
        info: "This will export the places as kml to the local computer.",
        videoKey: "export-places-as-kml",
      },
      {
        label: "Import Places from KML/KMZ/GPX/TCX",
        method: inputKmlFile,
        icon: null,
        visible: true,
        checked: false,
        info: "Read a KML, KMZ, GPX or TCX file and create places from it",
        videoKey: "import-kml-kmz-gpx-and-tcx-files",
      },
    ];
    setMenuModalList(menuList);
    setMenuModalHeading("Read/Write Guide Menu");
    setMenuModalImage(<FontAwesomeIcon icon={solid("book-open")} />);
    setMenuModalPlace(null);
    setMenuModalShow(true);
  };

  // No blanket guest block here — Google Drive (below) never touches app
  // login, so blocking the whole wizard up front stopped guests from ever
  // reaching it. Only the Saved Files path (the app's own cloud storage)
  // actually needs to be signed in, so that check now lives on that path
  // specifically, in _onSelectFromSaved.
  const CreateJournalFromPhotos = () => {
    setPhotoJournalWizardShow(true);
  };

  const _doSelectPhotos = () => {
    // Without this, the dialog opens against whatever source was last
    // picked this session (module-level state in ImageDialog.js), which
    // defaults to "Guide" (the current guide's own already-used photos) on
    // a fresh page load — not the "Saved" cloud photo pool "Create Journal
    // from Photos" actually needs. A guide with no photos yet then shows
    // "No files present" even though real Saved photos exist. Found
    // 2026-10-02.
    forceNextImageDialogSource("Saved");
    setImageDialogWeb(false);
    setImageDialogMode("select");
    setImageDialogExif(true);
    setImageDialogShow(true);
  };

  // ── Create Places from Photos: free web photos / Wikipedia articles ──
  // (2026-10-17) Photos as a way to start a guide, not only trip photos:
  // each picked photo or article becomes its own place, without a map
  // location unless the article has one, its photo keeping the print size
  // and credit (Common/photoCredit.js) for a Photo Book. They go into the
  // same group/schedule choice as the trip photos, unscheduled.
  const _onSelectFromWeb = (options) => {
    _photoJournalResolveGuideTarget(options, () => setTimeout(() => {
      forceNextImageDialogSource("Wikimedia");
      setImageDialogWeb(true);
      setImageDialogMode("select");
      setImageDialogExif(false);
      setImageDialogShow(true);
    }, options.guideTarget === "add" ? 0 : 300));
  };
  const _onSelectFromWikipedia = (options) => {
    _photoJournalResolveGuideTarget(options, () => setTimeout(() => setWikipediaArticlesShow(true), options.guideTarget === "add" ? 0 : 300));
  };

  // An image chooser item (Wikimedia/Flickr) as a new place.
  const _placeFromWebPhoto = (item) => {
    const place = new Place(window.guide_obj.places);
    place.Name = String(item.name || "Photo").replace(/^File:/i, "").replace(/\.(jpe?g|png|gif|webp|tiff?)$/i, "").replace(/_/g, " ").trim() || "Photo";
    place.Photo = item.url || item.url_m || "";
    place.Photo_m = item.url_m || item.url || "";
    applyPhotoExtras(place, item);
    const esc = (t) => String(t).replace(/&/g, "&amp;").replace(/</g, "&lt;");
    place.Info = `<p style="text-align:center;"><img src="${place.Photo_m}" alt="Image" style="width:100%; max-width:700px; height:auto; border-radius:10%" data-photo="${place.Photo}"></img></p>${item.description ? `<p>${esc(item.description)}</p>` : ""}`;
    place.PType = "Icon";
    return place;
  };

  // Adds the places to the guide, with unique names, in one mosaic group
  // named after the search ("fighter aircraft") — or the wizard's group name
  // for web photos — and NOT linked to a schedule: these places aren't
  // scheduled, and a linked schedule makes the mosaic tile filter by it,
  // leaving its page empty. In Mosaic mode the home page then shows a tile
  // per search, each opening a mosaic of its places' photos.
  // kind: "photo" | "article".
  // Web photos and Wikipedia articles (2026-10-22): ask which group the new
  // places go in — by default one named after the search; no group is
  // also allowed. kind: "photo" | "article".
  const askWebPlacesGroup = (places, kind, searchText) => {
    if (!places || places.length === 0) return;
    const opts = journalOptionsRef.current || {};
    const typed = opts.groupName && opts.groupName !== "Photo" ? opts.groupName : "";
    const suggested = String((searchText || "").trim() || typed || (kind === "article" ? "Articles" : "Photos"));
    setWebPhotoGroupChoice({ places, kind, topic: searchText, useGroup: true, name: suggested.charAt(0).toUpperCase() + suggested.slice(1) });
  };

  // groupChoice: { useGroup, name } from the "Add N places" dialog.
  const _addPhotoPlaces = (places, kind, topic, groupChoice) => {
    if (!places || places.length === 0) return;
    _applyPhotoJournalFolderNameFallback(topic);
    // Same picture default as the photos path (2026-10-25): a guide with no
    // picture takes the first new place's.
    const firstPhoto = places.find((p) => p.Photo_m || p.Photo);
    if (!window.guide_obj.attributes.image && firstPhoto) {
      window.guide_obj.attributes.image = firstPhoto.Photo_m || firstPhoto.Photo;
      window.guide_obj.attributes.image_m = firstPhoto.Photo_m || firstPhoto.Photo;
    }
    const opts = journalOptionsRef.current || {};
    const useGroup = !groupChoice || groupChoice.useGroup;
    const raw = String((groupChoice && groupChoice.name) || (kind === "article" ? topic : "") || (opts.groupName && opts.groupName !== "Photo" ? opts.groupName : "") || (kind === "article" ? "Articles" : "Photos")).trim();
    const groupName = raw.charAt(0).toUpperCase() + raw.slice(1);
    let GroupID = null;
    if (useGroup) (window.guide_obj.groups || []).forEach((g) => { if (g.mosaic && !g.schedule && (g.name || "").toLowerCase() === groupName.toLowerCase()) GroupID = g.id; });
    if (useGroup && GroupID === null) {
      GroupID = window.guide_obj.addGroup(groupName);
      const group = new Group();
      group.id = GroupID;
      group.name = groupName;
      group.poi_img = 16;
      group.mosaic = true;
      window.guide_obj.modifyGroup(group, group);
    }
    const used = new Set((window.guide_obj.places.placesList || []).map((p) => (p.Name || "").toLowerCase()));
    let added = 0;
    places.forEach((p) => {
      p.Name = Common.uniquePlaceName(p.Name || "Place", used);
      p.Group = useGroup ? [GroupID] : [];
      if (groupChoice && groupChoice.markVisited) p.Visited = true;
      if (!p.poi_img) p.poi_img = "208";
      if (window.guide_obj.places.addPlace(p) != null) added++;
    });
    // Rebuilds the mosaic too (Mosaic mode only — a custom itinerary is
    // never touched), so the new group's tile shows without reloading.
    UpdateDisplay();
    myAlert(
      `Added ${added} place${added === 1 ? "" : "s"} from ${kind === "article" ? "Wikipedia" : "the photos"}. ` +
        "Places without a map location appear in the Places list — edit one to add a location or put it in your schedule. Print Photo Book uses their photos, with a credits page.",
      "Message"
    );
  };

  // Resolves the "Where should this go?" choice before either entry path
  // proceeds — matches BuildMyTripWizard.js's guideTarget model instead of
  // the old single "Clear and overwrite guide" toggle, which could only
  // ever act on the current guide (no "new guide" option at all). Stashes
  // the full options (including scheduleTarget/groupName) onto
  // journalOptionsRef regardless of guideTarget, so updateImageCallBack can
  // resolve the final schedule name once photos actually arrive.
  // Was createNewGuideForAI (immediate Firestore write, guests blocked) —
  // switched to createLocalGuide, same decision as everywhere else (see its
  // own comment). Photo Journal still builds its own schedule from the
  // photos' dates afterward — this only changes how the guide itself gets
  // created, not the rest of the pipeline. Found/changed 2026-09-28.
  const _photoJournalResolveGuideTarget = (options, onReady) => {
    journalOptionsRef.current = options;
    if (options.guideTarget === "new") {
      myConfirm(
        "This will create a new guide. Save any wanted changes to the current guide first. Continue?",
        [
          { Title: "OK", Method: () => createLocalGuide(options.newGuideName || "New Guide", (success) => { if (success) onReady(); }) },
          { Title: "CANCEL", Method: null },
        ]
      );
      return;
    }
    if (options.guideTarget === "replace") {
      myConfirm(
        "This will clear all places and the schedule in the current guide. Save any wanted changes to this guide first. Continue?",
        [
          { Title: "OK", Method: () => { _clearGuide(); onReady(); } },
          { Title: "CANCEL", Method: null },
        ]
      );
      return;
    }
    onReady();
  };

  // Called by the wizard's "Add from Saved Files" button with the full options object
  const _onSelectFromSaved = (options) => {
    if (Authorization === AUTHORIZATION_LEVEL.GUEST) {
      myAlert("Cannot use Saved Files in guest mode. You must be registered and logged in — try Google Drive instead.", "Message");
      return;
    }
    _photoJournalResolveGuideTarget(options, () => {
      if (options.guideTarget === "add") _doSelectPhotos();
      else setTimeout(_doSelectPhotos, 300);
    });
  };

  const _onSelectFromGDrive = (options, items, folderName) => {
    if (!items) {
      // First call: store options and open the Google Picker
      setGdriveJournalOptions(options);
      setGdriveJournalPickerShow(true);
      return;
    }
    // Second call: files returned from picker
    _photoJournalResolveGuideTarget(options, () => _onSelectFromGDriveItems(items, folderName));
  };

  const _onSelectFromGDriveItems = async (items, folderName) => {
    if (!items.length) return;

    const refreshToken = localStorage.getItem("gdrive_refresh_token");
    let accessToken = null;
    try {
      const r = await fetch(`${API_BASE_URL}/gdrive_refresh.php`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: `refresh_token=${encodeURIComponent(refreshToken)}`,
      });
      const d = await r.json();
      accessToken = d.access_token || null;
    } catch { /* proceed without metadata */ }

    const enriched = await Promise.all(items.map(async (item) => {
      const fileId = item.url.replace("gdrive:", "");
      let exif_data = {};
      if (accessToken) {
        try {
          const res = await fetch(
            `https://www.googleapis.com/drive/v3/files/${fileId}?fields=imageMediaMetadata(location,time)`,
            { headers: { Authorization: `Bearer ${accessToken}` } }
          );
          const meta = await res.json();
          const imd = meta.imageMediaMetadata || {};
          const loc = imd.location || {};
          if (loc.latitude != null && loc.longitude != null) {
            exif_data.latitude  = loc.latitude;
            exif_data.longitude = loc.longitude;
          }
          if (imd.time) {
            const normalized = imd.time.replace(/^(\d{4}):(\d{2}):(\d{2})/, "$1-$2-$3");
            exif_data.date = new Date(normalized).toISOString();
          }
        } catch { /* keep empty exif */ }
      }
      return { ...item, exif_data };
    }));

    updateImageCallBack(enriched, folderName);
  };

  const ReverseGeocode = async (place) => {
    try {
      console.log("ReverseGeocode")
      fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${place.Lat},${place.Longi}&key=${process.env.REACT_APP_GOOGLE_MAPS_GEOCODING_KEY}`)
      .then(function (a) {
        return a.json(); // call the json method on the response to get JSON
    })
    .then(function (json) {
        try{
        let city = "";
        let state = "";
        let country = "";
        let street_address = "";
        for (var j=0; j<json.results.length; j++)
        {
            for (var i=0; i<json.results[j].address_components.length; i++)
            {
                if (json.results[j].address_components[i].types.includes("locality")) 
                    city = json.results[j].address_components[i].long_name;
                if (json.results[j].address_components[i].types.includes("administrative_area_level_1" ))
                    state = json.results[j].address_components[i].long_name;
                if (json.results[j].address_components[i].types.includes("country"))
                    country = json.results[j].address_components[i].long_name;
                  if(typeof json.results[j].formatted_address !== "undefined")
                //if (json.results[j].address_components[i].types.includes("street_address"))
                    street_address = json.results[j].formatted_address;
                if(city !== "" && state !== "" && country !== "") break;
            }
            if(city !== "" && state !== "" && country !== "") break;
        }

          // if(json.results[0].length === 7){
            place.Country = country;
            place.City = city;
            place.State = state;
            place.Address = street_address;
          // }
          // else if(json.results.length === 4 && json.results[3].types.includes("country")){
          //   place.Country = json.results[3].formatted_addres;
          // }
          
        }catch{

        }
    })
    }
    catch{}
  };

  // "A new guide"/"Replace this guide" always go into "Main" — the
  // schedule picker only applies to "Add to this guide" — same rule as
  // BuildMyTripWizard.js. A freshly typed "new schedule" name is
  // auto-deduped against existing schedule names rather than prompting,
  // since an explicitly-picked existing schedule can never collide with
  // itself.
  const _photoJournalResolveScheduleName = () => {
    const { guideTarget, scheduleTarget, groupName } = journalOptionsRef.current;
    if (guideTarget !== "add") return "Main";
    if (scheduleTarget !== PHOTO_JOURNAL_NEW_SCHEDULE) return scheduleTarget;
    const shedLabel = groupName || "Photo";
    const scheds = window.guide_obj.schedule.geScheduleNames();
    let schedule = shedLabel;
    for (let s = 1; s < 99999; s++) {
      schedule = (s === 1) ? `${shedLabel}` : `${shedLabel}${s}`;
      if (scheds.findIndex((x) => x.label === schedule) === -1) break;
    }
    return schedule;
  };

  // If the user left "Guide Name" blank when creating a new guide via
  // Create Journal from Photos, fall back to the source folder's name
  // instead of the generic "New Guide" sentinel. Checked against that
  // literal string since createNewGuideForAI already used it as the
  // fallback when the guide was created, before the folder (Saved Files) or
  // folder name (Google Drive) was even known yet. Kept in parity with
  // HomeHeader.js's own copy of this helper.
  const _applyPhotoJournalFolderNameFallback = (folderName) => {
    if (!folderName) return;
    const options = journalOptionsRef.current;
    if (!options || (options.guideTarget !== "new" && options.guideTarget !== "replace") || options.newGuideName) return;
    if (window.guide_obj?.attributes?.guide_name !== "New Guide") return;
    window.guide_obj.attributes.guide_name = folderName;
    window.guide_obj.guide_name = folderName;
    // The description is "New Guide" too — the Library card showed it under the name.
    if (window.guide_obj.attributes.description === "New Guide") window.guide_obj.attributes.description = folderName;
  };

  // Development builds only: the Playwright tests (e2e/smoke) start a
  // journal from sample photos through the real path below.
  if (process.env.NODE_ENV === "development") window.__andiamoTestJournal = (images) => updateImageCallBack(images, "");

  const updateImageCallBack = (images, folderName) => {
    _applyPhotoJournalFolderNameFallback(folderName);
    const schedule = _photoJournalResolveScheduleName();
    let groups = window.guide_obj.groups;
    let found = false;
    let GroupID = null;
    // Named after what was chosen, not the schedule (2026-10-18): a new or
    // replaced guide's schedule is always "Main", so every such journal got
    // a mosaic tile called "Main". The photo folder, else the group name
    // typed in the wizard, else the guide's name; the schedule name last.
    const typedName = String(journalOptionsRef.current?.groupName || "").trim();
    const guideName = String(window.guide_obj?.attributes?.guide_name || "").trim();
    let groupName =
      String(folderName || "").trim() ||
      (typedName && typedName !== "Photo" ? typedName : "") ||
      (guideName && guideName !== "New Guide" ? guideName : "") ||
      schedule;
    for (let x = 0; x < groups.length; x++) {
      if (groups[x].schedule === schedule || groups[x].name === groupName) {
        found = true;
        GroupID = groups[x].id;
      }
    }
    if(found === false){
       GroupID = window.guide_obj.addGroup(groupName);
        let group = new Group();
        group.id = GroupID;
        group.name = groupName;
        group.poi_img = 16;
        group.mosaic = true;
        group.schedule = schedule;
        window.guide_obj.modifyGroup(group, group);
    }

    updateImageConfirmed(images, schedule, "Add", GroupID);
  }

  const updateImageConfirmed = (images, schedule, update, GroupID) => {
    // for (let s = 1; s < 99999; s++) {
    //   schedule = (s === 1) ? `${shedLabel}` : `${shedLabel}${s}`;
    //   let found = false;
    //   for (let x = 1; x < scheds.length; x++) {
    //     if (schedule === scheds[x].label) found = true;
    //   }
    //   if (found === false) break;
    // }
    if(update === "Overwrite"){
      for (let i = window.guide_obj.schedule.events.length - 1; i >= 0; i--) {
        const event = window.guide_obj.schedule.events[i];
        if(event.Itinerary === schedule){
          const places_in_schedule = event.get_places(window.guide_obj.places);
          window.guide_obj.schedule.deleteEvent(event);
          for (let j = 0; j <places_in_schedule.length; j++) {
            window.guide_obj.places.deletePlace(places_in_schedule[j]);
          }
        }
      } 
    }
    let num_exif = 0;
    let exif_images = [];
    let no_exif_images = [];
    for (let i = 0; i < images.length; i++) {
      if (
        typeof images[i].exif_data === "undefined" ||
        typeof images[i].exif_data.date === "undefined" ||
        typeof images[i].exif_data.longitude === "undefined" ||
        typeof images[i].exif_data.latitude === "undefined" ||
        images[i].exif_data.longitude !== images[i].exif_data.longitude ||
        images[i].exif_data.latitude !== images[i].exif_data.latitude
      ) {
        no_exif_images.push(images[i]);
        continue;
      }
      exif_images.push(images[i]);
      num_exif++;
    }
    exif_images.sort((a, b) => {
      const at = DateTime.fromISO(a.exif_data.date);
      const bt = DateTime.fromISO(b.exif_data.date);
      return at < bt ? -1 : at > bt ? 1 : 0;
    });

    // Photos missing GPS/date can't be clustered or scheduled — rather than
    // silently drop them, ask first; only on "Yes" does each get its own
    // unscheduled, no-location Place (named from its own filename), still
    // available to the Photo Book and completable later via the normal
    // place-editing UI. One Place per photo, not a shared bucket — a
    // bucket can't be split back apart later. Opt-in, not automatic —
    // user-decided design, 2026-10-02.
    if (no_exif_images.length > 0) {
      myAlert("Some photos don't have location or date info. Use those photos as well?", "Message", [
        { Title: "No", Method: () => _continuePhotoJournal(exif_images, no_exif_images, false, num_exif, schedule, GroupID) },
        { Title: "Yes", Method: () => _continuePhotoJournal(exif_images, no_exif_images, true, num_exif, schedule, GroupID) },
      ]);
      return;
    }
    _continuePhotoJournal(exif_images, no_exif_images, false, num_exif, schedule, GroupID);
  };

  // Shared continuation after the (possibly skipped, when there are no
  // EXIF-less photos at all) Yes/No prompt above — creates a Place per
  // EXIF-less photo if the user opted in, reports what happened, then
  // proceeds to the existing cluster/review flow for the EXIF-complete
  // subset exactly as before.
  const _continuePhotoJournal = (exif_images, no_exif_images, useNoExif, num_exif, schedule, GroupID) => {
    let createdCount = 0;
    if (useNoExif) {
      const usedNoExifNames = new Set((window.guide_obj.places.placesList || []).map((p) => (p.Name || "").toLowerCase()));
      no_exif_images.forEach((photo) => {
        // No camera file names as place names (4.10.55).
        let _name = photoDefaultName(photo);
        _name = Common.uniquePlaceName(_name, usedNoExifNames);
        const new_place = new Place(window.guide_obj.places);
        new_place.Name = _name;
        new_place.Photo_m = photo.url_m || photo.url || "";
        new_place.Photo = photo.url || photo.url_m || "";
        new_place.poi_img = "208";
        window.guide_obj.places.addPlace(new_place);
        createdCount++;
      });
      dispatch(slice1Actions.setGuide({ guide: null }));
    }

    if (num_exif === 0) {
      myAlert(
        createdCount > 0
          ? `None of these photos had location or date info, so we couldn't build an automatic journal or schedule. We created ${createdCount} separate place${createdCount === 1 ? "" : "s"} instead, one per photo — edit each one to add a location or add it to your schedule manually.`
          : "No photos had location and date info",
        "Message"
      );
      return;
    } else if (createdCount > 0) {
      myAlert(
        `${num_exif} place${num_exif === 1 ? "" : "s"} created and added to your schedule from photos with location/date info. ${createdCount} more photo${createdCount === 1 ? "" : "s"} had no location/date info, so they couldn't be scheduled — we created a separate place for each one instead; edit them later to add a location or add them to your schedule.`,
        "Message"
      );
    } else if (no_exif_images.length > 0) {
      myAlert("Some photos had no location or date info", "Message");
    }

    photoJournalExifImagesRef.current = exif_images;
    photoJournalScheduleRef.current = schedule;
    photoJournalGroupIdRef.current = GroupID;
    setPhotoJournalReviewClusters(_clusterPhotosByProximity(exif_images, photoJournalSensitivity, photoJournalMaxSpan));
    setPhotoJournalReviewShow(true);
  };

  // Strips the timezone-offset suffix some cameras write into EXIF dates,
  // matching the parsing this file already did per-photo before clustering
  // existed — kept as a helper since it's now needed for both the initial
  // date sort and the per-cluster Start/End timing below.
  const _parsePhotoDate = (dateStr) => {
    let _date = dateStr;
    const parts = _date.split(":");
    if (parts[parts.length - 2].includes("+") || parts[parts.length - 2].includes("-")) {
      _date = _date.substring(0, _date.length - 5) + "00:00";
    }
    return DateTime.fromISO(_date);
  };

  // Greedy nearest-cluster-centroid grouping, not naive consecutive-photo
  // chaining — chaining would merge an entire day of walking into one
  // "place" since each step is close to the last even as the day's overall
  // span grows huge. Photos must already be in chronological order.
  const _clusterPhotosByProximity = Common.clusterPhotosByProximity;

  const _buildExtraPhotosHtml = (extraPhotos) => {
    return extraPhotos
      .map((photo) => {
        const rawUrl = photo.url_m || photo.url || "";
        const idAttr = rawUrl ? ` data-photo-id="${rawUrl}"` : "";
        const resolved = rawUrl ? Common.getImageURL(rawUrl, null, false) : "";
        const src = (resolved && resolved.startsWith("http")) ? resolved : (photo.thumb || photo.url || rawUrl);
        return `<img src="${src}" alt=""${idAttr} style="max-width:100%;height:auto;margin:4px 0;">`;
      })
      .join("\n");
  };

  // Called from PhotoJournalReviewModal once the user confirms the proposed
  // (and possibly manually re-clustered/split) places. One place per
  // cluster — the cover photo becomes Photo/Photo_m, any other photos in
  // the cluster are embedded directly into that place's Notes, so no
  // separate "Add Photos to Places" pass is needed for this flow.
  const _applyPhotoJournalClusters = (result, guideCoverPhoto) => {
    const schedule = photoJournalScheduleRef.current;
    const GroupID = photoJournalGroupIdRef.current;
    setPhotoJournalReviewShow(false);

    // The guide's own cover photo — distinct from any place's ★ cover, and
    // never implicit — set only when the user picked one via the ⌂ button
    // in PhotoJournalReviewModal. Same pattern as mobile's MainScreen.js.
    if (guideCoverPhoto) {
      const guideCoverUrl = guideCoverPhoto.url_m || guideCoverPhoto.url || "";
      if (guideCoverUrl) {
        window.guide_obj.attributes.image = guideCoverUrl;
        window.guide_obj.attributes.image_m = guideCoverUrl;
      }
    }

    const clusterInfos = result
      .map(({ coverPhoto, extraPhotos, placeName }) => {
        const allDates = [coverPhoto, ...extraPhotos].map((p) => _parsePhotoDate(p.exif_data.date).toMillis());
        return { coverPhoto, extraPhotos, placeName, earliest: Math.min(...allDates) };
      })
      .sort((a, b) => a.earliest - b.earliest);

    if (clusterInfos.length === 0) {
      myAlert("No places to create.", "Message");
      return;
    }

    // No picture picked and the guide has none (a new guide, or "Replace
    // this guide", which clears it): use the first place's photo, so the
    // journal doesn't show up picture-less in the Library (2026-10-25).
    if (!window.guide_obj.attributes.image) {
      const firstCover = clusterInfos[0].coverPhoto;
      const firstUrl = firstCover?.url_m || firstCover?.url || "";
      if (firstUrl) {
        window.guide_obj.attributes.image = firstUrl;
        window.guide_obj.attributes.image_m = firstUrl;
      }
    }

    const usedNames = new Set(window.guide_obj.places.placesList.map((p) => (p.Name || "").toLowerCase()));
    let last_event = null;
    clusterInfos.forEach((info, i) => {
      // placeName, when set, only overrides the resulting place's name —
      // never the photo's own filename/file, which stays untouched.
      let _name = info.placeName || photoDefaultName(info.coverPhoto);
      if (!info.placeName && _name.toUpperCase().includes(".JPG")) _name = _name.slice(0, -4);
      _name = Common.uniquePlaceName(_name, usedNames);

      let place = addPlaceToMap(
        "Icon",
        { Lat: info.coverPhoto.exif_data.latitude, Longi: info.coverPhoto.exif_data.longitude },
        null,
        {
          name: _name,
          info: _buildExtraPhotosHtml(info.extraPhotos),
          imgURL: info.coverPhoto.url_m,
          imgURL_t: info.coverPhoto.url,
          poi_img: "208",
          group: [`${GroupID}`],
          visited: journalOptionsRef.current?.markVisited !== false,
        }
      );
      if (!place) return;
      if (place !== null) ReverseGeocode(place);

      const image_date = DateTime.fromMillis(info.earliest);
      const next_earliest = i === clusterInfos.length - 1 ? null : clusterInfos[i + 1].earliest;

      let event = new Appointment(window.guide_obj.schedule);
      event.Subject = _name;
      event.Body = "";
      event.Itinerary = schedule;
      event.Start = image_date.toISO();
      event.End = journalEventEnd(info.earliest, next_earliest).toISO();
      if (!event.Places.includes(place.ID)) event.Places = place.ID;
      window.guide_obj.schedule.addEvent(event);
      last_event = event;
    });

    if (last_event && window.guide_obj.guide_settings.itinerary.directions === false && window.guide_obj.guide_settings.itinerary.info === false && window.guide_obj.guide_settings.itinerary.photo === true && window.guide_obj.guide_settings.itinerary.place_menu === false) {
      let main_event = new Appointment(window.guide_obj.schedule);
      main_event.Subject = schedule;
      main_event.Body = "";
      main_event.Itinerary = "Main";
      main_event.Start = last_event.Start;
      main_event.End = last_event.End;
      main_event.Places = last_event.Places;
      window.guide_obj.schedule.addEvent(main_event);
    } else {
      const main_events = window.guide_obj.schedule.getEventsFromSchedule("Main");
      if (main_events.length === 0) window.guide_obj.schedule.copySchedule(schedule, "Main");
    }

    setTimeout(() => {
      const html = window.guide_obj.createHTMLItinerary("Main", GuideSettings.itinerary, { ...user_info, showHiddenPlaces: ShowHiddenPlaces }, GuideSettings);
      // createHTMLItinerary itself has no cover-image logic — every caller
      // that wants one has to prepend it, same as ScheduleHeader.js's
      // doItinerary / TripAI.js / BuildMyTripWizard.js. This path never had
      // it, so a guide cover photo just set above (or an existing one)
      // never showed up here.
      const ILLUSTRATED_PLACEHOLDER = "https://andiamotravelapp.com/Images/App/IllustratedImage.jpg";
      const GOOGLE_PLACES_PHOTO_PATTERN = /places\.googleapis\.com\/v1\/.*\/media/i;
      const hasRealPhoto = (p) =>
        (p.Photo && p.Photo !== ILLUSTRATED_PLACEHOLDER && !GOOGLE_PLACES_PHOTO_PATTERN.test(p.Photo)) ||
        (p.Photo_m && p.Photo_m !== ILLUSTRATED_PLACEHOLDER && !GOOGLE_PLACES_PHOTO_PATTERN.test(p.Photo_m));
      // Skip the first real-photo place when a second exists — it's often
      // ALSO what a mosaic tile or the itinerary's first listed place ends
      // up showing (same "first with a real photo" pick). Requested
      // 2026-09-27.
      const photoPlaces = window.guide_obj.places.placesList.filter(hasRealPhoto);
      const coverPlace = (photoPlaces.length > 1 ? photoPlaces[1] : photoPlaces[0]) || null;
      const isBadCoverUrl = (url) =>
        !url || url === ILLUSTRATED_PLACEHOLDER || GOOGLE_PLACES_PHOTO_PATTERN.test(url);
      const guideCustomCover = !isBadCoverUrl(window.guide_obj.attributes.image_m)
        ? window.guide_obj.attributes.image_m
        : null;
      const coverImageM = guideCustomCover || coverPlace?.Photo_m || coverPlace?.Photo;
      const coverImageUrl = coverImageM ? Common.getImageURL(coverImageM, null, true) : null;
      const coverImg = coverImageUrl
        ? Common.coverImageHTML(coverImageUrl)
        : "";
      const fullHtml = `${coverImg}${html}`;
      window.guide_obj.document = fullHtml;
      dispatch(slice1Actions.setHTMLTitle({ value: "Itinerary" }));
      dispatch(slice1Actions.setHTMLToSHow({ value: fullHtml }));
      dispatch(slice1Actions.setShowHTMLReader({ value: true }));
      dispatch(slice1Actions.resetHTMLScreen());
    }, 500);

    dispatch(slice1Actions.setScheduleName({ value: schedule }));
    // update_guide_attributes: true — without it, setGuide's plain-refresh
    // path never re-syncs state.guide_meta.guide_info from
    // window.guide_obj.attributes (only the "clear" branch and the
    // update_guide_attributes branch do, per reducer.js), so a guide cover
    // photo set above via window.guide_obj.attributes.image/image_m never
    // showed up in the UI (GuideNameBar.js/GuideEditModal.js read
    // guide_meta.guide_info, not window.guide_obj.attributes directly).
    // Every other flow that touches guide attributes already passes this —
    // see e.g. KMLInput.js:1006,1021. Found 2026-09-24.
    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true, update_guide_attributes: true }));
  };

  const _onPhotoJournalSensitivityChange = (value) => {
    setPhotoJournalSensitivity(value);
    setPhotoJournalReviewClusters(_clusterPhotosByProximity(photoJournalExifImagesRef.current, value, photoJournalMaxSpan));
  };

  const _onPhotoJournalMaxSpanChange = (value) => {
    setPhotoJournalMaxSpan(value);
    setPhotoJournalReviewClusters(_clusterPhotosByProximity(photoJournalExifImagesRef.current, photoJournalSensitivity, value));
  };

  const addPlaceToMap = (PType, Point, Points, params) => {
    let shape = "New Place";
    if (PType === "Polygon") shape = "New Area";
    else if (PType === "PolyLine") shape = "New Path";
    let new_place = new Place(window.guide_obj.places);
    new_place.Name = `${shape}`;
    if (params != null) {
      new_place.Name = params.name;
      new_place.Info = params.info;
      new_place.Photo_m = params.imgURL;
      if (typeof params.imgURL_t !== "undefined") new_place.Photo = params.imgURL_t;
      if (typeof params.poi_img !== "undefined") new_place.poi_img = params.poi_img;
      if (typeof params.Hlink !== "undefined" ) new_place.Hlink = params.Hlink;
      if (typeof params.group !== "undefined" ) new_place.Group = params.group;
      if (typeof params.visited !== "undefined" ) new_place.Visited = params.visited;
      if (typeof params.country !== "undefined" ) new_place.Country = params.country;
      if (typeof params.city !== "undefined" ) new_place.City = params.city;
      if (typeof params.state !== "undefined" ) new_place.State = params.state;
      if (typeof params.address !== "undefined" ) new_place.Address = params.address;
      if (typeof params.phone !== "undefined" ) new_place.Phone = params.phone;
      if (typeof params.email !== "undefined" ) new_place.Email = params.email;
      if (typeof params.rating !== "undefined" ) new_place.Rating = params.rating;
      if (typeof params.duration !== "undefined" ) new_place.Duration = params.duration;
      if (typeof params.favorite !== "undefined" ) new_place.Favorite = params.favorite;
      if (typeof params.mustSee !== "undefined" ) new_place.MustSee = params.mustSee;
      if (typeof params.hidden !== "undefined" ) new_place.Hidden = params.hidden;
      if (typeof params.category !== "undefined" ) new_place.Category = params.category;
      if (typeof params.link !== "undefined" ) new_place.Link = params.link;
      if (typeof params.openingHours !== "undefined" ) new_place.OpeningHours = Place.mergeOpeningHoursDefaults(params.openingHours);
    }
    // console.log("_mapCoordinate", _mapCoordinate);
    new_place.Lat = Point.Lat; //_mapCoordinate.Lat;
    new_place.Longi = Point.Longi; //_mapCoordinate.Longi;
    new_place.PType = PType;
    new_place.Points = Points;
    if (PType === "Icon") new_place.Points = null;
    // console.log(new_place);
    //this.props.onAddPlace(new_place);
    window.guide_obj.places.addPlace(new_place);

    dispatch(slice1Actions.addShowHiddenPlaces({ value: new_place }));
    dispatch(slice1Actions.setGuide({ guide: null }));
    return new_place;
  };

  const ExportGuideAsKML = () => {
    const kml = window.guide_obj.createKML();
    console.log("kml", kml);
    const file = new Blob([kml], { type: "text/plain" });
    const element = document.createElement("a");
    element.href = URL.createObjectURL(file);
    element.download = "Guide.kml";
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  };

  const ExportTripAsHTML = () => { setMenuModalShow(false); setShowExportOptions(true); };
  const ExportTripAsPDF  = () => { setMenuModalShow(false); setShowExportOptions(true); };

  const doExportHTML = (opts) => {
    const html = generateTripHTML(window.guide_obj, opts);
    const name = (window.guide_obj.attributes.guide_name || "Trip").replace(/[^a-z0-9_\- ]/gi, "").trim() || "Trip";
    const blob = new Blob([html], { type: "text/html;charset=utf-8" });
    const el = document.createElement("a");
    el.href = URL.createObjectURL(blob);
    el.download = `${name}.html`;
    document.body.appendChild(el);
    el.click();
    document.body.removeChild(el);
  };

  const doExportPDF = (opts) => {
    printTripAsPDF(window.guide_obj, opts);
  };

  const writeGuideToFile = () => {
    if (window.guide_obj.isAuthorized(Authorization, AUTHORIZATION_LEVEL.MODIFY) === false) {
      myAlert("Not authorized to save this guide");
      return;
    }
    const guide_obj_write = {
      pass: true,
      error: "",
      guide_id: guide_meta.guide_id,
      res: window.guide_obj,
      infoDoc: window.guide_obj.attributes,
      guide_info_id: guide_meta.guide_info_id,
      owner_info: owner_info,
      creator_info: creator_info,
    };
    const file = new Blob([JSON.stringify(guide_obj_write)], { type: "text/plain" });
    const element = document.createElement("a");
    element.href = URL.createObjectURL(file);
    element.download = "Guide.json";
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  };

  const readGuideFromFile = () => {
    const element = document.getElementById("guide-file-upload");
    element.click();
  };

  const readLocalFile = (e) => {
    //console.log(e.target.files);
    var fr = new FileReader();
    fr.onload = function () {
      try {
        //console.log(fr.result);
        const guide_obj_read = JSON.parse(fr.result);
        // if(guide_obj_read.owner_info.uid !== user_info.uid) {
        //   myAlert("Not authorized to read this guide");
        //   return;
        // }
        let data = JSON.stringify(guide_obj_read.res);
        let guide_part = { data: data };
        const params = {
          pass: true,
          error: "",
          guide_id: guide_obj_read.guide_id,
          res: guide_part,
          infoDoc: guide_obj_read.infoDoc,
          guide_info_id: guide_obj_read.guide_info_id,
          owner_info: guide_obj_read.owner_info,
          creator_info: guide_obj_read.creator_info,
        };
        readGuideDataReturnNew(params);
      } catch (e) {
        myAlert("Error reading guide");
      }
    };
    fr.readAsText(e.target.files[0]);
  };

  const handleContentFontZoom = () => {
    let zoomList = [];
    for (let i = 50; i <= 300; i += 10) {
      zoomList.push({ id: i.toString(), label: i.toString(), value: i, name: i.toString() });
    }
    let selectedZoom = [
      {
        id: ContentFontZoom.toString(),
        label: ContentFontZoom.toString(),
        value: ContentFontZoom,
        name: ContentFontZoom.toString(),
      },
    ];
    setMultiselectItems(zoomList);
    setMultiselectSelectedItems(selectedZoom);
    setMultiselectMode("uni");
    setMultiselectTitle(`Select Zoom`);
    setShowMultiselect(true);
    //setMultiselectCallback(() => handleContentFontZoomCallback());
  };

  const handleContentFontZoomCallback = (zoom) => {
    dispatch(slice1Actions.setContentFontZoom({ value: zoom[0].value }));
  };

  const setGuideSettings = (value) => {
    setGuideSettingsDialogShow(true);
    return;
    let guide_options = JSON.parse(JSON.stringify(GuideSettings));
    if (guide_options.mode === "edit") guide_options.mode = "view";
    else if (guide_options.mode === "view") guide_options.mode = "custom_view";
    else guide_options.mode = "edit";
    dispatch(slice1Actions.setGuideSettings({ value: guide_options }));
    dispatch(slice1Actions.setGuide({ guide: null }));
  };

  const SavePDFxxx = () => {
    // const doc = new jsPDF();
    var doc = new jsPDF("l", "mm", [1200, 1810]);
    // doc.text("Hello world!", 10, 10);
    const htmlString = HTMLStack[htmlStackLength - 1];

    // doc.text(htmlString, 10, 10);
    doc.html(htmlString, {
      callback: () => {
        doc.save("guide.pdf");
      },
      x: 10,
      y: 10,
    });
  };

  const SavePDF = () => {
    const iframe = document.createElement("iframe");
    iframe.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden";
    document.body.appendChild(iframe);
    const element = document.getElementById("home-content");
    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write(`<html><head><title>${guide_meta.guide_info.guide_name}</title></head><body>${element ? element.innerHTML : ""}</body></html>`);
    doc.close();
    setTimeout(() => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => { if (document.body.contains(iframe)) document.body.removeChild(iframe); }, 1000);
    }, 500);

    return;
    // setPDFModalShow(true);
    // return;

    const input = document.getElementById("home-content");
    html2canvas(input, {
      scale: 0.8,
      useCORS: true,
      etterRendering: 1,
      allowTaint: true,
      onrendered: SavePDFComplete,
    }).then((canvas) => {
      var imgWidth = 200;
      var pageHeight = 2900;
      var imgHeight = (canvas.height * imgWidth) / canvas.width;
      var heightLeft = imgHeight;
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      var position = 0;
      var heightLeft = imgHeight;
      pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
      pdf.save("Guide.pdf");
    });
  };

  const SavePDFComplete = () => {
    myAlert("PDF processed", "Message");
  };

  let _attributes = null;

  const RefreshGuide = () => {
    if (!guide_meta.guide_info_id) {
      myAlert("This guide hasn't been saved to the cloud yet, so there's nothing to reload.", "Message");
      return;
    }
    myConfirm("Reload this Guide from cloud? This will overwrite any changes.", [
      { Title: "OK", Method: () => _RefreshGuide() },
      { Title: "CANCEL", Method: null },
    ]);
  };

  const _RefreshGuide = () => {
    loadGuide(guide_meta.guide_info_id);
  };

  const ReviewGuide = () => {
    if (Authorization === AUTHORIZATION_LEVEL.GUEST) {
      myAlert("Cannot rate a guides in guest mode. You must be registered and logged in", "Message");
      return;
    }
    setReviewDialogShow(true);
  };

  const PreviousGuide = () => {
    if (GuideStack.length < 1) {
      dispatch(slice1Actions.clearGuideStack());
      return;
    }
    if (GuideStack.length < 2) return;
    let guide_id = GuideStack[GuideStack.length - 2];
    dispatch(slice1Actions.popGuideStack({ value: null }));
    loadGuide(guide_id);
  };

  const clearGuide = async () => {
    const message = "This will clear the content of the current guide. The changes will be local until you save the guide. You can also refresh the guide to read the content last saved to the cloud. Continue?";
    // The owner reusing a guide for a different trip (2026-10-17) can also
    // delete its comments, polls and ratings — they're about the old trip,
    // kept in the cloud apart from the content, and Clear alone never
    // touches them. Offered only when there are some.
    const discussion = await guideDiscussionToOffer();
    if (!discussion) {
      myConfirm(message, [
        { Title: "OK", Method: () => _clearGuide() },
        { Title: "CANCEL", Method: null },
      ]);
      return;
    }
    myConfirm(`${message}\n\nThis guide also has ${discussion.text}. If the guide is becoming a different trip, you can delete them too — that part happens right away and can't be undone.`, [
      { Title: "Clear", Method: () => _clearGuide() },
      { Title: "Clear and delete discussion", Method: () => { _clearGuide(); deleteGuideDiscussionNow(); } },
      { Title: "CANCEL", Method: null },
    ]);
  };

  // { text } describing the guide's comments/polls/ratings when the current
  // user owns the saved guide and it has any; otherwise null.
  const guideDiscussionToOffer = async () => {
    const infoId = guide_meta?.guide_info_id;
    const ownerId = guide_meta?.guide_info?.user_id;
    if (!infoId || !user_info?.uid || user_info.uid === "guest" || ownerId !== user_info.uid) return null;
    const c = await DataBase.countGuideDiscussion(infoId);
    const parts = [
      c.comments ? `${c.comments} comment${c.comments === 1 ? "" : "s"}` : "",
      c.polls ? `${c.polls} poll${c.polls === 1 ? "" : "s"}` : "",
      c.reviews ? `${c.reviews} rating${c.reviews === 1 ? "" : "s"}` : "",
    ].filter(Boolean);
    if (parts.length === 0) return null;
    return { text: parts.length > 1 ? `${parts.slice(0, -1).join(", ")} and ${parts[parts.length - 1]}` : parts[0] };
  };

  const deleteGuideDiscussionNow = () => {
    const infoId = guide_meta?.guide_info_id;
    if (!infoId) return;
    DataBase.deleteGuideDiscussion(infoId).then(() => DataBase.countGuideDiscussion(infoId)).then((left) => {
      if (left.reviews > 0) myAlert(`${left.reviews} rating${left.reviews === 1 ? "" : "s"} by other people couldn't be deleted — the database only lets each person remove their own.`, "Message");
    });
  };

  const _clearGuide = () => {
    window.__guideLoadGen = (window.__guideLoadGen || 0) + 1;   // drop any guide still loading
    dispatch(slice1Actions.ClearAllFilters());
    dispatch(slice1Actions.SetSearchText({ value: "" }));
    dispatch(slice1Actions.setGuide({ action: "clear" }));
  };

  // Travel document expiry warning (docs/competitive-analysis.md rec #6).
  // Signed-in users only, and only when a traveler's Passport/Visa document
  // matches one of the current guide's destination countries and expires
  // within Common.DOCUMENT_EXPIRY_WARNING_MONTHS. Session-only dismiss, same
  // simplification as the sample-guide banner above.
  const renderTravelDocumentBanner = () => {
    const isGuest = user_info.uid === null || user_info.uid === "guest" || Authorization === AUTHORIZATION_LEVEL.GUEST;
    if (isGuest || TravelDocumentBannerDismissed) return null;
    if (window.guide_obj == null) return null;
    const guideCountries = window.guide_obj.attributes.countries || [];
    if (guideCountries.length === 0) return null;
    const travelers = user_info.travelers || [];
    let expiringDoc = null;
    for (const traveler of travelers) {
      for (const doc of traveler.documents || []) {
        if (doc.type !== "Passport" && doc.type !== "Visa") continue;
        if (!guideCountries.includes(doc.country)) continue;
        const status = Common.getDocumentExpiryStatus(doc.expiryDate);
        if (status === "expired" || status === "soon") {
          expiringDoc = { traveler, doc, status };
          break;
        }
      }
      if (expiringDoc) break;
    }
    if (!expiringDoc) return null;
    const verb = expiringDoc.status === "expired" ? "expired" : "expires soon";
    return (
      <div className="sample-guide-banner">
        <span className="sgb-text">
          {expiringDoc.traveler.name}'s {expiringDoc.doc.type} for {expiringDoc.doc.country} {verb}
        </span>
        <span className="sgb-actions">
          <span className="sgb-action" onClick={() => setShowYouModal(true)}>
            Review
          </span>
          <span className="sgb-action" onClick={() => setTravelDocumentBannerDismissed(true)}>
            Dismiss
          </span>
        </span>
      </div>
    );
  };

  // Persistent "where am I in building this guide" indicator — same 3-step
  // model as the per-screen hints in Places.js/SchedulePanel.js/Map.js/
  // Home.js (destinations → places → auto-built schedule/itinerary), but
  // visible from every screen via this always-mounted nav bar instead of
  // only when you happen to land on one with a hint. Disappears entirely
  // once the guide has real places — at that point it's in active use, not
  // "still being set up," and a permanent progress bar would just be
  // clutter. Session-only, not dismissible — reflects genuine guide state,
  // not a one-time announcement like the banners above.
  const renderProgressBanner = () => {
    if ((window.guide_obj?.places?.placesList || []).length > 0) return null;
    if ((window.guide_obj?.destinations || []).length === 0) {
      return (
        <div className="sample-guide-banner">
          <span className="sgb-text">Step 1 of 3 — Add destinations for this guide</span>
          <span className="sgb-actions">
            <span className="sgb-action" onClick={() => setShowDestinations(true)}>Add Destinations</span>
          </span>
        </div>
      );
    }
    return (
      <div className="sample-guide-banner">
        <span className="sgb-text">Step 2 of 3 — Find places for your destinations</span>
        <span className="sgb-actions">
          <span
            className="sgb-action"
            onClick={() => window.dispatchEvent(new CustomEvent("openBuildMyTripWizard", { detail: { pickPlacesAuto: true } }))}
          >
            Automatically
          </span>
          <span
            className="sgb-action"
            onClick={() => window.dispatchEvent(new CustomEvent("openBuildMyTripWizard", { detail: { pickPlacesAuto: false } }))}
          >
            Pick Myself
          </span>
        </span>
      </div>
    );
  };

  // Port of andiamo-places' MainScreen.js _renderUnsavedGuideBanner — web
  // had the same save-promotion bug (fixed earlier this session in
  // HomeHeader.js/here) but no equivalent visible reminder, so a user could
  // build a whole trip (Build My Trip/Build Trip with AI/Import Itinerary
  // from Image) and lose it by navigating away or closing the tab without
  // ever being told it wasn't saved. Shown whenever the guide has real
  // content that isn't safely in the cloud: never saved at all
  // (guide_info_id == null) OR saved once but dirtied again since
  // (GuideHasUnsavedChanges). Dismissed per-guide via object identity
  // (dismissedUnsavedGuideRef), matching mobile — a newly created/loaded
  // guide always nags again even if a previous one was dismissed. Added
  // 2026-09-30.
  const renderUnsavedGuideBanner = () => {
    if (!window.guide_obj) return null;
    const neverSaved = guide_meta?.guide_info_id == null;
    if (!neverSaved && !GuideHasUnsavedChanges) return null;
    if (dismissedUnsavedGuide === window.guide_obj) return null;
    const isGuest = user_info.uid === null || user_info.uid === "guest" || Authorization === AUTHORIZATION_LEVEL.GUEST;
    const text = isGuest
      ? "Unsaved guide — sign in to keep it"
      : neverSaved
      ? "Unsaved guide — not yet in the cloud"
      : "Unsaved changes — remember to save";
    return (
      <div className="sample-guide-banner">
        <span className="sgb-text" onClick={() => setDismissedUnsavedGuide(window.guide_obj)}>
          {text}
        </span>
        <span className="sgb-actions">
          {isGuest ? (
            <span className="sgb-action" onClick={() => { setLoginModalMode("Login"); setShowLoginModal(true); }}>Sign In</span>
          ) : (
            <span className="sgb-action" onClick={_saveGuide}>Save</span>
          )}
        </span>
      </div>
    );
  };

  // "You have N comments" — dismiss is persisted (CommentDismiss,
  // localStorage) as the comment_count value as of last dismiss, not a
  // plain seen/unseen flag, so it reappears once the count climbs past that
  // again rather than staying dismissed forever once clicked. comment_count
  // itself is a free read (already on the loaded guide_meta.guide_info doc)
  // — no extra query just to decide whether to show this. Mirrors mobile's
  // MainScreen.js _renderCommentsBanner.
  const renderCommentsBanner = () => {
    if (!window.guide_obj || guide_meta?.guide_info_id == null) return null;
    const count = guide_meta?.guide_info?.comment_count || 0;
    if (count <= 0) return null;
    if (count <= CommentDismiss.getDismissedCount(guide_meta.guide_info_id)) return null;
    const markSeen = () => {
      CommentDismiss.setDismissedCount(guide_meta.guide_info_id, count);
      setCommentDismissVersion((v) => v + 1);
    };
    // Viewing counts as seen, same as Dismiss — the banner returns only when
    // new comments arrive.
    const viewComments = () => {
      markSeen();
      setShowCommentsList(true);
    };
    return (
      <div className="sample-guide-banner">
        <span className="sgb-text" onClick={viewComments} style={{ cursor: "pointer" }}>
          {`You have ${count} comment${count === 1 ? "" : "s"}`}
        </span>
        <span className="sgb-actions">
          <span className="sgb-action" onClick={viewComments}>
            View
          </span>
          <span className="sgb-action" onClick={markSeen}>
            Dismiss
          </span>
        </span>
      </div>
    );
  };

  // "Build My Trip" always just opens the wizard now — same as TripAI, the
  // wizard itself asks "a new guide / add to this guide / replace this
  // guide" (see its own "Where should this go?" guide-level section) and
  // only warns/creates/clears once that choice and the destination(s) are
  // actually confirmed, rather than deciding for the user and warning
  // before they've even seen the setup dialog.
  const newGuide = () => {
    setBuildMyTripWizardShow(true);
  };

  // Same as newGuide, but skips the wizard entirely for users who want to
  // build a guide manually — without this, the only way to do that is to
  // enter the wizard and back out of it, every single time.
  const newGuideManual = () => {
    myConfirm("This will create a new guide. Save any wanted changes to this guide first. Continue?", [
      { Title: "OK", Method: () => {
        createLocalGuide("New Guide", () => {});
      }},
      { Title: "CANCEL", Method: null },
    ]);
  };

  // "Create a Photo Book" (2026-10-20): a new, empty guide that opens
  // straight into the Photo Book, for a book made from custom pages (or
  // photos added later) rather than from a trip.
  // Asks first (2026-10-20): the book can come from this guide, or from a
  // new blank one.
  const newPhotoBookGuide = () => {
    myConfirm(`Make the photo book from this guide ("${window.guide_obj?.attributes?.guide_name || "this guide"}"), or start with a blank guide? A blank guide replaces this one on screen — save any wanted changes to this guide first.`, [
      { Title: "Use existing guide", Method: () => setShowPhotoBookPreview(true) },
      { Title: "Start with blank guide", Method: () => createLocalGuide("My Photo Book", () => setShowPhotoBookPreview(true)) },
      { Title: "CANCEL", Method: null },
    ]);
  };

  const newGuideCallback = (guideAttributes) => {
    _attributes = guideAttributes;
    let GuideObj = new Guide("new");
    GuideObj.decodeGuideFb(GuideObj, _attributes);
    GuideObj.user_id = user_info.uid;
    DataBase.batchedWriteGuide(GuideObj, null, null, user_info, "new", addGuideDataCallbackNewGuide);
  };

  const addGuideDataCallbackNewGuide = (res) => {
    if (res.pass !== true) {
      dispatch(slice1Actions.SetLoadingGuide({ value: false }));
      return;
    }
    window.record_last_guide_read = true;
    DataBase.readGuideTransaction(res.new_info_ref.id, readGuideDataReturnNew, user_info.uid);
  };

  // Builds a fresh Guide object purely in redux/window.guide_obj, with no
  // Firestore write — used for ALL new-guide creation (guest and signed-in
  // alike) to avoid littering the cloud with abandoned guides from every
  // "Create new guide" click. It gets a real cloud home on the user's first
  // actual Save via _saveGuide's guide_info_id==null promotion path below,
  // or — for guests specifically — automatically on sign-in via
  // persistLocalGuide (see findUserByUIDCallback's guest_generated_unsaved_trip check).
  const createLocalGuide = (name, callback) => {
    const attributes = new GuideAttributes(name || "New Guide", "", null, "English", 0, [], []);
    let GuideObj = new Guide("new");
    GuideObj.decodeGuideFb(GuideObj, attributes);
    window.guide_obj = GuideObj;
    dispatch(
      slice1Actions.setGuide({
        guide: "new",
        guide_meta: { guide_info: null, guide_info_id: null, guide_id: null },
      })
    );
    dispatch(slice1Actions.setGuidesOrPlaces({ value: "Places", GuideType: "None" }));
    callback(true);
  };

  const copyGuide = () => {
    if (Authorization === AUTHORIZATION_LEVEL.GUEST) {
      myAlert("Cannot copy guides in guest mode. You must be registered and logged in");
      return;
    }
    if (window.guide_obj.isAuthorized(Authorization, AUTHORIZATION_LEVEL.COPY) === false) {
      myAlert("You are not authorized to copy this guide");
      return;
    }
    myConfirm(
      copyConfirmText(window.guide_obj?.attributes),
      [
        { Title: "OK", Method: () => _batchedCopyGuide() },
        { Title: "CANCEL", Method: null },
      ]
    );
  };

  let _copiedGuideID = null;

  const _batchedCopyGuide = () => {
    dispatch(slice1Actions.SetLoadingGuide({ value: true }));
    setTimeout(timeoutFunc, 5000);
    _copiedGuideID = guide_meta?.guide_info_id;
    DataBase.batchedWriteGuide(window.guide_obj, null, null, user_info, "copy", batchCopyGuideCallback);
  };

  const batchCopyGuideCallback = (res) => {
    dispatch(slice1Actions.SetLoadingGuide({ value: false }));
    if (res.pass !== true) {
      myAlert(res.tooLarge ? res.res : "Error copying guide");
      return;
    }
    // this.setState({
    //   new_guide_id: res.new_doc_ref.id,
    //   new_guide_info: res.new_info_ref.id,
    //   guide_info_id: res.new_info_ref.id,
    // });
    window.record_last_guide_read = true;
    DataBase.readGuideTransaction(res.new_info_ref.id, readGuideDataReturnNew, user_info.uid);
    DataBase.incrementCopiesTransaction(_copiedGuideID, incrementCopiesTransaction);
  };

  const incrementCopiesTransaction = () => {};
  //let download_type = "read";

  const overWriteGuide = () => {
    if (window.guide_obj.isAuthorized(Authorization, AUTHORIZATION_LEVEL.MODIFY) === false) {
      myAlert("Not authorized to modify this guide");
      return;
    }
    if (Authorization === AUTHORIZATION_LEVEL.GUEST) {
      myAlert("Cannot overwrite guides in guest mode. You must be registered and logged in");
      return;
    }
    myConfirm("This will update content of another guide with this guide. Continue?", [
      { Title: "OK", Method: () => selectGuideToOverWrite() },
      { Title: "CANCEL", Method: null },
    ]);
  };

  const selectGuideToOverWrite = () => {
    setGuideDownloadType("overwrite");
    setGuideDownloadMode("list");
    setGuideDownloadShow(true);
  };

  const _overWriteGuide = (guide_info_id, guide_id) => {
    console.log("overwriting guide_id:", guide_id);
    dispatch(slice1Actions.SetLoadingGuide({ value: true }));
    setTimeout(timeoutFunc, 5000);
    DataBase.batchedWriteGuide(
      window.guide_obj,
      guide_id,
      guide_info_id,
      user_info,
      "overwrite",
      overWriteGuideCallback,
      guide_id,
      guide_info_id
    );
  };

  const overWriteGuideCallback = (res) => {
    dispatch(slice1Actions.SetLoadingGuide({ value: false }));
    if (res.pass === true) myAlert("Guide overwritten");
  };

  const ShowGuidesOrGuide = (guides_or_places, GuideType) => {
    let temp = guides_or_places === "Guides" ? "Places" : "Guides";
    if (guides_or_places === GuidesOrPlaces) {
      ShowGuidesOrGuideTimeout(temp, GuideType);
      setTimeout(() => ShowGuidesOrGuideTimeout(guides_or_places, GuideType), 100);
    } else ShowGuidesOrGuideTimeout(guides_or_places, GuideType);
  };

  const handleLibraryTap = () => {
    const type = inviteCount > 0 ? "Shared" : lastLibraryTypeRef.current ?? (ViewedGuides.length > 0 ? "Viewed" : "Mine");
    ShowGuidesOrGuide("Guides", type);
  };

  const ShowGuidesOrGuideTimeout = (guides_or_places, GuideType) => {
    let Hide = guides_or_places === "Guides" ? true : false;
    dispatch(slice1Actions.setGuidesOrPlaces({ value: guides_or_places, GuideType: GuideType }));
    //window.GuidesOrPlaces = newValue;
    dispatch(slice1Actions.setHideSchedule({ value: Hide }));
    if (guides_or_places === "Guides") {
      dispatch(slice1Actions.setHideMap({ value: false }));
      dispatch(slice1Actions.setHidePlaces({ value: false }));
      //setTimeout(() => ShowSelectGuide(), 2000);
    } else {
      dispatch(slice1Actions.resetHomeScreen({ value: null }));
    }
    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
    //setTimeout(updateMap, 1000);
  };

  const ShowSelectGuide = () => {
    console.log("ShowSelectGuide");
    let htmlString = `<div>
    <div style="text-align: center;"><br /><strong><span style="font-size: 220%;">Select guide from List or from map</span></strong></div>
    </div>`;
    window.location.href = "#home-start";
    var homeDiv = document.getElementById("home-content-start");
    if(homeDiv !== null) homeDiv.scrollIntoView();
    dispatch(slice1Actions.setHTMLTitle({ value: "Featured Guides" }));
    dispatch(slice1Actions.setHTMLToSHow({ value: htmlString }));
    dispatch(slice1Actions.setShowHTMLReader({ value: true }));
    window.location.href = "#home-start";
    var homeDiv = document.getElementById("home-content-start");
    if(homeDiv !== null) homeDiv.scrollIntoView();
  };

  const GuidesInMap = () => {
    let newValue = GuidesOrPlaces === "Guides" ? "Places" : "Guides";
    let newType = GuidesOrPlaces === "Guides" ? "None" : GuideType;
    let Hide = newValue === "Guides" ? true : false;
    dispatch(slice1Actions.setGuidesOrPlaces({ value: newValue, GuideType: "Featured" }));
    //window.GuidesOrPlaces = newValue;
    dispatch(slice1Actions.setHideSchedule({ value: Hide }));
    if (newValue === "Guides") {
      dispatch(slice1Actions.setHideMap({ value: false }));
      dispatch(slice1Actions.setHidePlaces({ value: false }));
    }
    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
    //setTimeout(updateMap, 1000);
  };

  const HideShowPlaces = () => {
    dispatch(slice1Actions.setHidePlaces({ value: !HidePlaces }));
  };

  const HideShowSchedule = () => {
    dispatch(slice1Actions.setHidePlaces({ value: !HideSchedule }));
  };

  const HideShowMap = () => {
    dispatch(slice1Actions.setHidePlaces({ value: !HideMap }));
  };

  // const HideShowMap = () => {
  //   dispatch(slice1Actions.setHomeFullScreen({ value: !HomeFullScreen }));
  // };

  // const updateMap = () => {
  //   dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
  // };

  const DownloadGuide = (Category) => {
    setGuideDownloadCategory(Category);
    setGuideDownloadType("read");
    setGuideDownloadMode("download");
    setGuideDownloadShow(true);
  };

  const GuideDownloadCallback = (guide_info_id, guide_id) => {
    //if (GuideDownloadMode === "list") return;
    if (GuideDownloadType === "overwrite") _overWriteGuide(guide_info_id, guide_id);
    else _DownloadGuide(guide_info_id, guide_id);
  };

  const _DownloadGuide = (guide_info_id, guide_id) => {
    console.log("GuideDownloadCallback id:", guide_info_id);
    loadGuide(guide_info_id);

    let _user_info = JSON.parse(JSON.stringify(user_info));
    _user_info.last_guide_id = guide_info_id;
    _user_info.last_guide_time = DateTime.now().toISO({ zone: "utc" });
    dispatch(slice1Actions.setUserInfo({ value: _user_info }));
    let doc_id = user_info_id;
    if(user_info_id === null) doc_id = user_doc_id;
    if(doc_id === null) return;
    DataBase.updateUser(_user_info, doc_id, updateUserCallback);
  };

  const recordLastGuideRead = (guide_info_id) => {
    // Redux user_info, not user_info_retrieved — the latter is a plain `let`
    // reset to null on every render (see readGuideDataReturnNew's comment),
    // so any guide opened after startup was never recorded. Found 2026-10-07.
    const current = user_info_retrieved || user_info;
    if (current == null || current.uid == null || current.uid === "guest") return;
    let doc_id = user_info_id;
    if(user_info_id === null) doc_id = user_doc_id;
    if(doc_id === null) return;
    let _user_info = JSON.parse(JSON.stringify(current));
    _user_info.last_guide_id = guide_info_id;
    _user_info.last_guide_time = DateTime.now().toISO({ zone: "utc" });
    DataBase.updateUser(_user_info, doc_id, updateUserCallback);
  };

  const updateUserCallback = (res) => {
    console.log("updateUserCallback", res.pass);
  };

  const showGuideInfo = () => {
    //setGuideInfoModal(true);
    setGuideEditModalMode("VIEW");
    setGuideEditModalShow(true);
  };

  const EmailGuideLink = () => {
    document.location.href =
      "mailto:?subject=" +
      encodeURIComponent(`Link to guide`) +
      "&body=" +
      encodeURIComponent(
        `Use this link for the web version: ${guideShareLink(guide_meta.guide_info_id)} or download the mobile app`
      );
  };

  const DisplayGuideLink = () => {
    myAlert(`Guide:link: https://andiamoplaces.com?id=${guide_meta.guide_info_id}`);
  };

  const WhatsAppGuideLink = () => {
    const text = encodeURIComponent(
      `Use this link for the web version: ${guideShareLink(guide_meta.guide_info_id)} or download the mobile app`
    );
    window.open(`https://wa.me/?text=${text}`, "_blank");
  };

  const ShareGuideLink = () => {
    const url = guideShareLink(guide_meta.guide_info_id);
    const title = (guide_meta.guide_info && guide_meta.guide_info.guide_name) || "Guide";
    if (navigator.share) {
      navigator.share({ title, text: `Check out this guide: ${title}`, url }).catch(() => {});
    } else {
      setShareLinkShow(true);
    }
  };

  const ImportUploadShareMenu = () => {
    const buildMenuList = (advancedMode) => [
      // ── Import ──────────────────────────────────────────
      {
        label: "Import Trip",
        method: () => { setMenuModalShow(false); setImportTripShow(true); },
        icon: null,
        visible: advancedMode,
        info: "Import a trip from a JSON or CSV file exported by Andiamo Places",
      },
      {
        label: "Import Confirmation Email",
        method: () => { setMenuModalShow(false); setImportConfirmationShow(true); },
        icon: null,
        visible: true, // without Advanced Mode (2026-10-24, matches mobile)
        info: "Paste a flight/train/bus/ferry confirmation email to auto-create schedule events",
      },
      {
        label: "Import Google Maps List",
        method: inputCSVFile,
        icon: null,
        visible: advancedMode,
        info: "Read a Google Maps List (CSV) file and create places from it",
        videoKey: "import-google-maps-list",
      },
      {
        label: "Import Google Timeline",
        method: inputJSONFile,
        icon: null,
        visible: advancedMode,
        info: "Read a Google Timeline (JSON) file and create places from it",
        videoKey: "import-google-timeline",
      },
      {
        label: "Import KML/KMZ/GPX/TCX",
        method: () => inputKmlFile(),
        icon: null,
        visible: advancedMode,
        info: "Read a KML, KMZ, GPX or TCX file and create places from it",
        videoKey: "import-kml-kmz-gpx-and-tcx-files",
      },
      {
        label: "Import Places from Other Guides",
        method: () => { setMenuModalShow(false); window.dispatchEvent(new CustomEvent("addPlacesFromGuides")); },
        icon: null,
        visible: advancedMode,
        info: "Scan your other guides and pick which places to add to this one — duplicates already in this guide are skipped automatically",
      },
      // ── Upload ──────────────────────────────────────────
      {
        label: "Upload Images",
        method: ImageUpload,
        icon: null,
        visible: true,
        info: "Upload images to the cloud so they can be used in guides",
        videoKey: "upload-images",
      },
    ];
    let menuList = buildMenuList(advancedMode);
    if (!advancedMode) {
      const hiddenCount = buildMenuList(true).filter((i) => i.visible).length - menuList.filter((i) => i.visible).length;
      if (hiddenCount > 0) {
        menuList = [
          ...menuList,
          {
            label: `Turn on Advanced Mode to see ${hiddenCount} more option${hiddenCount === 1 ? "" : "s"}`,
            method: () => {
              toggleAdvancedMode();
              setTimeout(() => { if (importUploadShareMenuRef.current) importUploadShareMenuRef.current(); }, 350);
            },
            icon: null,
            visible: true,
            highlight: true,
            info: "Turns on Advanced Mode right away — no account needed.",
          },
        ];
      }
    }
    setMenuModalBackFn(() => MainMenu);
    setMenuModalList(menuList);
    setMenuModalHeading("Import & Upload");
    setMenuModalImage(<FontAwesomeIcon icon={solid("share-nodes")} />);
    setMenuModalPlace(null);
    setMenuModalShow(true);
  };

  const ExportShareMenu  = () => {
    const buildMenuList = (advancedMode) => [
      {
        label: "Export Trip as JSON or CSV",
        method: () => { setMenuModalShow(false); setExportTripShow(true); },
        icon: null,
        visible: advancedMode,
        info: "Export the trip as a JSON or CSV file to your device",
      },
      {
        label: "Export Trip as HTML or PDF",
        method: ExportTripAsHTML,
        icon: null,
        visible: true,
        info: "Download a self-contained interactive HTML page with all trip details",
        videoKey: "export-trip-as-pdf",
      },
      {
        label: "Print Photo Book",
        videoKey: "photo-book",
        method: () => setShowPhotoBookPreview(true),
        icon: null,
        // Remote switch (Common/featureFlags.js) — hidden for 4.7.55.
        visible: isPhotoBookEnabled(),
        // Phase A of the printed-photo-book feature (project plan) —
        // preview only, no ordering/payment yet. Pulls from "Personalize
        // Guide with Photos"'s embedded photos, not a separate upload step.
        // Moved here from Guide Menu, 2026-10-03 — it's an export/output,
        // same bucket as the other "produce a deliverable" items below.
        info: "Preview, arrange and caption a printed photo book from your trip photos and free stock photos (credited on a photo credits page), then order a hardcover copy.",
      },
      {
        label: "Export Trip as Video",
        method: () => { setMenuModalShow(false); setShowExportVideo(true); },
        icon: null,
        visible: advancedMode,
        info: "Create a slideshow video of trip photos with place names and dates",
        videoKey: "export-trip-as-video",
      },
      {
        label: "Export Places as KML",
        method: ExportGuideAsKML,
        icon: null,
        visible: advancedMode,
        info: "Export the places as a KML file to your device",
        videoKey: "export-places-as-kml",
      },
      {
        label: "Display link to this guide",
        method: DisplayGuideLink,
        icon: null,
        // A guide created via createLocalGuide has no cloud doc yet — the
        // link would be a dead "id=null" URL until the guide is saved.
        visible: !!guide_meta.guide_info_id,
        info: "Display the current guide link.",
      },
      {
        label: "Share Link to this Guide",
        method: ShareGuideLink,
        icon: null,
        visible: !!guide_meta.guide_info_id,
        info: "Share the guide link via email, WhatsApp, social media or copy to clipboard",
        videoKey: "share-your-trip-or-travel-journal",
      },
      // {
      //   label: "Export Trip as PDF",
      //   method: ExportTripAsPDF,
      //   icon: null,
      //   visible: GuidesOrPlaces === "Places",
      //   info: "Print or save the trip as a PDF file",
      // },
    ];
    let menuList = buildMenuList(advancedMode);
    if (!advancedMode) {
      const hiddenCount = buildMenuList(true).filter((i) => i.visible).length - menuList.filter((i) => i.visible).length;
      if (hiddenCount > 0) {
        menuList = [
          ...menuList,
          {
            label: `Turn on Advanced Mode to see ${hiddenCount} more option${hiddenCount === 1 ? "" : "s"}`,
            method: () => {
              toggleAdvancedMode();
              setTimeout(() => { if (exportShareMenuRef.current) exportShareMenuRef.current(); }, 350);
            },
            icon: null,
            visible: true,
            highlight: true,
            info: "Turns on Advanced Mode right away — no account needed.",
          },
        ];
      }
    }
    setMenuModalBackFn(() => MainMenu);
    setMenuModalList(menuList);
    setMenuModalHeading("Export & Share");
    setMenuModalImage(<FontAwesomeIcon icon={solid("share-nodes")} />);
    setMenuModalPlace(null);
    setMenuModalShow(true);
  };

  const goTranslate = () => {
    setGuideTranslateShow(true);
  };

  const EditMenu = () => {
    // Parameterized on advancedMode (shadows the outer const inside this
    // function, so every `visible: ... advancedMode ...` expression below is
    // unchanged) so it can be built twice — once for the real state, once
    // forced on — and diffed to count hidden items for the discovery hint
    // appended below (mirrors mobile's MainScreen.js createEditMenu fix).
    const buildMenuList = (advancedMode) => [
      {
        // No longer conditioned on GuidesOrPlaces — the Library takeover
        // panel being open shouldn't hide the primary trip-creation entry
        // point from this menu. Found/fixed 2026-10-05.
        label: "Build My Trip",
        method: newGuide,
        icon: null,
        visible: true,
        info: "Create a new guide and walk through setting a destination, then sourcing and scheduling places — from a live Google Places search by default, or AI suggestions if you want to customize.",
        videoKey: "build-my-trip",
      },
      // "Build Trip from Guides" left this menu 2026-10-20: it's the Guides
      // tile inside Build My Trip (above); still in the command palette.
      {
        // Moved from Import & Upload and renamed from "Import Itinerary
        // from Image or Text" — it hands off to Build My Trip/Build Trip
        // from Places, the same two flows its neighbors here lead to,
        // rather than passively importing into the current guide.
        // Requested 2026-09-26.
        // Admin mode only (2026-10-20): built for itinerary images posted
        // in Facebook groups, which turned out to be mostly ads, some
        // AI-made with errors. Kept for admins; "admin" in the command
        // search unlocks it.
        label: "Build Trip from Image or Text",
        method: () => setImportItineraryImageShow(true),
        icon: null,
        visible: advancedMode && !!window.admin_unlocked,
        info: "Paste text or upload a picture/PDF of an itinerary or Top 10 list to build a trip from it",
      },
      {
        label: "Create Paths w/AI",
        method: () => WalksFromAI(),
        icon: null,
        visible: advancedMode,
        info: "Use artificial intelligence to generate walking tours with paths and points of interest",
        videoKey: "walks-and-paths",
      },
      {
        label: "Create Journal from Photos",
        method: CreateJournalFromPhotos,
        icon: null,
        visible: true, // shown without Advanced Mode (2026-10-24): ad 2 features it, as mobile does
        info: "This will Create a content from photos. First upload photos that have location and date info. Choose a new/current/replaced guide and schedule, then optionally identify each place by name. You can also start from free photos from the web or Wikipedia articles.",
        videoKey: "create-journal-from-photos",
      },
      {
        label: "Start with blank guide",
        method: newGuideManual,
        icon: null,
        visible: true,
        info: "Create a new guide without the setup wizard, for building it manually.",
        videoKey: "blank-create-reload-clear-guide",
      },
      {
        label: "Create a Photo Book",
        method: newPhotoBookGuide,
        icon: null,
        visible: isPhotoBookEnabled(),
        info: "Design a printed book page by page from your own custom pages and photos — from this guide, or a new blank one.",
        videoKey: "photo-book",
      },
      {
        label: "Create copy of this Guide",
        method: copyGuide,
        icon: null,
        visible: true,
        info: "This will make a copy of the current guide and open the new guide. The new guide name will be the current guide name appended with '_C'",
        videoKey: "blank-create-reload-clear-guide",
      },
      {
        // 2026-10-19: every other "Overwrite Guide" entry is in a menu nothing
        // opens (SaveMenu, CreateEditSaveMenu, HomeHeader, MobileHeader), so
        // it was only reachable from How-to. Same place as the app's.
        label: "Overwrite Guide",
        method: overWriteGuide,
        icon: null,
        visible: advancedMode,
        info: "This will overwrite a selected guide with the contents of the current guide. It will preserve the ownership of the overwritten guide.",
      },
      {
        label: "Reload Guide from Cloud",
        method: RefreshGuide,
        icon: null,
        // A guide created via createLocalGuide (guest or signed-in) has no
        // cloud doc yet — guide_info_id is null — so there's nothing to
        // reload; hide rather than let it crash on an empty Firestore path.
        visible: !!guide_meta.guide_info_id,
        info: "Reload the guide from the cloud, overwriting any local changes. Good way to undo all local changes since guide was loaded.",
        videoKey: "blank-create-reload-clear-guide",
      },
      {
        label: "Clear local Guide Content",
        method: clearGuide,
        icon: null,
        visible: true,
        info: "This will clear the current guide. You still need to save the guide to keep your changes",
        videoKey: "blank-create-reload-clear-guide",
      },
      {
        label: "Edit Itinerary",
        method: HTMLEdit,
        icon: null,
        visible: true,
        info: "Edit the main page of the guide. The content is in HTML",
        videoKey: "edit-itinerary-and-notes",
      },
      {
        label: "Edit my Notes",
        method: EditNotes,
        icon: null,
        visible: true,
        info: "Edit the main page of the guide. The content is in HTML",
        videoKey: "edit-itinerary-and-notes",
      },
      {
        label: "Edit Chapters/Sections",
        method: EditSections,
        icon: null,
        visible: advancedMode,
        info: "Edit the secondary pages of the guide, which are organized by chapters. These pages are in HTML and can be linked to from other pages",
        videoKey: "chapters-and-sections",
      },
      {
        // Secondary organizational/taxonomy concept, not needed for core
        // trip planning — gated to match its sibling bulk-edit operations
        // in PlacesHeader.js's Attributes submenu. Found 2026-10-05.
        label: "Edit Groups",
        method: EditGroups,
        icon: null,
        visible: advancedMode,
        info: "Edit the groups of the guide. Groups are used to group places that share a common trait e.g. all places in the same neighborhood",
        videoKey: "groups-and-categories",
      },
      {
        // Same reasoning as Edit Groups above.
        label: "Edit Categories",
        method: EditCategories,
        icon: null,
        visible: advancedMode,
        info: "Edit the categories of the guide. The categories are used to categorize places, e.g. all restaurants that are vegeterian",
        videoKey: "groups-and-categories",
      },
      {
        label: "Create custom Map Markers",
        method: editCustomIcons,
        icon: null,
        visible: advancedMode,
        info: "Edit the custom map markers. You can supply the URL to custom images that you can use for map markers",
        videoKey: "create-custom-map-marker",
      },
      {
        label: "Edit Guide Info",
        method: EditGuideInfo,
        icon: null,
        visible: true,
        info: "Edit the attributes of a guide, e.g. guide name",
        videoKey: "edit-guide-info",
      },
      {
        label: "Translate Guide",
        method: goTranslate,
        icon: null,
        visible: advancedMode,
        info: "Translate the guide content to a different language",
        videoKey: "translate-guide",
      },
      {
        label: "Edit Packing List",
        method: () => setPackingListDialogShow(true),
        icon: null,
        visible: true,
        info: "Manage your packing list — add custom items, check off what's packed",
        videoKey: "packing-list",
      },
      // {
      //   label: "Save Guide to Cloud",
      //   method: SaveGuide,
      //   icon: null,
      //   visible: GuidesOrPlaces === "Places",
      //   info: "Save the current guide to the cloud",
      // },
      // {
      //   label: "Wanderlist",
      //   method: openWanderlist,
      //   icon: null,
      //   visible: true,
      //   info: "Get statistics on continents, countries and cities visited",
      // },
    ];
    let menuList = buildMenuList(advancedMode);
    // Discovery hint: when Basic mode is hiding items, add a row pointing
    // at Settings, tied to the exact moment someone's browsing this menu —
    // mirrors mobile's MainScreen.js createEditMenu fix.
    if (!advancedMode) {
      const hiddenCount = buildMenuList(true).filter((i) => i.visible).length - menuList.filter((i) => i.visible).length;
      if (hiddenCount > 0) {
        menuList = [
          ...menuList,
          {
            label: `Turn on Advanced Mode to see ${hiddenCount} more option${hiddenCount === 1 ? "" : "s"}`,
            method: () => {
              toggleAdvancedMode();
              setTimeout(() => { if (editMenuRef.current) editMenuRef.current(); }, 350);
            },
            icon: null,
            visible: true,
            highlight: true,
            info: "Turns on Advanced Mode right away — no account needed.",
          },
        ];
      }
    }
    setMenuModalBackFn(() => MainMenu);
    setMenuModalList(menuList);
    setMenuModalHeading("Create & Edit");
    setMenuModalImage(<FontAwesomeIcon icon={solid("pencil")} />);
    setMenuModalPlace(null);
    setMenuModalShow(true);
  };

  const EditGroups = () => {
    setGroupsDialogShow(true);
  };

  const EditPlacesOfInterest = () => {
    setPlacesOfInterestShow(true);
  };

  const editCustomIcons = () => {
    setCustomIconsShow(true);
  };

  const EditCategories = () => {
    setCategoriesDialogShow(true);
  };

  const EditSections = () => {
    setSectionsDialogShow(true);
  };

  let _place_operation = "";

  // const SetCategory = () => {
  //   _place_operation = "Category";
  //   myAlert("Add to or replace Category?", "Add or Replace", [
  //     { Title: "Add", Method: _Add },
  //     { Title: "Replace", Method: _Replace },
  //     { Title: "Cancel", Method: null },
  //   ]);
  // };

  // const SetGroup = () => {
  //   _place_operation = "SetGroup";
  //   myAlert("Add to or replace Group?", "Add or Replace", [
  //     { Title: "Add", Method: _Add },
  //     { Title: "Replace", Method: _Replace },
  //     { Title: "Cancel", Method: null },
  //   ]);
  // };

  // let AddReplaceMode = "Add";

  // const _Add = () => {
  //   AddReplaceMode = "Add";
  //   selectPlaces();
  // };

  // const _Replace = () => {
  //   AddReplaceMode = "Replace";
  //   selectPlaces();
  // };

  // const DeletePlaces = () => {
  //   _place_operation = "Delete Places";
  //   selectPlaces();
  // };

  // const EditFavorite = () => {
  //   _place_operation = "Favorite";
  //   selectPlaces();
  // };

  // const EditVisited = () => {
  //   _place_operation = "Visited";
  //   selectPlaces();
  // };

  // const EditMustSee = () => {
  //   _place_operation = "MustSee";
  //   selectPlaces();
  // };

  // const EditHidden = () => {
  //   _place_operation = "Hidden";
  //   selectPlaces();
  // };

  const EditGuideInfo = () => {
    setGuideEditModalMode("UPDATE");
    setGuideEditModalShow(true);
  };

  // const selectPlaces = () => {
  //   let selectedPlaces = [];
  //   let places = window.guide_obj.places.getPlacesToDisplay(null);
  //   let count = 0;
  //   places.forEach((place) => {
  //     if (
  //       (_place_operation === "Favorite" && place.Favorite === true) ||
  //       (_place_operation === "Visited" && place.Visited === true) ||
  //       (_place_operation === "MustSee" && place.MustSee === true) ||
  //       (_place_operation === "Hidden" && place.Hidden === true) ||
  //       _place_operation === "Category" ||
  //       _place_operation === "SetGroup" ||
  //       _place_operation === "Delete Places"
  //     ) {
  //       selectedPlaces.push({
  //         label: place.name,
  //         name: place.name,
  //         value: place.value,
  //       });
  //       count++;
  //     }
  //   });
  //   //console.log("selectedPlaces, count", selectedPlaces, count);
  //   dispatch(slice1Actions.setMultiselectCallback({ value: selectPlacesCallBack }));
  //   dispatch(slice1Actions.setMultiselectItems({ value: places }));
  //   dispatch(slice1Actions.setMultiselectSelectedItems({ value: selectedPlaces }));
  //   dispatch(slice1Actions.setMultiselectMode({ value: "multi" }));
  //   dispatch(slice1Actions.setMultiselectSearchText({ value: "" }));
  //   dispatch(slice1Actions.setShowMultiselect({ value: true }));
  //   // props.navigation.navigate("MultiSelectDialog", {
  //   //   selectionList: places,
  //   //   selectedItems: selectedPlaces,
  //   //   callBack: selectPlacesCallBack,
  //   //   title: "Places",
  //   //   selectText: "Select Places",
  //   // });
  // };

  // let places_selected = [];

  // const selectPlacesCallBack = (Places) => {
  //   if (Places == null) return;
  //   places_selected = Places;
  //   if (_place_operation === "Category") {
  //     if (places_selected.length > 0) setTimeout(selectCategory, 500);
  //     return;
  //   }
  //   if (_place_operation === "SetGroup") {
  //     if (places_selected.length > 0) setTimeout(selectGroup, 500);
  //     return;
  //   }
  //   if (_place_operation === "Delete Places") {
  //     places_selected.forEach((place_id) => {
  //       window.guide_obj.places.deletePlaceById(place_id.value);
  //     });
  //     dispatch(slice1Actions.setGuide({ guide: null }));
  //     return;
  //   }

  //   window.guide_obj.places.setPlaceAttributes(Places, _place_operation);
  //   UpdateDisplay();
  // };

  // const selectCategory = () => {
  //   let _ChooseCategoriesList = window.guide_obj.getCategoriesToDisplay();
  //   // _ChooseCategoriesList.forEach((cat) => {
  //   //   cat.icon = <img src={Place.getItemPOIImage(cat.icon)} />;
  //   // });
  //   dispatch(slice1Actions.setMultiselectCallback({ value: SelectCategoryCallBack }));
  //   dispatch(slice1Actions.setMultiselectItems({ value: _ChooseCategoriesList }));
  //   dispatch(slice1Actions.setMultiselectSelectedItems({ value: [] }));
  //   dispatch(slice1Actions.setMultiselectMode({ value: "uni" }));
  //   dispatch(slice1Actions.setMultiselectSearchText({ value: "" }));
  //   dispatch(slice1Actions.setShowMultiselect({ value: true }));
  // };

  // const SelectCategoryCallBack = (category) => {
  //   places_selected.forEach((place_id) => {
  //     let place = window.guide_obj.places.getPlace(place_id.value);
  //     if (place == null) return;
  //     if (AddReplaceMode === "Add") place.Category.push(category[0].id);
  //     else place.Category = [category[0].id];
  //   });
  //   console.log("SelectCategoryCallBack", places_selected, category);
  //   dispatch(slice1Actions.setGuide({ guide: null }));
  // };

  // const selectGroup = () => {
  //   let _ChooseGroupsList = window.guide_obj.getGroupsToDisplay();
  //   dispatch(slice1Actions.setMultiselectCallback({ value: SelectGroupCallBack }));
  //   dispatch(slice1Actions.setMultiselectItems({ value: _ChooseGroupsList }));
  //   dispatch(slice1Actions.setMultiselectSelectedItems({ value: [] }));
  //   dispatch(slice1Actions.setMultiselectMode({ value: "uni" }));
  //   dispatch(slice1Actions.setMultiselectSearchText({ value: "" }));
  //   dispatch(slice1Actions.setShowMultiselect({ value: true }));
  // };

  // const SelectGroupCallBack = (groups) => {
  //   places_selected.forEach((place_id) => {
  //     let place = window.guide_obj.places.getPlace(place_id.value);
  //     if (place == null) return;
  //     if (AddReplaceMode === "Add") place.Group.push(groups[0].id);
  //     else place.Group = [groups[0].id];
  //   });
  //   console.log("SelectCategoryCallBack", places_selected, groups);
  //   dispatch(slice1Actions.setGuide({ guide: null }));
  // };

  const UpdateDisplay = () => {
    dispatch(slice1Actions.setGuide({ guide: null }));
    if (GuideFormat === "Photo Mosaic" && window.guide_obj) {
      const html = window.guide_obj.createHTMLItinerary("Main", GuideSettings.itinerary, { ...user_info, showHiddenPlaces: ShowHiddenPlaces }, GuideSettings);
      dispatch(slice1Actions.clearHTMLStack());
      dispatch(slice1Actions.setHomeScreen({ value: html }));
    }
  };

  const GuideEditModalCallback = (guide_attributes, edit_mode) => {
    if (edit_mode === true) {
      setGuideEditModalMode("UPDATE");
      setGuideEditModalShow(true);
      return;
    }
    if (GuideEditModalMode === "ADD" && guide_attributes) {
      dispatch(slice1Actions.SetLoadingGuide({ value: true }));
      setTimeout(timeoutFunc, 5000);
      newGuideCallback(guide_attributes);
      return;
    }
    if (GuideEditModalMode === "UPDATE")
      dispatch(slice1Actions.setGuide({ guide: null, update_guide_attributes: true }));
  };

  const InfoMenu = () => {
    const menuList = [
      {
        label: "About",
        method: handleAbout,
        icon: null,
        visible: true,
        info: "List information about this application",
      },
      {
        label: "Help Document",
        method: handleDocumentation,
        icon: null,
        visible: true,
        info: "Show the help document for this app",
      },
      {
        label: "Help Videos",
        method: handleHelpVideos,
        icon: null,
        visible: true,
        info: "View videos that explain how to perform certain functions with the app",
      },
      {
        label: "FAQs",
        method: handleFAQs,
        icon: null,
        visible: true,
        info: "Lists Frequently asked Questions (FAQs) about this app",
      },
      {
        label: "Privacy Policy",
        method: handlePrivacyPolicy,
        icon: null,
        visible: true,
        info: "View our privacy policy",
      },
      {
        label: "Terms of Use",
        method: handleGuidelines,
        icon: null,
        visible: true,
        info: "Lists how users of the app should behave and what is not allowed.",
      },
      {
        label: "Web Site",
        method: WebSite,
        icon: null,
        visible: true,
        info: "Link to our web site",
      },
      {
        label: "Contact Us",
        method: handleContactUs,
        icon: null,
        visible: true,
        info: "Send us an email with questions or bug reports",
      },
    ];
    setMenuModalList(menuList);
    setMenuModalBackFn(() => MainMenu);
    setMenuModalList(menuList);
    setMenuModalHeading("Info Menu");
    setMenuModalImage(<FontAwesomeIcon icon={solid("info")} />);
    setMenuModalPlace(null);
    setMenuModalShow(true);
  };

  function handleAbout() {
    window.open("/Docs/About.html", "_blank");
  }

  function WebSite() {
    const _url = "https://andiamotravelapp.com/";
    let win = window.open(_url, "_blank");
    win.focus();
  }

  function handleHelpVideos() {
    window.open("/Docs/HelpVideosAll.html", "_blank");
  }

  function handleDocumentation() {
    const doc = "/Docs/DocumentationAll.html";
    window.open(doc, "_blank");
  }

  function handleDocumentationOLD() {
    let htmlString = AppSettings.help_document_web;
    //htmlString = urlSchemeToFunctions(htmlString);
    dispatch(slice1Actions.setHTMLTitle({ value: "Creating a Guide" }));
    dispatch(slice1Actions.setHTMLToSHow({ value: htmlString }));
    dispatch(slice1Actions.setShowHTMLReader({ value: true }));
    window.location.href = "#home-start";
    var homeDiv = document.getElementById("home-content-start");
    if(homeDiv !== null) homeDiv.scrollIntoView();
  }

  function handleFAQs() {
    window.open("/Docs/FAQs.html", "_blank");
  }

  function handleGuidelines() {
    window.open("/Docs/terms-of-use.html", "_blank");
  }

  function handleContactUs() {
    window.location.href = "mailto:andiamotravelapp@gmail.com?subject=Feedback&body=";
  }

  function handlePrivacyPolicy() {
    window.open("/Docs/privacy-policy.html", "_blank");
  }

  const CreateEditSaveMenu = () => {
    const menuList = [
      // ── Create ──────────────────────────────────────────
      {
        label: "Build Trip with AI",
        method: () => GuideFromAI(),
        icon: null,
        visible: true,
        info: "Use artificial intelligence to automatically create a trip",
      },
      {
        label: "Create Paths w/AI",
        method: () => WalksFromAI(),
        icon: null,
        visible: true,
        info: "Use artificial intelligence to generate walking tours with paths and points of interest",
        videoKey: "walks-and-paths",
      },
      {
        label: "New Guide",
        method: newGuide,
        icon: null,
        visible: GuideEditMode && GuidesOrPlaces === "Places",
        info: "Create a new guide and open it",
        videoKey: "build-my-trip",
      },
      {
        label: "Copy Guide",
        method: copyGuide,
        icon: null,
        visible: GuideEditMode && GuidesOrPlaces === "Places",
        info: "Make a copy of the current guide and open the new guide",
        videoKey: "blank-create-reload-clear-guide",
      },
      {
        label: "Create Journal from Photos",
        method: CreateJournalFromPhotos,
        icon: null,
        visible: true,
        info: "Create guide content from photos that have location and date info — choose a new/current/replaced guide and schedule, then optionally identify each place by name. You can also start from free photos from the web or Wikipedia articles.",
        videoKey: "create-journal-from-photos",
      },
      // ── Edit ────────────────────────────────────────────
      {
        label: "Edit Home Content",
        method: HTMLEdit,
        icon: null,
        visible: GuidesOrPlaces === "Places",
        info: "Edit the main page of the guide",
        videoKey: "edit-itinerary-and-notes",
      },
      {
        label: "Edit Chapters/Sections",
        method: EditSections,
        icon: null,
        visible: GuidesOrPlaces === "Places",
        info: "Edit the secondary pages of the guide, organised by chapters",
        videoKey: "chapters-and-sections",
      },
      {
        label: "Edit Guide Properties",
        method: EditGuideInfo,
        icon: null,
        visible: GuidesOrPlaces === "Places",
        info: "Edit guide attributes such as name",
        videoKey: "edit-guide-info",
      },
      // ── Save ────────────────────────────────────────────
      {
        label: "Save Guide to Cloud",
        method: SaveGuide,
        icon: null,
        visible: GuidesOrPlaces === "Places",
        info: "Save the current guide to the cloud",
      },
      {
        label: "Save Guide to Device",
        method: writeGuideToFile,
        icon: null,
        visible: GuideEditMode && GuidesOrPlaces === "Places",
        info: "Save the guide as a file to your device",
      },
      {
        label: "Overwrite Guide",
        method: overWriteGuide,
        icon: null,
        visible: GuideEditMode && GuidesOrPlaces === "Places",
        info: "Overwrite a selected guide with the contents of the current guide",
      },
      {
        label: "Clear Guide Content",
        method: clearGuide,
        icon: null,
        visible: GuideEditMode && GuidesOrPlaces === "Places",
        info: "Clear the content of the current guide. Changes are local until you save to cloud",
      },
      // ── Import / Export ─────────────────────────────────
      {
        label: "Export Places as KML",
        method: ExportGuideAsKML,
        icon: null,
        visible: true,
        info: "Export the places as a KML file to your device",
        videoKey: "export-places-as-kml",
      },
      {
        label: "Import KML/KMZ/GPX/TCX",
        method: () => inputKmlFile(),
        icon: null,
        visible: true,
        info: "Read a KML, KMZ, GPX or TCX file and create places from it",
        videoKey: "import-kml-kmz-gpx-and-tcx-files",
      },
      {
        label: "Import Google Maps List",
        method: inputCSVFile,
        icon: null,
        visible: true,
        info: "Read a Google Maps List (CSV) file and create places from it",
        videoKey: "import-google-maps-list",
      },
      {
        label: "Import Google Timeline",
        method: inputJSONFile,
        icon: null,
        visible: true,
        info: "Read a Google Timeline (JSON) file and create places from it",
        videoKey: "import-google-timeline",
      },
      {
        label: "Export Places as KML",
        method: ExportGuideAsKML,
        icon: null,
        visible: true,
        info: "Export the places as a KML file to your device",
        videoKey: "export-places-as-kml",
      },
    ];
    setMenuModalList(menuList);
    setMenuModalHeading("Create & Edit");
    setMenuModalImage(<FontAwesomeIcon icon={solid("floppy-disk")} />);
    setMenuModalPlace(null);
    setMenuModalShow(true);
  };

  const TravelResourcesMenu = () => {
    const menuList = [
      {
        label: "Travel Wizard",
        method: () => setAiDialogShow(true),
        icon: null,
        visible: true,
        info: "Ask the AI any travel question — packing, best time to visit, getting around, food, budgets — or start from a sample question. Uses your trip's destination and dates.",
      },
      {
        label: "Flight Cost Map",
        method: FlightCostMap,
        icon: <FontAwesomeIcon icon={solid("plane-departure")} />,
        visible: true,
        info: "View airfare prices from a location on a map",
      },
      {
        label: "Flight Cost Calendar",
        method: FlightCostCalendar,
        icon: <FontAwesomeIcon icon={solid("calendar-days")} />,
        visible: true,
        info: "View airfare prices by date for a specific route",
      },
      {
        label: "Find Airport Shuttle",
        method: KiwiTaxi,
        icon: null, //<FontAwesomeIcon icon={solid("taxi")} />,
        visible: true,
        info: "Find airport shuttle options",
      },
      {
        label: "Weather",
        method: showWeather,
        icon: <FontAwesomeIcon icon={solid("cloud-sun")} />,
        visible: true,
        info: "View the weather forecast for a destination on this trip",
        videoKey: "weather-and-climate",
      },
      {
        label: "Flight Status",
        method: () => setFlightStatusShow(true),
        icon: <FontAwesomeIcon icon={solid("plane")} />,
        visible: true,
        info: "Track flight status for this trip — saved flights persist with the guide",
        videoKey: "get-flight-status",
      },
      {
        label: "Climate",
        method: showClimate,
        icon: <FontAwesomeIcon icon={solid("temperature-half")} />,
        visible: true,
        info: "See typical monthly high/low temperatures and rainfall for a destination on this trip",
        videoKey: "weather-and-climate",
      },
    ];
    setMenuModalBackFn(() => MainMenu);
    setMenuModalList(menuList);
    setMenuModalHeading("Travel Resources");
    setMenuModalImage(<FontAwesomeIcon icon={solid("plane-departure")} />);
    setMenuModalPlace(null);
    setMenuModalShow(true);
  };

  const MainMenu = () => {
    const menuList = [
      {
        label: "Create & Edit ›",
        method: EditMenu,
        icon: <FontAwesomeIcon icon={solid("pencil")} />,
        visible: GuideEditMode,
        info: "Display the Edit menu",
      },
      {
        label: "Import & Upload ›",
        method: ImportUploadShareMenu,
        icon: <FontAwesomeIcon icon={solid("share-nodes")} />,
        visible: true,
        info: "Import data and upload images",
      },
      {
        label: "Export & Share ›",
        method: ExportShareMenu,
        icon: <FontAwesomeIcon icon={solid("share-nodes")} />,
        visible: true,
        info: "Export data and share guides",
      },
      {
        label: "Guide Menu ›",
        method: GuideMenu,
        icon: <FontAwesomeIcon icon={solid("book-open")} />,
        visible: true,
        info: "Display the Guide menu",
      },
      {
        label: "Collaborate ›",
        method: TripCommunicationMenu,
        icon: <FontAwesomeIcon icon={solid("comments")} />,
        visible: true,
        info: "Discuss the trip, comments, polls, trip members, expenses, and rate the guide",
      },
      {
        label: "Travel Resources ›",
        method: TravelResourcesMenu,
        icon: <FontAwesomeIcon icon={solid("plane-departure")} />,
        visible: true,
        info: "Travel Wizard, flight cost tools, and airport shuttle search",
        videoKey: "travel-wizard",
      },
      // {
      //   label: "Guide Style",
      //   method: GuideStyleMenu,
      //   icon: <FontAwesomeIcon icon={solid("wand-magic-sparkles")} />,
      //   visible: true,
      //   info: "Create guides, change format and style",
      // },
      // {
      //   label: "View",
      //   method: ViewSubMenu,
      //   icon: <FontAwesomeIcon icon={solid("eye")} />,
      //   visible: true,
      //   info: "Display the View menu",
      // },
      // {
      //   label: "Account",
      //   method: UserMenu,
      //   icon: <FontAwesomeIcon icon={solid("user")} />,
      //   visible: true,
      //   info: "Display the Account menu",
      // },
      {
        label: "Info ›",
        method: InfoMenu,
        icon: <FontAwesomeIcon icon={solid("info")} />,
        visible: true,
        info: "Display the Info menu",
      },

      {
        label: "Partner Offers",
        method: purchaseTickets,
        icon: <FontAwesomeIcon icon={solid("ticket")} />,
        visible: true,
        info: "View travel related tickets and partner offers",
      },
      {
        label: "Save Guide to Cloud",
        method: SaveGuide,
        icon: null,
        visible: true,
        info: "Save the current guide to the cloud",
      },
    ];
    setMenuModalBackFn(null);
    setMenuModalList(menuList);
    setMenuModalHeading("Main Menu");
    setMenuModalImage(<FontAwesomeIcon icon={solid("bars")} />);
    setMenuModalPlace(null);
    setMenuModalShow(true);
  };
  
  const FlightCostMap = async () => {
    const response = await fetch('/FlightCostMap.html');
    let htmlString = await response.text();
    // Defaults to the user's home_airport (Settings) when set — the widget's
    // own JS drives the picker off currentOrigin/currentLabel, so overriding
    // those two literals here is enough; the code itself is a valid enough
    // label (matches selectOrigin's own fallback shape).
    const homeAirport = user_info?.home_airport;
    if (homeAirport) {
      htmlString = htmlString
        .replace("var currentOrigin = 'LON';", `var currentOrigin = '${homeAirport}';`)
        .replace("var currentLabel  = 'London (LON)';", `var currentLabel  = '${homeAirport}';`);
    }
    dispatch(slice1Actions.setCurrentAppScreen({ value: "Home" }));
    dispatch(slice1Actions.setHTMLTitle({ value: "Flight Cost" }));
    dispatch(slice1Actions.setHomeScreen({ value: htmlString }));
  };

  const FlightCostCalendar = async () => {
    const response = await fetch('/FlightCostCalendar.html');
    let htmlString = await response.text();
    // Same home_airport default as FlightCostMap above.
    const homeAirport = user_info?.home_airport;
    if (homeAirport) {
      htmlString = htmlString
        .replace("var currentOrigin = 'LAX';", `var currentOrigin = '${homeAirport}';`)
        .replace("var currentLabel  = 'Los Angeles (LAX)';", `var currentLabel  = '${homeAirport}';`);
    }
    // __GUIDE_DESTINATION__ is resolved (city name -> airport code) inside
    // FlightCostCalendar.html itself via resolveCityCode, using the same
    // AIRPORTS table its origin search box already has — this call site
    // just supplies the raw city name. Escape single quotes since this is
    // substituted directly into a 'single-quoted' JS string literal.
    const firstDest = window.guide_obj?.destinations?.[0];
    if (firstDest?.city) {
      htmlString = htmlString.replace("__GUIDE_DESTINATION__", firstDest.city.replace(/'/g, "\\'"));
    }
    dispatch(slice1Actions.setCurrentAppScreen({ value: "Home" }));
    dispatch(slice1Actions.setHTMLTitle({ value: "Flight Cost Calendar" }));
    dispatch(slice1Actions.setHomeScreen({ value: htmlString }));
  };

  const KiwiTaxi = async () => {
    const response = await fetch('/Data/KiwiTaxi.html');
    let htmlString = await response.text();
    // Best-effort default pickup — from= accepts free-text city/airport names
    // (the widget's own autocomplete resolves them, same as a user typing
    // "Paris" and picking Charles de Gaulle themselves), so the guide's first
    // destination's city/country is enough; no IATA code or geocoding needed.
    // No destination just leaves it blank, same as today's behavior.
    const firstDest = window.guide_obj?.destinations?.[0];
    if (firstDest) {
      const from = `${firstDest.city}${firstDest.country ? ", " + firstDest.country : ""}`;
      htmlString = htmlString.replace("from=&", `from=${encodeURIComponent(from)}&`);
    }
    dispatch(slice1Actions.setCurrentAppScreen({ value: "Home" }));
    dispatch(slice1Actions.setHTMLTitle({ value: "Kiwi Taxi" }));
    dispatch(slice1Actions.setHomeScreen({ value: htmlString }));
  };

  // Shared by Weather and Climate — resolves which destination to use, via
  // a picker when there's more than one, and calls onPicked(city, country).
  // Returns true if a destination was found/picking started, false if
  // nothing is set (caller should alert).
  // Shows a picker when `list` has more than one {city,country} entry,
  // calls onPicked directly for exactly one, or returns false for none.
  const pickFromList = (list, pickerTitle, onPicked) => {
    if (list.length > 1) {
      const items = list.map((d, i) => ({
        id: (i + 1).toString(),
        label: [d.city, d.country].filter(Boolean).join(", "),
        name: [d.city, d.country].filter(Boolean).join(", "),
        value: i.toString(),
      }));
      dispatch(slice1Actions.setMultiselectCallback({ value: (sel) => {
        if (sel.length === 0) return;
        onPicked(list[parseInt(sel[0].value)]);
      }}));
      dispatch(slice1Actions.setMultiselectItems({ value: items }));
      dispatch(slice1Actions.setMultiselectSelectedItems({ value: [] }));
      dispatch(slice1Actions.setMultiselectMode({ value: "uni" }));
      dispatch(slice1Actions.setMultiselectSearchText({ value: "" }));
      dispatch(slice1Actions.setMultiselectTitle({ value: pickerTitle }));
      dispatch(slice1Actions.setShowMultiselect({ value: true }));
      return true;
    }
    if (list.length === 1) {
      onPicked(list[0]);
      return true;
    }
    return false;
  };

  const pickDestination = (pickerTitle, onPicked) => {
    // One combined, deduped list — explicit destinations plus every
    // distinct city/country found across the guide's own places (covers day
    // trips to places that were never added as a formal "destination" but
    // still have their own weather/climate), not a tiered fallback.
    const seen = new Set();
    const combined = [];
    const addUnique = (city, country) => {
      city = city || "";
      country = country || "";
      if (!city && !country) return;
      const key = `${city}|${country}`;
      if (seen.has(key)) return;
      seen.add(key);
      combined.push({ city, country });
    };

    (window.guide_obj?.destinations || []).forEach((d) => addUnique(d.city, d.country));
    (window.guide_obj?.places?.placesList || []).forEach((p) => addUnique(p.City, p.Country));

    if (pickFromList(combined, pickerTitle, (d) => onPicked(d.city, d.country))) return true;

    // Ultimate fallback — same city/country KiwiTaxi and WalkAI.js's
    // default form values already use.
    const attrs = window.guide_obj?.attributes;
    const city = attrs?.cities?.[0];
    const country = attrs?.countries?.[0];
    if (city || country) {
      onPicked(city, country);
      return true;
    }

    return false;
  };

  const openWeatherFor = async (city, country) => {
    const parts = [city, country].filter(Boolean);
    if (parts.length === 0) return;
    const fallbackUrl = `https://www.wunderground.com/weather/${encodeURIComponent(parts.join(", "))}`;
    let target = fallbackUrl;
    try {
      // Wunderground also accepts /forecast/<lat>,<lon> directly, which is
      // more precise than its free-text /weather/<query> search — use it
      // when geocoding succeeds, fall back to the text search otherwise.
      const geo = await geocode(city, country);
      if (geo) target = `https://www.wunderground.com/forecast/${geo.lat},${geo.lon}`;
    } catch (_) {
      // keep fallbackUrl
    }
    const win = window.open(target, "_blank");
    if (win) win.focus();
  };

  const showWeather = () => {
    const found = pickDestination("Select Destination", openWeatherFor);
    if (!found) myAlert("No destination is set for this guide yet.", "Weather");
  };

  const showClimate = () => {
    const found = pickDestination("Select Destination", (city, country) => {
      dispatch(slice1Actions.setClimateDialogParams({ value: { city, country } }));
    });
    if (!found) myAlert("No destination is set for this guide yet.", "Climate");
  };

  const updateUIAndHome = () => {
    dispatch(slice1Actions.resetHomeScreen({ value: null }));
    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
  };

  // const updateUI = () => {
  //   dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
  // };

  const updateGuide = () => {
    dispatch(slice1Actions.ClearAllFilters());
    dispatch(slice1Actions.SetSearchText({ value: "" }));
    // dispatch(slice1Actions.SetLoadingGuide({ value: true }));
    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true, update_guide_attributes: true }));
    // setTimeout(dispatch(slice1Actions.SetLoadingGuide({ value: false })), 1000);
    //dispatch(slice1Actions.resetHomeScreen({ value: null }));
  };

  const updateUI = (scheduleName) => {
    if (scheduleName !== null) {
      dispatch(slice1Actions.setScheduleName({ value: scheduleName }));
      dispatch(slice1Actions.SetSchedulesFilter({ value: [{ label: scheduleName }] }));
    }
    dispatch(slice1Actions.ClearAllFilters());
    dispatch(slice1Actions.SetSearchText({ value: "" }));
    dispatch(slice1Actions.resetHomeScreen({ value: null }));
    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
  };

  const SetScheduleName = (scheduleName) => {
    dispatch(slice1Actions.ClearAllFilters());
    dispatch(slice1Actions.setScheduleName({ value: scheduleName }));
    dispatch(slice1Actions.SetSchedulesFilter({ value: [{ label: scheduleName }] }));
    dispatch(slice1Actions.setGuide({ guide: null }));
  };

  const SaveGuide = () => {
    if (PreviewingConflictSnapshot) {
      myAlert("Keep or revert the previewed version (see the banner) before saving.");
      return;
    }
    if (Authorization === AUTHORIZATION_LEVEL.GUEST) {
      myAlert("Cannot save guides in guest mode. You must be registered and logged in.");
      return;
    }
    // Not the owner (e.g. still on the shared sample guide after signing
    // in) but at least COPY-authorized — rather than block with "Not
    // authorized", save it as the signed-in user's own guide instead. Keeps
    // the original name (no "_C" suffix) since this isn't the explicit
    // "Create copy of this Guide" action, just how a save lands when you
    // don't own the guide you're on.
    if (
      window.guide_obj.isAuthorized(Authorization, AUTHORIZATION_LEVEL.MODIFY) === false &&
      window.guide_obj.isAuthorized(Authorization, AUTHORIZATION_LEVEL.COPY) === true
    ) {
      myConfirm("You don't own this guide, so it can't be saved directly. Save it as your own copy instead?", [
        { Title: "OK", Method: () => _saveGuideAsCopy() },
        { Title: "CANCEL", Method: null },
      ]);
      return;
    }
    if (window.guide_obj.isAuthorized(Authorization, AUTHORIZATION_LEVEL.MODIFY) === false) {
      myAlert("Not authorized to save this guide");
      return;
    }
    myConfirm(`Save this Guide: "${window.guide_obj.attributes.guide_name}" to cloud?`, [
      { Title: "OK", Method: () => _saveGuide() },
      { Title: "CANCEL", Method: null },
    ]);
  };

  const _saveGuide = () => {
    setActivityIndicator(true);
    // A guide built locally (createLocalGuide) has guide_id/
    // guide_info_id null — it was never actually written to Firestore, so
    // "modify" (which targets an existing doc via .doc(guide_id)) has
    // nothing to update. Create it instead.
    if (guide_meta.guide_info_id == null || guide_meta.guide_id == null) {
      DataBase.batchedWriteGuide(window.guide_obj, null, null, user_info, "new", saveNewGuideCallback);
      return;
    }
    DataBase.batchedWriteGuide(
      window.guide_obj,
      guide_meta.guide_id,
      guide_meta.guide_info_id,
      user_info,
      "modify",
      batchSaveGuideCallback,
      null,
      null,
      null,
      _expectedMod()
    );
  };

  // attributes.mod is a Luxon DateTime object after a fresh load
  // (decodeAttributes) but a plain ISO string right after a save (see the
  // sync-back in batchSaveGuideCallback) — the conflict check compares
  // against Firestore's raw string, so this always normalizes to a string.
  const _expectedMod = () => {
    const mod = window.guide_obj.attributes.mod;
    if (mod == null) return null;
    return typeof mod === "string" ? mod : mod.toISO();
  };

  // Conflict Phase 1 — see HomeHeader.js's _showSaveConflict for the full
  // design rationale; mirrored here since the bottom nav bar has its own save path.
  const _showSaveConflict = (serverGuideInfo) => {
    setActivityIndicator(false);
    const when = serverGuideInfo?.mod
      ? DateTime.fromISO(serverGuideInfo.mod).toLocaleString(DateTime.DATETIME_MED)
      : "just now";
    // owner_name is the guide's OWNER, not necessarily who made this write —
    // a MODIFY-level collaborator could be the one who saved. last_modified_by
    // (a uid, stamped on every save) is the accurate source; look up that
    // user's email (names are optional and often blank).
    if (serverGuideInfo?.last_modified_by) {
      User.findUserByUID(serverGuideInfo.last_modified_by, (res) => {
        const fullName = res?.pass === true ? `${res.res.first_name || ""} ${res.res.last_name || ""}`.trim() : "";
        const who = fullName || (res?.pass === true ? res.res.email : "") || "Someone";
        _showSaveConflictDialog(serverGuideInfo, who, when);
      });
    } else {
      _showSaveConflictDialog(serverGuideInfo, serverGuideInfo?.owner_name || "Someone", when);
    }
  };

  const _showSaveConflictDialog = (serverGuideInfo, who, when) => {
    myConfirm(
      `${who} saved changes to "${serverGuideInfo?.guide_name || window.guide_obj.attributes.guide_name}" at ${when}, after you last loaded it. Your unsaved changes would overwrite theirs if you save now.`,
      [
        {
          Title: "Write Anyway",
          Method: () => _saveGuideWithExpectedMod(serverGuideInfo?.mod),
        },
        {
          Title: "View Changes",
          Method: () => {
            setDiffModalConflict({ serverGuideInfo, who, when });
            setDiffModalShow(true);
          },
        },
        {
          Title: "View Latest Version",
          // Unlike "Load Their Version" below, nothing is discarded —
          // stashed first so the global ConflictPreviewBanner's "Revert to
          // my copy" can restore it. Mirrors HomeHeader.js's identical
          // addition — the bottom nav bar has its own save path. See the
          // purring-humming-mountain plan. This file's loadGuide already
          // takes an afterLoad callback (now passed the load's success
          // status) for an unrelated earlier use — reused here rather than
          // adding a second callback mechanism.
          Method: () => {
            stashConflictSnapshot(guide_meta.guide_id);
            loadGuide(guide_meta.guide_info_id, (success) => {
              if (success) dispatch(slice1Actions.setPreviewingConflictSnapshot({ value: true }));
            });
          },
        },
        {
          Title: "Load Their Version",
          // Deferred for the same reason as the old "View Their Version"
          // fix — nesting a myConfirm inside this dialog's own button click
          // would otherwise get clobbered by AlertModal's onHide() firing
          // right after Method() in the same batched update.
          Method: () =>
            setTimeout(
              () =>
                myConfirm("Loading their version will discard your unsaved changes to this guide. Continue?", [
                  { Title: "OK", Method: () => loadGuide(guide_meta.guide_info_id) },
                  { Title: "Cancel", Method: null },
                ]),
              0
            ),
        },
        { Title: "Cancel", Method: null },
      ]
    );
  };

  // "View Changes" closes this myConfirm to open the separate diff modal —
  // when that modal closes, bring the same conflict decision back up rather
  // than silently dropping the user with no way back to Write Anyway/Load.
  const _reopenConflictDialogFromDiff = () => {
    setDiffModalShow(false);
    if (diffModalConflict) {
      setTimeout(
        () => _showSaveConflictDialog(diffModalConflict.serverGuideInfo, diffModalConflict.who, diffModalConflict.when),
        0
      );
    }
  };

  const _saveGuideWithExpectedMod = (expectedMod) => {
    setActivityIndicator(true);
    DataBase.batchedWriteGuide(
      window.guide_obj,
      guide_meta.guide_id,
      guide_meta.guide_info_id,
      user_info,
      "modify",
      batchSaveGuideCallback,
      null,
      null,
      null,
      expectedMod
    );
  };

  // Same content as the "Create copy of this Guide" action, but keeps the
  // original name (keepOriginalName) and swaps the app over to the new copy
  // afterward, since this is standing in for a failed save rather than an
  // explicit, separate "make a copy" action.
  const _saveGuideAsCopy = () => {
    setActivityIndicator(true);
    DataBase.batchedWriteGuide(window.guide_obj, null, null, user_info, "copy", saveGuideAsCopyCallback, undefined, undefined, true);
  };

  const saveGuideAsCopyCallback = (res) => {
    setActivityIndicator(false);
    if (res.pass !== true) {
      myAlert("Could not save this guide as your own copy.");
      return;
    }
    // Same reasoning as saveNewGuideCallback — this creates a brand-new
    // cloud guide too (standing in for a failed regular save).
    window.record_last_guide_read = true;
    DataBase.readGuideTransaction(res.new_info_ref.id, readGuideDataReturnNew, user_info.uid);
    myAlert("Saved as your own copy of this guide.");
  };

  const saveNewGuideCallback = (res) => {
    setActivityIndicator(false);
    if (res.pass !== true) {
      myAlert(res.tooLarge ? res.res : "Error saving guide");
      return;
    }
    // This is the guide's first real save (promoted from a local-only
    // createLocalGuide draft to a real cloud doc) — the moment it becomes
    // "a guide" the app should remember returning to, same as any other
    // newly-created guide (createNewGuideForAI/Copy Guide already do this).
    window.record_last_guide_read = true;
    DataBase.readGuideTransaction(res.new_info_ref.id, readGuideDataReturnNew, user_info.uid);
    dispatch(slice1Actions.setGuideHasUnsavedChanges({ value: false }));
    myAlert(`Guide "${window.guide_obj.attributes.guide_name}" saved in cloud.${leftoverNamesNote(window.guide_obj)}${res?.sizeWarning ? `\n\n${res.sizeWarning}` : ""}`);
  };

  const batchSaveGuideCallback = (res) => {
    setActivityIndicator(false);
    if (res.pass !== true) {
      if (res.conflict) {
        _showSaveConflict(res.serverGuideInfo);
        return;
      }
      //console.log("batchSaveGuideCallback: Error saving guide", res);
      myAlert(res.tooLarge ? res.res : "Error saving guide");
      return;
    }
    if (res.new_mod) window.guide_obj.attributes.mod = res.new_mod;
    // Reflect the save in the cached Mine/Featured list immediately, instead of
    // leaving it stale until the next cloud re-fetch of that list.
    const attrs = window.guide_obj.attributes;
    const patch = {
      guide_name: attrs.guide_name,
      description: attrs.description,
      language: attrs.language,
      countries: attrs.countries,
      cities: attrs.cities,
      mod: DateTime.utc().toISO(),
    };
    if (GuideType === "Featured") {
      dispatch(slice1Actions.setGuideInfoArray({
        value: Common.patchGuideInfoEntry(GuideInfoArray, guide_meta.guide_info_id, patch),
      }));
    } else {
      dispatch(slice1Actions.setGuideInfoArrayMine({
        value: Common.patchGuideInfoEntry(GuideInfoArrayMine, guide_meta.guide_info_id, patch),
      }));
    }
    dispatch(slice1Actions.setGuideHasUnsavedChanges({ value: false }));
    const guideSizeKB = (JSON.stringify(window.guide_obj).length / 1024).toFixed(1);
    myAlert(`Guide "${window.guide_obj.attributes.guide_name}" saved in cloud (${guideSizeKB} KB).${leftoverNamesNote(window.guide_obj)}${res?.sizeWarning ? `\n\n${res.sizeWarning}` : ""}`);
  };

  const showUserInfoModal = () => {
    setUserInfoModal(true);
  };

  const bookColor = () => {
    //console.log("Authorization", Authorization);
    if (user_info.uid === "guest") return COLORS.GRAY;
    if (Authorization === AUTHORIZATION_LEVEL.MODIFY) return COLORS.GREEN;
    else if (Authorization === AUTHORIZATION_LEVEL.COPY) return COLORS.YELLOW;
    else if (Authorization === AUTHORIZATION_LEVEL.READ) return COLORS.ORANGE;
    else if (Authorization === AUTHORIZATION_LEVEL.GUEST) return COLORS.GRAY;
    else return COLORS.GRAY;
  };

  const modeColor = () => {
    if (GuideSettings.mode === "edit") return COLORS.GREEN;
    else if (GuideSettings.mode === "view") return COLORS.YELLOW;
    else if (GuideSettings.mode === "custom_view") return COLORS.ORANGE;
    else return COLORS.GRAY;
  };

  const userColor = () => {
    if (user_info.uid === "guest") return COLORS.GRAY;
    if (Authorization === AUTHORIZATION_LEVEL.GUEST) return COLORS.GRAY;
    return COLORS.GREEN;
  };
  const hideMenuModal = () => {
    dispatch(slice1Actions.setMenuModalArgs({ value: { ...MenuModalArgs, Show: false } }));
  };
  const showMap = () => {
    dispatch(slice1Actions.setHideMap({ value: !HideMap }));
    setTimeout(fitPlaces, 1000);
  };

  const showSideMenu = () => {
    dispatch(slice1Actions.setHideSideMenu({ value: !HideSideMenu }));
  };
  const showHome = () => {
    dispatch(slice1Actions.setHideHome({ value: !HideHome }));
    setTimeout(fitPlaces, 1000);
  };
  let local_image_folder = null;
  const setImageFolder = (folder) => {
    local_image_folder = folder;
    dispatch(slice1Actions.setImageFolder({ value: folder }));
  };

  //console.log("******************Authorization", Authorization, user_info, bookColor(), userColor());

  // Navigates to a screen (Places/Map/Schedule) then asks that screen's own
  // header to open its menu, via a window CustomEvent. Needed because
  // Place/Map/Schedule menus live in separate components the palette can't
  // call into directly — see rec #4's "navigate + open menu" tier in
  // usability-recommendations.md.
  const navigateAndOpenMenu = (screen, eventName) => {
    if (GuidesOrPlaces !== "Places") {
      dispatch(slice1Actions.setGuidesOrPlaces({ value: "Places", GuideType: "None" }));
    }
    dispatch(slice1Actions.setCurrentAppScreen({ value: screen }));
    setTimeout(() => window.dispatchEvent(new CustomEvent(eventName)), 350);
  };

  // Literal search over the app's actions — usability-recommendations.md rec #4.
  // Reuses the same handler functions the (advanced-mode-gated) menus already call; the
  // "advanced" flag here mirrors that same classification so Basic-mode users don't find
  // advanced-only actions through the palette either. This is a full audit of every
  // active (non-dead) menu reachable from this component, plus "navigate + open menu"
  // entries for the Places/Map/Schedule menu items that live in other components
  // (cross-checked directly against every feature bullet in public/Docs/About.html).
  // Opens the schedule header's "Copy to Trip Itinerary" dialog. In mobile mode
  // that header only exists on the Schedule screen, so go there first.
  const openItineraryFromSchedule = () => {
    const fire = () => window.dispatchEvent(new CustomEvent("andiamo-open-itinerary-copy"));
    if (MobileMode) {
      dispatch(slice1Actions.setCurrentAppScreen({ value: "Schedule" }));
      setTimeout(fire, 400);
    } else fire();
  };
  // Also offered after renaming a place (RenameFollowUpModal).
  window.openItineraryFromSchedule = openItineraryFromSchedule;

  const webPhotoGroupDialog = webPhotoGroupChoice ? (
    <Modal show centered size="sm" onHide={() => setWebPhotoGroupChoice(null)}>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 18 }}>
          Add {webPhotoGroupChoice.places.length} place{webPhotoGroupChoice.places.length === 1 ? "" : "s"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <label style={{ display: "flex", gap: 8, alignItems: "center", cursor: "pointer", marginBottom: 8 }}>
          <input type="checkbox" checked={webPhotoGroupChoice.useGroup}
            onChange={(e) => setWebPhotoGroupChoice({ ...webPhotoGroupChoice, useGroup: e.target.checked })} />
          Put them in a group
        </label>
        <input className="form-control" value={webPhotoGroupChoice.name} disabled={!webPhotoGroupChoice.useGroup}
          placeholder="Group name" onChange={(e) => setWebPhotoGroupChoice({ ...webPhotoGroupChoice, name: e.target.value })} />
        {/* Visited (2026-10-23, matches mobile): off by default here — a web
            photo or an article isn't a sign the user went there. */}
        <label style={{ display: "flex", gap: 8, alignItems: "center", cursor: "pointer", marginTop: 12 }}>
          <input type="checkbox" checked={!!webPhotoGroupChoice.markVisited}
            onChange={(e) => setWebPhotoGroupChoice({ ...webPhotoGroupChoice, markVisited: e.target.checked })} />
          Mark them as visited
        </label>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-outline-secondary btn-sm" onClick={() => setWebPhotoGroupChoice(null)}>Cancel</button>
        <button className="btn btn-primary btn-sm" onClick={() => {
          const c = webPhotoGroupChoice;
          setWebPhotoGroupChoice(null);
          _addPhotoPlaces(c.places, c.kind || "photo", c.topic, { useGroup: c.useGroup && !!c.name.trim(), name: c.name.trim(), markVisited: !!c.markVisited });
        }}>Add</button>
      </Modal.Footer>
    </Modal>
  ) : null;

  const commandPaletteCommands = [
    // ── Create & Edit (EditMenu) — gated behind GuideEditMode, same as the real menu ──
    { label: "Browse Featured Guides", method: () => ShowGuidesOrGuide("Guides", "Featured"), info: "Use and personalize any of the hundreds of existing guides for your trip", advanced: false, visible: MobileMode, videoKey: "personalize-existing-guides" },
    { label: "Build Trip with AI", method: () => { setBuildMyTripAutoOpenAI(true); newGuide(); }, info: "(Formerly Create Trip w/AI.) AI chooses the places for your preferences; the schedule is built around their opening hours. Also in Build My Trip as the AI source.", advanced: false, visible: GuideEditMode, videoKey: "create-trip-with-ai" },
    { label: "Build Trip from Guides", method: () => { setBuildMyTripFromGuides(true); newGuide(); }, info: "Combine guides into one trip: choose destinations, then take each one's places from an existing guide (yours or Featured) instead of a search. Opens Build My Trip with \"Guides\" selected.", advanced: false, visible: GuideEditMode },
    { label: "Build My Trip", method: newGuide, info: "Create or add to a trip: places from a search, this guide's places, other guides, or AI — review them if you like — then a schedule around opening hours. Can overwrite a schedule.", advanced: false, visible: GuideEditMode, videoKey: "build-my-trip" },
    { label: "Describe Your Trip (type or speak)", method: newGuide, info: "Say or type the trip in your own words; destinations, dates and preferences are filled in. Opens Build My Trip — tap Describe your trip at the top.", advanced: false, visible: GuideEditMode },
    { label: "Build Trip from Image or Text", method: () => setImportItineraryImageShow(true), info: "(Formerly Create Trip / Import Itinerary from Image or Text.) Paste text or upload a picture/PDF of an itinerary or Top 10 list to build a trip from it", advanced: true, visible: GuideEditMode && !!window.admin_unlocked },
    { label: "Destinations", method: () => setShowDestinations(true), info: "View or edit this guide's destinations — add/remove/reorder, paste as text, derive from the schedule, or import from a confirmation email; independent of Build My Trip/Build Trip with AI", advanced: false, visible: GuideEditMode, videoKey: "destinations-and-preferences" },
    { label: "Preferences", method: () => setShowPreferences(true), info: "Trip type, focus, activities, budget, pace, transportation, and proximity — used by both Destinations from AI and Build Trip with AI", advanced: false, visible: GuideEditMode, videoKey: "destinations-and-preferences" },
    { label: "Start with blank guide", method: newGuideManual, info: "Create a new guide without the setup wizard", advanced: false, visible: GuideEditMode, videoKey: "blank-create-reload-clear-guide" },
    { label: "Create a Photo Book", method: newPhotoBookGuide, info: "Design a printed book page by page from your own custom pages and photos — from this guide, or a new blank one.", advanced: false, visible: isPhotoBookEnabled(), videoKey: "photo-book" },
    { label: "Edit Itinerary", method: HTMLEdit, info: "Edit the main page of the guide", advanced: false, visible: GuideEditMode, videoKey: "edit-itinerary-and-notes" },
    { label: "Edit my Notes", method: EditNotes, info: "Edit the guide notes", advanced: false, visible: GuideEditMode, videoKey: "edit-itinerary-and-notes" },
    { label: "Update Itinerary from Schedule", method: openItineraryFromSchedule, info: "Rebuild the guide's itinerary page from the selected schedule, with an optional cover image — also under Edit > Update Itinerary from Schedule", advanced: false, visible: GuideEditMode, videoKey: "edit-itinerary-and-notes" },
    { label: "Copy to Trip Itinerary", method: openItineraryFromSchedule, info: "Copy the selected schedule to the trip itinerary page (same as Update Itinerary from Schedule)", advanced: false, visible: GuideEditMode },
    { label: "Edit Groups", method: EditGroups, info: "Edit the groups used to group places", advanced: true, visible: GuideEditMode, videoKey: "groups-and-categories" },
    { label: "Edit Categories", method: EditCategories, info: "Edit the categories used to categorize places", advanced: true, visible: GuideEditMode, videoKey: "groups-and-categories" },
    { label: "Edit Guide Info", method: EditGuideInfo, info: "Edit guide attributes such as name", advanced: false, visible: GuideEditMode, videoKey: "edit-guide-info" },
    { label: "Allow Others to Modify your Trip", method: EditGuideInfo, info: "Grant Modify access to other users, from Edit Guide Info's Sharing section", advanced: false, visible: GuideEditMode, videoKey: "allow-others-to-modify-or-copy-your-guide" },
    { label: "Allow Others to Copy your Trip", method: EditGuideInfo, info: "Grant Copy access to other users, from Edit Guide Info's Sharing section", advanced: false, visible: GuideEditMode, videoKey: "allow-others-to-modify-or-copy-your-guide" },
    { label: "Edit Packing List", method: () => setPackingListDialogShow(true), info: "Manage your packing list — add custom items, check off what's packed", advanced: false, visible: GuideEditMode, videoKey: "packing-list" },
    { label: "Create Paths w/AI", method: WalksFromAI, info: "Use AI to create walks, walking tours, bike routes or hikes with paths and points of interest", advanced: true, visible: GuideEditMode, videoKey: "walks-and-paths" },
    { label: "Create Journal from Photos", method: CreateJournalFromPhotos, info: "Create guide content from photos that have location and date info — choose a new/current/replaced guide and schedule, then optionally identify each place by name via Wikipedia or its resolved city, one at a time or all at once — or start from free photos from the web or Wikipedia articles, each becoming a place", advanced: false, visible: GuideEditMode, videoKey: "create-journal-from-photos" },
    { label: "Create copy of this Guide", method: copyGuide, info: "Make a copy of the current guide and open the new guide", advanced: false, visible: GuideEditMode, videoKey: "blank-create-reload-clear-guide" },
    { label: "Reload Guide from Cloud", method: RefreshGuide, info: "Reload the guide from the cloud, overwriting any local changes", advanced: false, visible: GuideEditMode && !!guide_meta.guide_info_id, videoKey: "blank-create-reload-clear-guide" },
    { label: "Clear local Guide Content", method: clearGuide, info: "Clear the current guide's local content", advanced: false, visible: GuideEditMode, videoKey: "blank-create-reload-clear-guide" },
    { label: "Edit Chapters/Sections", method: EditSections, info: "Edit the secondary pages of the guide, organized by chapters", advanced: true, visible: GuideEditMode, videoKey: "chapters-and-sections" },
    { label: "Create custom Map Markers", method: editCustomIcons, info: "Supply URLs for custom map marker images", advanced: true, visible: GuideEditMode, videoKey: "create-custom-map-marker" },
    { label: "Translate Guide", method: goTranslate, info: "Translate the guide content to a different language", advanced: true, visible: GuideEditMode, videoKey: "translate-guide" },

    // ── Import & Upload ──
    { label: "Upload Images", method: ImageUpload, info: "Upload images to the cloud so they can be used in guides", advanced: false, videoKey: "upload-images" },
    { label: "Import Trip", method: () => setImportTripShow(true), info: "Import a trip from a JSON or CSV file exported by Andiamo Places", advanced: true, videoKey: "export-import-trip-from-json-or-csv" },
    { label: "Import Confirmation Email", method: () => setImportConfirmationShow(true), info: "Paste a flight/train/bus/ferry confirmation email to auto-create schedule events", advanced: false, videoKey: "import-confirmation-email-pdf-or-photo" },
    { label: "Import Google Maps List", method: inputCSVFile, info: "Read a Google Maps List (CSV) file and create places from it", advanced: true, videoKey: "import-google-maps-list" },
    { label: "Import Google Timeline", method: inputJSONFile, info: "Read a Google Timeline (JSON) file and create places from it", advanced: true, videoKey: "import-google-timeline" },
    { label: "Import KML/KMZ/GPX/TCX", method: () => inputKmlFile(), info: "Read a KML, KMZ, GPX or TCX file and create places from it", advanced: true, videoKey: "import-kml-kmz-gpx-and-tcx-files" },
    { label: "Import Places from Other Guides", method: () => window.dispatchEvent(new CustomEvent("addPlacesFromGuides")), info: "Scan your other guides and pick which places to add to this one", advanced: true, videoKey: "import-from-other-guides" },

    // ── Export & Share ──
    { label: "Export Trip as HTML or PDF", method: ExportTripAsHTML, info: "Download a self-contained interactive HTML page with all trip details", advanced: false, visible: true, videoKey: "export-trip-as-pdf" },
    { label: "Print Photo Book", method: () => setShowPhotoBookPreview(true), info: "Preview, arrange and caption a printed photo book from your trip photos and free stock photos (credited on a photo credits page), then order a hardcover copy.", advanced: false, visible: isPhotoBookEnabled(), videoKey: "photo-book" },
    { label: "Display link to this guide", method: DisplayGuideLink, info: "Display the current guide link", advanced: false, visible: !!guide_meta.guide_info_id },
    { label: "Share Link to this Guide", method: ShareGuideLink, info: "Share the guide link via email, WhatsApp, social media or copy to clipboard", advanced: false, visible: !!guide_meta.guide_info_id, videoKey: "share-your-trip-or-travel-journal" },
    { label: "Export Trip as JSON or CSV", method: () => setExportTripShow(true), info: "Export the trip as a JSON or CSV file to your device", advanced: true, visible: true, videoKey: "export-import-trip-from-json-or-csv" },
    { label: "Export Trip as Video", method: () => setShowExportVideo(true), info: "Create a slideshow video of trip photos with place names and dates", advanced: true, visible: true, videoKey: "export-trip-as-video" },
    { label: "Export Places as KML", method: ExportGuideAsKML, info: "Export the places as a KML file to your device", advanced: true, videoKey: "export-places-as-kml" },

    // ── Guide Menu ──
    { label: "Guide Settings", method: setGuideSettings, info: "Interaction Behavior (Default/Custom click handling), Guide Mode, day hours, schedules as separate plans, and other guide-wide settings", advanced: false, videoKey: "guide-settings" },
    { label: "View Itinerary", method: ViewHomeContent, info: "View the main page of the guide", advanced: false, videoKey: "edit-itinerary-and-notes" },
    { label: "View my Notes", method: ViewGuideNotes, info: "View the guide notes", advanced: false },
    { label: "View Guide Info", method: showGuideInfo, info: "Display the properties of the guide, e.g. name", advanced: false },
    { label: "Previous Guide", method: PreviousGuide, info: "Go back to the previously loaded guide", advanced: false, visible: GuideStack.length > 1 },

    // ── Collaborate ──
    { label: "Trip Discussion", method: () => setShowGuideDiscussion(true), info: "Discuss the trip as a whole with your collaborators — not tied to any one place or event.", advanced: false },
    { label: "Comments", method: () => setShowCommentsList(true), info: "See every comment left on this guide's places and events, and jump straight to any of them.", advanced: false, videoKey: "comments" },
    { label: "Polls", method: () => setShowPolls(true), info: "Create a quick poll for your travel companions to vote on — e.g. which restaurant, which day to visit somewhere.", advanced: false, videoKey: "polls" },
    { label: "Trip Members", method: () => setShowTripMembers(true), info: "Keep a record of who's on this trip — a lightweight roster (just names, not app accounts) used to split expenses, plus a running history of who paid/owes what.", advanced: false },
    { label: "Expenses", method: () => setShowExpenses(true), info: "Track trip expenses, split costs among trip members by percentage, and see each person's running balance.", advanced: false, videoKey: "expense-tracking" },
    { label: "Rate this Guide", method: ReviewGuide, info: "Rate the current guide", advanced: true, visible: true },
    { label: "Report this Guide", method: openReportGuide, info: "Report a guide someone else made that has sexual, violent, hateful or spam content. Only the Andiamo team sees reports.", advanced: false, visible: canReportGuide(guide_meta, user_info) },

    // ── Save ──
    { label: "Save Guide to Cloud", method: SaveGuide, info: "Save the current guide to the cloud", advanced: false, visible: true },
    { label: "Overwrite Guide", method: overWriteGuide, info: "Overwrite a selected guide with the contents of the current guide", advanced: true, visible: GuideEditMode },

    // ── Wanderlist / Stats ──
    { label: "Wanderlist / Trip Statistics", method: getGuideStatistics, info: "See statistics on the places, countries and continents in this trip", advanced: false, videoKey: "trip-statistics" },

    // ── User Menu ──
    { label: "Settings", method: showSettingsDialog, info: "Change the settings for this app", advanced: false },
    { label: "User Details", method: showUserInfoModal, info: "Display the details of the logged in user, e.g. name, id etc.", advanced: false },
    { label: "Reset Password", method: resetPassword, info: "Reset the password — an email will be sent to allow you to reset it", advanced: false },
    { label: "Sign In", method: showLogin, info: "Login to this app", advanced: false, visible: user_info.uid === null || user_info.uid === "guest" || Authorization === AUTHORIZATION_LEVEL.GUEST },
    { label: "Register", method: Register, info: "Register for the app — free of charge, required before you can log in", advanced: false, visible: user_info.uid === null || user_info.uid === "guest" || Authorization === AUTHORIZATION_LEVEL.GUEST },
    { label: "Sign Out", method: logout, info: "Log out from this app", advanced: false, visible: user_info.uid !== null && user_info.uid !== "guest" && Authorization !== AUTHORIZATION_LEVEL.GUEST },
    {
      label: "Travel Documents",
      method: () => {
        dispatch(slice1Actions.setGuidesOrPlaces({ value: "You", GuideType: "None" }));
        setTimeout(() => window.dispatchEvent(new CustomEvent("openTravelersDialog")), 350);
      },
      info: "Manage travel companions and their passport, visa, insurance, and other documents",
      advanced: true,
      visible: user_info.uid !== null && user_info.uid !== "guest" && Authorization !== AUTHORIZATION_LEVEL.GUEST,
      videoKey: "travel-documents",
    },

    // ── Travel Resources (Main Menu direct items) ──
    { label: "Travel Wizard", method: () => setAiDialogShow(true), info: "Ask the AI any travel question — packing, best time to visit, getting around, food, budgets — or start from a sample question. Uses your trip's destination and dates.", advanced: false, videoKey: "travel-wizard" },
    { label: "Flight Cost Map", method: FlightCostMap, info: "View airfare prices from a location on a map", advanced: false },
    { label: "Flight Cost Calendar", method: FlightCostCalendar, info: "View airfare prices by date for a specific route", advanced: false },
    { label: "Find Airport Shuttle", method: KiwiTaxi, info: "Find airport shuttle options", advanced: false },
    { label: "Weather", method: showWeather, info: "See the weather forecast for a destination on this trip", advanced: false, videoKey: "weather-and-climate" },
    { label: "Climate", method: showClimate, info: "See typical monthly high/low temperatures and rainfall for a destination on this trip", advanced: false, videoKey: "weather-and-climate" },
    { label: "Flight Status", method: () => setFlightStatusShow(true), info: "Track flight status for this trip — saved flights persist with the guide", advanced: false, videoKey: "get-flight-status" },
    { label: "Partner Offers", method: purchaseTickets, info: "View travel related tickets and partner offers", advanced: false },

    // ── Info Menu ──
    { label: "About", method: handleAbout, info: "List information about this application", advanced: false },
    { label: "Help Document", method: handleDocumentation, info: "Show the help document for this app", advanced: false },
    { label: "Help Videos", method: handleHelpVideos, info: "View videos that explain how to perform certain functions with the app", advanced: false },
    { label: "FAQs", method: handleFAQs, info: "Lists Frequently asked Questions (FAQs) about this app", advanced: false },
    { label: "Privacy Policy", method: handlePrivacyPolicy, info: "View our privacy policy", advanced: false },
    { label: "Terms of Use", method: handleGuidelines, info: "Lists how users of the app should behave and what is not allowed", advanced: false },
    { label: "Web Site", method: WebSite, info: "Link to our web site", advanced: false },
    { label: "Contact Us", method: handleContactUs, info: "Send us an email with questions or bug reports", advanced: false },

    // ── Place / Map / Schedule menus — separate components, so these navigate there
    // and open that screen's own menu rather than executing an item directly. The
    // aliases below are worded the way a new user would actually search, rather than
    // the menu's internal item name — each mirrors the "advanced" flag of the real
    // item it leads to, so it doesn't promise something Basic mode won't show.
    { label: "Places Menu", method: () => navigateAndOpenMenu("Places", "openPlacesMenu"), info: "Bulk edit, delete, and manage place content & attributes", advanced: false, nav: true },
    { label: "Add a Place", method: () => navigateAndOpenMenu("Places", "openPlacesMenu"), info: "Add one or more places to your guide, from the Places menu", advanced: false, nav: true, videoKey: "add-places" },
    { label: "Delete a Place", method: () => navigateAndOpenMenu("Places", "openPlacesMenu"), info: "Select which places to delete, from the Places menu", advanced: true, nav: true },
    { label: "Build Trip from Places", method: () => navigateAndOpenMenu("Places", "openPlacesMenu"), info: "Build a trip from this guide's own places: choose them in a list with photos, check the destinations' dates, and overwrite or add to a schedule. Opens Build My Trip from the Places menu.", advanced: false, nav: true, videoKey: "build-trip-from-places" },
    { label: "AI Search", method: () => navigateAndOpenMenu("Places", "openPlacesMenu"), info: "Find places with AI: describe what you want (e.g. romantic restaurants with a view) or pick a sample query, then add the results to your guide.", advanced: false, nav: true, videoKey: "ai-search" },
    { label: "Search from Map", method: () => navigateAndOpenMenu("Places", "openPlacesMenu"), info: "Open the Map screen's Search menu for location-based search options, from the Places menu", advanced: false, nav: true },
    { label: "Refresh Photos", method: () => navigateAndOpenMenu("Places", "openPlacesMenu"), info: "Repair broken/missing photos only, or force a fresh search for every selected place regardless of its current photo — you'll be asked which, from the Places menu Uses only public-domain / CC0 images, so nothing needs a credit.", advanced: false, nav: true, videoKey: "refresh-photos" },
    { label: "Clear Photos", method: () => navigateAndOpenMenu("Places", "openPlacesMenu"), info: "Remove the photo from selected places and show the default image instead — for clearly wrong photos, from the Places menu. A single place also has Clear Photo in its own menu", advanced: true, nav: true },
    { label: "Fill Missing City & Country", method: () => navigateAndOpenMenu("Places", "openPlacesMenu"), info: "Fill in a missing City and/or Country for selected places, using nearby places first and a lookup only for the rest, from the Places menu", advanced: true, nav: true },
    {
      label: "Personalize Guide with Photos",
      // Desktop already shows the Places panel (PlacesHeader.js) at all
      // times, so it can open the dialog directly via the same event
      // HomeHeader.js's "Create Journal from Photos" wizard uses to link
      // into this feature — no navigate-first step needed like mobile mode.
      method: MobileMode
        ? () => navigateAndOpenMenu("Places", "openPlacesMenu")
        : () => window.dispatchEvent(new CustomEvent("openPersonalizeGuideWithPhotos")),
      info: "Match your trip photos to nearby places by GPS proximity — set cover photos, add notes photos, turn new locations into new places (optionally identified by name via Wikipedia/city, one at a time or all at once), and require new places to be a minimum distance from existing ones to surface excursions, from the Places menu",
      advanced: false,
      nav: MobileMode,
      videoKey: "personalize-guide-with-photos",
    },
    {
      label: "Identify Places",
      method: MobileMode
        ? () => navigateAndOpenMenu("Places", "openPlacesMenu")
        : () => window.dispatchEvent(new CustomEvent("openIdentifyPlaces")),
      info: "Name the places already in your guide from where they are — e.g. ones still called after a photo file: nearby landmarks, the city, or a spot picked on the map, with each place's photos (web photos labelled), from the Places menu",
      advanced: false,
      nav: MobileMode,
    },
    { label: "Find Trails & Paths", method: () => navigateAndOpenMenu("Map", "openMapSearchMenu"), info: "Find trails and paths near you and add them to the guide, from the Map screen's Search menu", advanced: true, nav: true, videoKey: "walks-and-paths" },
    { label: "Auto Add Info to Notes", method: () => navigateAndOpenMenu("Places", "openPlacesMenu"), info: "Look up Wikipedia info for selected places and add it to their notes, from the Places menu", advanced: true, nav: true },
    { label: "Find Opening Times", method: () => navigateAndOpenMenu("Places", "openPlacesMenu"), info: "Look up open/close times for selected places, from the Places menu", advanced: true, nav: true, videoKey: "opening-hours-and-schedule-conflicts" },
    { label: "Mark Places as Bucket List", method: () => navigateAndOpenMenu("Places", "openPlacesMenu"), info: "Add selected places to your bucket list of future trips or places, from the Places menu", advanced: true, nav: true, videoKey: "place-attributes" },
    { label: "Mark Places as Must See", method: () => navigateAndOpenMenu("Places", "openPlacesMenu"), info: "Tag selected places as must-see, from the Places menu", advanced: true, nav: true, videoKey: "place-attributes" },
    { label: "Mark Places Favorites", method: () => navigateAndOpenMenu("Places", "openPlacesMenu"), info: "Tag selected places as favorites, from the Places menu", advanced: true, nav: true, videoKey: "place-attributes" },
    { label: "Mark Places Visited", method: () => navigateAndOpenMenu("Places", "openPlacesMenu"), info: "Tag selected places as visited, from the Places menu", advanced: true, nav: true, videoKey: "place-attributes" },
    { label: "Map Search Menu", method: () => navigateAndOpenMenu("Map", "openMapSearchMenu"), info: "Search for and add places to the map", advanced: false, nav: true },
    { label: "Add a Place on the Map", method: () => navigateAndOpenMenu("Map", "openMapSearchMenu"), info: "Search for a place by name and add it to your guide, from the Map menu", advanced: false, nav: true },
    { label: "Map Menu", method: () => navigateAndOpenMenu("Map", "openMapMenu"), info: "Get directions, center the map to your location, or track your location, from the Map screen's own Map Menu", advanced: false, nav: true },
    { label: "Get Directions", method: () => navigateAndOpenMenu("Map", "openMapMenu"), info: "Get walking or driving directions between places, from the Map Menu", advanced: false, nav: true },
    { label: "Center Map to My Location", method: () => navigateAndOpenMenu("Map", "openMapMenu"), info: "Center the map to your current location, from the Map Menu", advanced: false, nav: true },
    { label: "Track My Location", method: () => navigateAndOpenMenu("Map", "openMapMenu"), info: "Track your location on the map as you move, from the Map Menu", advanced: false, nav: true, videoKey: "track-your-trip" },
    { label: "Schedule Menu", method: () => navigateAndOpenMenu("Schedule", "openScheduleMenu"), info: "Manage schedules and events", advanced: false, nav: true },
    { label: "Set Your Hotel", method: () => navigateAndOpenMenu("Schedule", "andiamo-no-menu"), info: "Each day in the schedule starts with travel from your hotel: tap \"From your hotel · tap to set it\" on a day, or give a place the Hotel category. Arrival days show travel from the previous city.", advanced: false, nav: true },
    { label: "Recalculate Schedule", method: () => navigateAndOpenMenu("Schedule", "openScheduleMenu"), info: "Recalculate event times for the schedule or a single day, with an option to reorder by travel distance, from the Schedule menu", advanced: false, nav: true, visible: GuideEditMode, videoKey: "recalculate-schedule" },
    { label: "Move Events or Change Schedule Dates", method: () => navigateAndOpenMenu("Schedule", "openScheduleMenu"), info: "Move events, shift a day or all subsequent days, or change the schedule's start date, from the Schedule menu", advanced: false, nav: true, visible: GuideEditMode, videoKey: "move-events" },
    { label: "Swap or Replace Event Times", method: () => navigateAndOpenMenu("Schedule", "openScheduleMenu"), info: "Trade one event's start/end time with another, or replace its place with an unused guide place — tap an event's own \"...\" menu and choose \"Swap or Replace Event\"", advanced: true, nav: true, visible: GuideEditMode, videoKey: "swap-or-replace-events" },
  ].filter((c) => (c.visible === undefined ? true : c.visible) && (advancedMode || !c.advanced));

  // Desktop's palette excludes the "navigate + open menu" commands above — desktop
  // shows Places/Map/Schedule panels simultaneously already, so there's no screen to
  // navigate to first (see usability-recommendations.md rec #4).
  const desktopCommandPaletteCommands = commandPaletteCommands.filter((c) => !c.nav);

  if (MobileMode)
    return (
      <>
        {renderUnsavedGuideBanner()}
        {renderCommentsBanner()}
        {renderTravelDocumentBanner()}
        {renderProgressBanner()}
        {ShowLoginModal ? (
          <LoginModal show={ShowLoginModal} onHide={() => setShowLoginModal(false)} mode={LoginModalMode} onSwitchMode={setLoginModalMode} />
        ) : null}
        <CommandPalette
          show={commandPaletteShow}
          onHide={() => setCommandPaletteShow(false)}
          commands={commandPaletteCommands}
          onSecretMatch={handleAdminSecretMatch}
        />
        <div className="mnbb-bar">
          <div className="mnbb-track">
            <div
              className={`mnbb-segment${GuidesOrPlaces === "Guides" ? " mnbb-active" : ""}`}
              onClick={handleLibraryTap}
            >
              <span className="mnbb-icon"><FontAwesomeIcon icon={solid("book-open")} />{inviteCount > 0 && <span className="mnbb-badge" aria-label={`${inviteCount} share invitation${inviteCount === 1 ? "" : "s"}`}>{inviteCount}</span>}</span>
              <span className="mnbb-label">Library</span>
            </div>
            <div
              className={`mnbb-segment${GuidesOrPlaces === "Wanderlist" ? " mnbb-active" : ""}`}
              onClick={() => openWanderlist()}
            >
              <span className="mnbb-icon"><FontAwesomeIcon icon={solid("earth-europe")} /></span>
              <span className="mnbb-label">Wanderlist</span>
            </div>
            <div
              className="mnbb-segment"
              onClick={() => setCommandPaletteShow(true)}
              title="How-To — find a feature or action"
            >
              <span className="mnbb-icon"><FontAwesomeIcon icon={solid("lightbulb")} /></span>
              <span className="mnbb-label">How-To</span>
            </div>
            <div
              className={`mnbb-segment${GuidesOrPlaces === "You" ? " mnbb-active" : ""}`}
              onClick={() => dispatch(slice1Actions.setGuidesOrPlaces({ value: "You", GuideType: "None" }))}
            >
              <span className="mnbb-icon"><FontAwesomeIcon icon={regular("user")} /></span>
              <span className="mnbb-label">You</span>
            </div>
            <div className="mnbb-segment" onClick={MainMenu}>
              <span className="mnbb-icon"><FontAwesomeIcon icon={solid("ellipsis-vertical")} /></span>
              <span className="mnbb-label">Menu</span>
            </div>
          </div>
        </div>
        <div style={{ textAlign: "center", marginTop: "2px" }}>
          <span
            onClick={handlePrivacyPolicy}
            style={{ fontSize: "10px", color: "#8891A8", cursor: "pointer" }}
          >
            Privacy Policy
          </span>
        </div>
        {/* <GuideInfo show={guideInfoModal} onHide={() => setGuideInfoModal(false)} /> */}
        <HTMLEditorModal
          show={ShowHTMLEditorModal}
          onHide={() => setHTMLEditorModal(false)}
          html={HTMLEditorModalContent}
          callback={HTMLEditCallback}
          callback_rt={null}
          title={"Home Page"}
        />
        {/* <ImageUploadModal show={ShowImageUploadModal} onHide={() => setImageUploadModal(false)} /> */}
        <UserInfoModal show={ShowUserInfoModal} onHide={() => setUserInfoModal(false)} />
        {showDestinations ? (
          <DestinationsScreen onHide={() => setShowDestinations(false)} />
        ) : null}
        {showPreferences ? (
          <PreferencesScreen onHide={() => setShowPreferences(false)} />
        ) : null}
        {showAdminDashboard ? (
          <AdminDashboard onHide={() => setShowAdminDashboard(false)} currentUid={user_info?.uid} />
        ) : null}

        <AlertModal
          show={AlertModalShow}
          onHide={() => setAlertModalShow(false)}
          AlertModalTitle={AlertModalTitle}
          AlertModalMessage={AlertModalMessage}
          AlertModalButtons={AlertModalButtons}
        />
        {diffModalShow ? (
          <SaveConflictDiffModal
            show={diffModalShow}
            onHide={_reopenConflictDialogFromDiff}
            serverGuideInfo={diffModalConflict?.serverGuideInfo}
          />
        ) : null}
        <MenuModal
          show={MenuModalShow}
          onHide={() => { setMenuModalShow(false); setMenuModalBackFn(null); }}
          menu_modal_list={MenuModalList}
          menu_modal_heading={MenuModalHeading}
          menu_model_image={MenuModalImage}
          menu_modal_place={MenuModalPlace}
          onBack={MenuModalBackFn || undefined}
        />
        <GuideDownload
          show={GuideDownloadShow}
          onHide={() => setGuideDownloadShow(false)}
          user_info={user_info}
          guide_sort_option={GuideSortOption}
          set_guide_sort_option={setGuideSortOption}
          callback={GuideDownloadCallback}
          mode={GuideDownloadMode}
          modify_only={GuideDownloadType === "overwrite" ? "true" : "false"}
          guide_meta={guide_meta}
          guide_download_category={GuideDownloadCategory}
        />
        {wikipediaArticlesShow ? (
          <WikipediaArticlesModal
            onCancel={() => setWikipediaArticlesShow(false)}
            onConfirm={(places, query) => { setWikipediaArticlesShow(false); askWebPlacesGroup(places, "article", query); }}
          />
        ) : null}
        {photoJournalWizardShow ? (
          <PhotoJournalWizardModal
            show={photoJournalWizardShow}
            onHide={() => setPhotoJournalWizardShow(false)}
            onSelectFromSaved={_onSelectFromSaved}
            onSelectFromGDrive={_onSelectFromGDrive}
            onSelectFromWeb={_onSelectFromWeb}
            onSelectFromWikipedia={_onSelectFromWikipedia}
            onOpenPersonalize={() => navigateAndOpenMenu("Places", "openPersonalizeGuideWithPhotos")}
          />
        ) : null}
        <Modal
          show={gdriveJournalPickerShow}
          onHide={() => setGdriveJournalPickerShow(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: "1rem" }}>Select Photos from Google Drive</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: "12px 16px 16px" }}>
            <GoogleDrivePicker
              onSelect={(items, folderName) => {
                setGdriveJournalPickerShow(false);
                _onSelectFromGDrive(gdriveJournalOptions, items, folderName);
              }}
              multi={true}
              fileType="image"
            />
          </Modal.Body>
        </Modal>
        {photoJournalReviewShow ? (
          <PhotoJournalReviewModal
            show={photoJournalReviewShow}
            onHide={() => setPhotoJournalReviewShow(false)}
            clusters={photoJournalReviewClusters}
            sensitivity={photoJournalSensitivity}
            onSensitivityChange={_onPhotoJournalSensitivityChange}
            maxSpan={photoJournalMaxSpan}
            onMaxSpanChange={_onPhotoJournalMaxSpanChange}
            onApply={_applyPhotoJournalClusters}
          />
        ) : null}
        <ShareModal
          show={shareLinkShow}
          onHide={() => setShareLinkShow(false)}
          url={guideShareLink(guide_meta.guide_info_id)}
          title={(guide_meta.guide_info && guide_meta.guide_info.guide_name) || "Guide"}
        />
        {ImageDialogShow ? (
          <ImageDialog
            show={ImageDialogShow}
            onHide={() => setImageDialogShow(false)}
            user_info={user_info}
            callback={ImageDialogCallback}
            mode={ImageDialogMode}
            modify_only={"true"}
            updateImage={ImageDialogCallback}
            size={"sm"}
            multi={true}
            exif={ImageDialogExif}
            webPhotos={ImageDialogWeb}
            folder={imageFolder}
            setImageFolder={setImageFolder}
            emptyStateNote={ImageDialogMode === "select" ? "No files present — create a folder, upload your trip photos, and rename them if desired using the tools above." : null}
          />
        ) : null}
        {/* <Offcanvas show={CategoriesDialogShow} onHide={() => setCategoriesDialogShow(false)}>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Offcanvas</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body> */}

        {SettingsDialogShow ? (
          <SettingsDialog
            show={SettingsDialogShow}
            onHide={() => setSettingsDialogShow(false)}
            user_info={user_info}
            creator_info={creator_info}
            user_info_id={user_info_id}
            callback={SettingsDialogCallback}
          />
        ) : null}

        {AiDialogShow ? (
          <AiDialog
            show={AiDialogShow}
            onHide={() => setAiDialogShow(false)}
            questions={AppSettings.questions2}
            user_info={user_info}
          />
        ) : null}

        {FlightStatusShow && (
          <FlightStatusDialog show={FlightStatusShow} onHide={() => setFlightStatusShow(false)} />
        )}

        {ClimateDialogParams && (
          <ClimateDialog
            show={!!ClimateDialogParams}
            onHide={() => dispatch(slice1Actions.setClimateDialogParams({ value: null }))}
            city={ClimateDialogParams.city}
            country={ClimateDialogParams.country}
            lat={ClimateDialogParams.lat}
            lon={ClimateDialogParams.lon}
          />
        )}

        {/* </Offcanvas.Body>
        </Offcanvas> */}

        {SectionsDialogShow ? (
          <SectionsDialog
            show={SectionsDialogShow}
            onHide={() => setSectionsDialogShow(false)}
            update_display={UpdateDisplay}
            mode={"edit"}
            callback={null}
          />
        ) : null}
        {ReviewDialogShow ? (
          <ReviewDialog
            show={ReviewDialogShow}
            onHide={() => setReviewDialogShow(false)}
            user_info={user_info}
            guide_info_id={guide_meta.guide_info_id}
            guide_info={guide_meta.guide_info}
          />
        ) : null}
        {showCommentsList ? (
          <CommentsListModal show={showCommentsList} onHide={() => setShowCommentsList(false)} />
        ) : null}
        {showGuideDiscussion ? (
          <GuideDiscussionModal show={showGuideDiscussion} onHide={() => setShowGuideDiscussion(false)} />
        ) : null}
        {showPolls ? <PollsModal show={showPolls} onHide={() => setShowPolls(false)} /> : null}
        {showExpenses ? <ExpensesModal show={showExpenses} onHide={() => setShowExpenses(false)} /> : null}
        {showTripMembers ? <TripMembersModal show={showTripMembers} onHide={() => setShowTripMembers(false)} /> : null}
        {showPhotoBookPreview ? (
          <PhotoBookPreviewModal show={showPhotoBookPreview} onHide={() => setShowPhotoBookPreview(false)} />
        ) : null}
        {GuideEditModalShow ? (
          <GuideEditModal
            show={GuideEditModalShow}
            onHide={() => setGuideEditModalShow(false)}
            guide_meta={guide_meta}
            guide_info={guide_meta.guide_info}
            guide_info_id={guide_meta.guide_info_id}
            user_info={user_info}
            mode={GuideEditModalMode}
            callback={GuideEditModalCallback}
          folder={imageFolder}
          setImageFolder={setImageFolder}
          />
        ) : null}
        {TripAIShow ? (
          <TripAI
            show={TripAIShow}
            onHide={() => setTripAIShow(false)}
            user_info={user_info}
            update_ui={updateUI}
            update_guide={updateGuide}
            set_schedule_name={SetScheduleName}
            ai_base_categories={AppSettings.AIBaseCategories}
            ai_categories={AppSettings.AICategories}
            clear_guide={_clearGuide}
            new_guide={newGuide}
            /* Was createNewGuideForAI (immediate Firestore write on every
               "A new guide" pick) — switched to createLocalGuide (in-memory,
               promoted to a real cloud doc on first Save) so a signed-in
               user doesn't leave an abandoned "New Guide" doc behind every
               time they back out or forget to save. Matches the decision
               already made for "Start with blank guide"
               (newGuideManual/_newGuide, this same file) and mobile's
               identical fix (andiamo-places MainScreen.js's
               _tripAICallbacks). Side effect: guests, previously blocked
               here by createNewGuideForAI's own Alert, now get a working
               local guide too — matching mobile, which already supported
               this. Every create_new_guide prop below reuses the same
               function. Found/changed 2026-09-27. */
            create_new_guide={createLocalGuide}
            GuideSettings={GuideSettings}
          />
        ) : null}
        {BuildMyTripWizardShow ? (
          <BuildMyTripWizard
            show={BuildMyTripWizardShow}
            onHide={() => { setBuildMyTripWizardShow(false); setBuildMyTripInitialTarget(undefined); setBuildMyTripInitialDestinations(undefined); setBuildMyTripReplaceDestinations(false); setBuildMyTripAutoStart(false); setBuildMyTripPickPlacesAuto(true); setBuildMyTripPaceMultiplier("1.3"); setBuildMyTripFromNudge(false); setBuildMyTripAutoOpenAI(false); setBuildMyTripInitialScheduleTarget(undefined); setBuildMyTripFromGuides(false); setBuildMyTripFromThisGuide(null); }}
            clear_guide={_clearGuide}
            create_new_guide={createLocalGuide}
            initialGuideTarget={buildMyTripInitialTarget}
            initialDestinations={buildMyTripInitialDestinations}
            replaceDestinations={buildMyTripReplaceDestinations}
            autoStart={buildMyTripAutoStart}
            autoStartPickPlacesAuto={buildMyTripPickPlacesAuto}
            autoStartPaceMultiplier={buildMyTripPaceMultiplier}
            fromDestinationsNudge={buildMyTripFromNudge}
            onSwitchToAI={() => { setBuildMyTripWizardShow(false); setTripAIShow(true); }}
            autoOpenAI={buildMyTripAutoOpenAI}
            initialScheduleTarget={buildMyTripInitialScheduleTarget}
            initialFromGuides={buildMyTripFromGuides}
            initialThisGuide={buildMyTripFromThisGuide}
          />
        ) : null}
        {WalkAIShow ? (
          <WalkAI
            show={WalkAIShow}
            onHide={() => setWalkAIShow(false)}
            update_ui={updateUI}
            update_guide={updateGuide}
          />
        ) : null}

        {GuideSettingsDialogShow ? (
          <GuideSettingsDialog show={GuideSettingsDialogShow} onHide={() => setGuideSettingsDialogShow(false)} />
        ) : null}
        {CategoriesDialogShow ? (
          <CategoriesDialog
            show={CategoriesDialogShow}
            onHide={() => setCategoriesDialogShow(false)}
            update_display={UpdateDisplay}
          />
        ) : null}
        {GroupsDialogShow ? (
          <GroupsDialog
            show={GroupsDialogShow}
            onHide={() => setGroupsDialogShow(false)}
            update_display={UpdateDisplay}
          />
        ) : null}
        {PlacesOfInterestShow ? (
          <PlacesOfInterest
            show={PlacesOfInterestShow}
            onHide={() => setPlacesOfInterestShow(false)}
            update_display={UpdateDisplay}
          />
        ) : null}
        {CustomIconsShow ? (
          <CustomIcons show={CustomIconsShow} onHide={() => setCustomIconsShow(false)} update_display={UpdateDisplay} />
        ) : null}
        {PackingListDialogShow ? (
          <PackingListDialog show={PackingListDialogShow} onHide={() => setPackingListDialogShow(false)} />
        ) : null}
      {ShowMultiselect ? (
        <MultiSelectModal
          show={ShowMultiselect}
          onHide={() => setShowMultiselect(false)}
          MultiselectItems={MultiselectItems}
          MultiselectSelectedItems={MultiselectSelectedItems}
          MultiselectMode={MultiselectMode}
          MultiselectCallback={handleContentFontZoomCallback}
          MultiselectTitle={MultiselectTitle}
          MultiselectSearchText={MultiselectSearchText}
        />
      ) : null}
      {webPhotoGroupDialog}
      <MultiSelectModal
        show={_ShowMultiselect}
        onHide={() => dispatch(slice1Actions.setShowMultiselect({ value: false }))}
        MultiselectItems={_MultiselectItems}
        MultiselectSelectedItems={_MultiselectSelectedItems}
        MultiselectMode={_MultiselectMode}
        MultiselectCallback={_MultiselectCallback}
        MultiselectTitle={_MultiselectTitle}
        MultiselectSearchText={_MultiselectSearchText}
      />
      {KMLInputShow ? (
        <KMLInput
          show={KMLInputShow}
          onHide={() => { setKMLInputShow(false); setKMLPresetFiles(null); }}
          PromptModalTitle={"KML"}
          PromptModalMessage={"Import KML file"}
          PromptModalButtons={[{ Title: "CANCEL", Method: null }]}
          PromptModalInputs={[{ name: "Read file", value: "" }]}
          add_place_to_map={addPlaceToMap}
          file_type={KMLFileType}
          presetFiles={KMLPresetFiles}
        />
      ) : null}
      {GuideTranslateShow ? (
        <GuideTranslate
          show={GuideTranslateShow}
          onHide={() => setGuideTranslateShow(false)}
          update_ui={updateUIAndHome}
        />
      ) : null}
      <ExportTripModal show={exportTripShow} onHide={() => setExportTripShow(false)} />
      <ImportTripModal show={importTripShow} onHide={() => setImportTripShow(false)} />
      <ImportConfirmationModal
        show={importConfirmationShow}
        onHide={() => setImportConfirmationShow(false)}
        onOfferTripAI={offerTripAIFromImport}
      />
      <ImportItineraryImageModal
        show={importItineraryImageShow}
        onHide={() => setImportItineraryImageShow(false)}
        onBuildMyTrip={(t, initialDests) => { setBuildMyTripInitialTarget(t); setBuildMyTripInitialDestinations(initialDests); setBuildMyTripAutoStart(false); setBuildMyTripFromNudge(false); setBuildMyTripWizardShow(true); }}
        onBuildFromPlaces={(placeIds) => {
          if (GuidesOrPlaces !== "Places") dispatch(slice1Actions.setGuidesOrPlaces({ value: "Places", GuideType: "None" }));
          dispatch(slice1Actions.setCurrentAppScreen({ value: "Places" }));
          setTimeout(() => window.dispatchEvent(new CustomEvent("andiamo-build-trip-from-places", { detail: { placeIds } })), 350);
        }}
      />
      <ExportVideoModal show={showExportVideo} onHide={() => setShowExportVideo(false)} />
      <ExportOptionsModal
        show={showExportOptions}
        onHide={() => setShowExportOptions(false)}
        guide={window.guide_obj}
        onExportHTML={doExportHTML}
        onExportPDF={doExportPDF}
      />
      </>
    );
  return (
    <>
      {renderUnsavedGuideBanner()}
        {renderCommentsBanner()}
      {renderTravelDocumentBanner()}
      {/* renderProgressBanner() not rendered on desktop: it duplicates the
          per-screen hint cards (Places.js/SchedulePanel.js/Map.js/Home.js)
          that already cover the same "what do I do next" guidance there —
          showing both at once is redundant clutter, confirmed by direct
          user feedback. Mobile keeps it since it has no per-screen hints. */}
      {MobileMode ? (
        <input
          className="form-item"
          placeholder="Choose file"
          type="file"
          accept=".json"
          onChange={readLocalFile}
          id="guide-file-upload"
          multiple
          hidden
        />
      ) : (
      <>
      <div
        id="menu"
        style={{
          display: "flex",
          width: "100%",
          margin: "0px",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: "1rem",
        }}
      >
        <div className="side-none" style={{ display: "flex", flexDirection: "column", alignItems: "center", marginRight: 10 }}>
          <img
            src={logo}
            alt=""
            height="36px"
            width="36px"
            style={{ borderRadius: "50%" }}
          />
          <h6 style={{ color: "orange", margin: "1px 0 0 0", fontSize: "0.7rem", fontWeight: 700, whiteSpace: "nowrap" }}>
            Andiamo Places
          </h6>
        </div>
        <div className="home-header">
          {htmlStackLength > 1 ? (
            
            <div className="mnbb-segment" onClick={goBack}>
              <span className="mnbb-icon"><FontAwesomeIcon icon={solid("arrow-left")} /></span>
              <span className="mnbb-label">Back</span>
            </div>
            // <div onClick={() => goBack()} style={{ cursor: "pointer", color: "#3598DB", verticalAlign: "middle" }}>
            //   <FontAwesomeIcon icon={solid("arrow-left")} className="pointer" />
            //   <p>Back</p>
            // </div>
          ) : null}
          <div className="mnbb-segment" onClick={DisplayHomeScreen}>
            <span className="mnbb-icon"><FontAwesomeIcon icon={solid("book-open")} /></span>
            <span className="mnbb-label">Itinerary</span>
          </div>
          <div className="mnbb-segment" onClick={() => setShowDestinations(true)}>
            <span className="mnbb-icon"><FontAwesomeIcon icon={solid("map-location-dot")} /></span>
            <span className="mnbb-label">Destination</span>
          </div>
          {/* <div onClick={ViewMenu} style={{ cursor: "pointer", color: "#3598DB", verticalAlign: "middle" }}>
            <FontAwesomeIcon icon={solid("eye")} className="pointer" />
            <p>View</p>
          </div> */}
          <label htmlFor="guide-file-upload" className="custom-file-upload" hidden>
            <FontAwesomeIcon title="Select KML File" icon={solid("cloud-upload")} className="pointer" size="5x" />
          </label>
          <input
            className="form-item"
            placeholder="Choose file"
            style={{ width: "250px" }}
            type="file"
            accept=".json"
            onChange={readLocalFile}
            id="guide-file-upload"
            multiple
            hidden
          />
          {/* <div className="none" onClick={() => GuideMenu()} style={{ cursor: "pointer", color: bookColor(), verticalAlign: "middle" }}>
            <FontAwesomeIcon icon={solid("book-open")} className="pointer" />
            <p>Guide</p>
          </div> */}
          {/* {GuideEditMode && GuidesOrPlaces === "Places" ? (
            <div className="none" style={{ cursor: "pointer", color: "#3598DB", verticalAlign: "middle" }} onClick={() => EditMenu()}>
              <FontAwesomeIcon icon={solid("pencil")} />
              <p>Edit</p>
            </div>
          ) : null} */}
          {GuidesOrPlaces === "Places" ? (
            <div className="mnbb-segment" onClick={openWanderlist}>
              <span className="mnbb-icon"><FontAwesomeIcon icon={solid("earth-europe")} /></span>
              <span className="mnbb-label">Wanderlist</span>
            </div>
            // <div className="none" style={{ cursor: "pointer", color: COLORS.BLUE, verticalAlign: "middle", textAlign: "center" }} onClick={() => getGuideStatistics()}>
            //   <FontAwesomeIcon icon={solid("earth-europe")} />
            //   <p>Wanderlist</p>
            // </div>
          ) : null}
            <div className="mnbb-segment" onClick={() => { setGuideDownloadType("read"); setGuideDownloadMode("download"); setGuideDownloadShow(true); }}>
              <span className="mnbb-icon"><FontAwesomeIcon icon={regular("bookmark")} />{inviteCount > 0 && <span className="mnbb-badge" aria-label={`${inviteCount} share invitation${inviteCount === 1 ? "" : "s"}`}>{inviteCount}</span>}</span>
              <span className="mnbb-label">Library</span>
            </div>
            <div className="mnbb-segment" onClick={() => setCommandPaletteShow(true)} title="How-To — find a feature or action">
              <span className="mnbb-icon"><FontAwesomeIcon icon={solid("lightbulb")} /></span>
              <span className="mnbb-label">How-To</span>
            </div>
            <div className="mnbb-segment" onClick={() => setShowYouModal(true)}>
              <span className="mnbb-icon"><FontAwesomeIcon icon={solid("user")} /></span>
              <span className="mnbb-label">You</span>
            </div>
          {/* <div className="none" style={{ cursor: "pointer", color: userColor(), verticalAlign: "middle", textAlign: "center" }} onClick={() => UserMenu()}>
            <FontAwesomeIcon icon={solid("user")} />
            <p>You</p>
          </div> */}
            <div className="mnbb-segment" onClick={MainMenu}>
              <span className="mnbb-icon"><FontAwesomeIcon icon={solid("ellipsis-vertical")} /></span>
              <span className="mnbb-label">Menu</span>
            </div>
          {/* <div style={{ cursor: "pointer", color: "#3598DB", verticalAlign: "middle", textAlign: "center" }} onClick={() => MainMenu()}>
            <FontAwesomeIcon icon={solid("bars")} />
            <p>Menu</p>
          </div> */}
        </div>
      </div>
      <div style={{ textAlign: "center", marginTop: "0px", lineHeight: 1 }}>
        <span
          onClick={handlePrivacyPolicy}
          style={{ fontSize: "10px", color: "#8891A8", cursor: "pointer" }}
        >
          Privacy Policy
        </span>
      </div>
      </>
      )}
      <CommandPalette
        show={commandPaletteShow}
        onHide={() => setCommandPaletteShow(false)}
        commands={MobileMode ? commandPaletteCommands : desktopCommandPaletteCommands}
        onSecretMatch={handleAdminSecretMatch}
      />
      {/* <GuideInfo show={guideInfoModal} onHide={() => setGuideInfoModal(false)} /> */}
      {ShowHTMLEditorModal ? (
        <HTMLEditorModal
          show={ShowHTMLEditorModal}
          onHide={() => setHTMLEditorModal(false)}
          html={HTMLEditorModalContent}
          callback={HTMLEditCallback}
          callback_rt={null}
          title={"Home Page"}
        />
      ) : null}
      {/* <ImageUploadModal show={ShowImageUploadModal} onHide={() => setImageUploadModal(false)} /> */}
      {ShowUserInfoModal ? <UserInfoModal show={ShowUserInfoModal} onHide={() => setUserInfoModal(false)} /> : null}
      {ShowLoginModal ? (
        <LoginModal show={ShowLoginModal} onHide={() => setShowLoginModal(false)} mode={LoginModalMode} onSwitchMode={setLoginModalMode} />
      ) : null}
      {ShowYouModal ? (
        <YouModal show={ShowYouModal} onHide={() => setShowYouModal(false)} />
      ) : null}

      {AlertModalShow ? (
        <AlertModal
          show={AlertModalShow}
          onHide={() => setAlertModalShow(false)}
          AlertModalTitle={AlertModalTitle}
          AlertModalMessage={AlertModalMessage}
          AlertModalButtons={AlertModalButtons}
        />
      ) : null}
      {diffModalShow ? (
        <SaveConflictDiffModal
          show={diffModalShow}
          onHide={_reopenConflictDialogFromDiff}
          serverGuideInfo={diffModalConflict?.serverGuideInfo}
        />
      ) : null}
      {showDestinations ? (
        <DestinationsScreen onHide={() => setShowDestinations(false)} />
      ) : null}
      {showPreferences ? (
        <PreferencesScreen onHide={() => setShowPreferences(false)} />
      ) : null}
      {showAdminDashboard ? (
        <AdminDashboard onHide={() => setShowAdminDashboard(false)} currentUid={user_info?.uid} />
      ) : null}
      {MenuModalShow ? (
        <MenuModal
          show={MenuModalShow}
          onHide={() => { setMenuModalShow(false); setMenuModalBackFn(null); }}
          menu_modal_list={MenuModalList}
          menu_modal_heading={MenuModalHeading}
          menu_model_image={MenuModalImage}
          menu_modal_place={MenuModalPlace}
          onBack={MenuModalBackFn || undefined}
        />
      ) : null}
      {GuideDownloadShow ? (
        <GuideDownload
          show={GuideDownloadShow}
          onHide={() => { setGuideDownloadShow(false); setGuideDownloadInitialType(null); }}
          user_info={user_info}
          guide_sort_option={GuideSortOption}
          set_guide_sort_option={setGuideSortOption}
          callback={GuideDownloadCallback}
          mode={GuideDownloadMode}
          modify_only={GuideDownloadType === "overwrite" ? "true" : "false"}
          guide_meta={guide_meta}
          guide_download_category={GuideDownloadCategory}
          viewed_guides={ViewedGuides}
          initial_guide_type={GuideDownloadInitialType || (GuideDownloadType === "read" && inviteCount > 0 ? "Shared" : GuideDownloadType === "read" && ViewedGuides.length > 0 ? "Viewed" : "Mine")}
        />
      ) : null}
      {wikipediaArticlesShow ? (
        <WikipediaArticlesModal
          onCancel={() => setWikipediaArticlesShow(false)}
          onConfirm={(places, query) => { setWikipediaArticlesShow(false); askWebPlacesGroup(places, "article", query); }}
        />
      ) : null}
      {photoJournalWizardShow ? (
        <PhotoJournalWizardModal
          show={photoJournalWizardShow}
          onHide={() => setPhotoJournalWizardShow(false)}
          onSelectFromSaved={_onSelectFromSaved}
          onSelectFromGDrive={_onSelectFromGDrive}
          onSelectFromWeb={_onSelectFromWeb}
          onSelectFromWikipedia={_onSelectFromWikipedia}
          onOpenPersonalize={() => navigateAndOpenMenu("Places", "openPersonalizeGuideWithPhotos")}
        />
      ) : null}
      <Modal
        show={gdriveJournalPickerShow}
        onHide={() => setGdriveJournalPickerShow(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: "1rem" }}>Select Photos from Google Drive</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "12px 16px 16px" }}>
          <GoogleDrivePicker
            onSelect={(items, folderName) => {
              setGdriveJournalPickerShow(false);
              _onSelectFromGDrive(gdriveJournalOptions, items, folderName);
            }}
            multi={true}
            fileType="image"
          />
        </Modal.Body>
      </Modal>
      {photoJournalReviewShow ? (
        <PhotoJournalReviewModal
          show={photoJournalReviewShow}
          onHide={() => setPhotoJournalReviewShow(false)}
          clusters={photoJournalReviewClusters}
          sensitivity={photoJournalSensitivity}
          onSensitivityChange={_onPhotoJournalSensitivityChange}
          maxSpan={photoJournalMaxSpan}
          onMaxSpanChange={_onPhotoJournalMaxSpanChange}
          onApply={_applyPhotoJournalClusters}
        />
      ) : null}
      <ShareModal
        show={shareLinkShow}
        onHide={() => setShareLinkShow(false)}
        url={guideShareLink(guide_meta.guide_info_id)}
        title={(guide_meta.guide_info && guide_meta.guide_info.guide_name) || "Guide"}
      />
      <ExportTripModal show={exportTripShow} onHide={() => setExportTripShow(false)} />
      <ImportTripModal show={importTripShow} onHide={() => setImportTripShow(false)} />
      <ImportConfirmationModal
        show={importConfirmationShow}
        onHide={() => setImportConfirmationShow(false)}
        onOfferTripAI={offerTripAIFromImport}
      />
      <ImportItineraryImageModal
        show={importItineraryImageShow}
        onHide={() => setImportItineraryImageShow(false)}
        onBuildMyTrip={(t, initialDests) => { setBuildMyTripInitialTarget(t); setBuildMyTripInitialDestinations(initialDests); setBuildMyTripAutoStart(false); setBuildMyTripFromNudge(false); setBuildMyTripWizardShow(true); }}
        onBuildFromPlaces={(placeIds) => {
          if (GuidesOrPlaces !== "Places") dispatch(slice1Actions.setGuidesOrPlaces({ value: "Places", GuideType: "None" }));
          dispatch(slice1Actions.setCurrentAppScreen({ value: "Places" }));
          setTimeout(() => window.dispatchEvent(new CustomEvent("andiamo-build-trip-from-places", { detail: { placeIds } })), 350);
        }}
      />
      <ExportVideoModal show={showExportVideo} onHide={() => setShowExportVideo(false)} />
      <ExportOptionsModal
        show={showExportOptions}
        onHide={() => setShowExportOptions(false)}
        guide={window.guide_obj}
        onExportHTML={doExportHTML}
        onExportPDF={doExportPDF}
      />
      {ImageDialogShow ? (
        <ImageDialog
          show={ImageDialogShow}
          onHide={() => setImageDialogShow(false)}
          user_info={user_info}
          callback={ImageDialogCallback}
          mode={ImageDialogMode}
          modify_only={"true"}
          updateImage={ImageDialogCallback}
          size={"sm"}
          multi={true}
          exif={ImageDialogExif}
          webPhotos={ImageDialogWeb}
          folder={imageFolder}
          setImageFolder={setImageFolder}
          emptyStateNote={ImageDialogMode === "select" ? "No files present — create a folder, upload your trip photos, and rename them if desired using the tools above." : null}
        />
      ) : null}
      {/* <Offcanvas show={CategoriesDialogShow} onHide={() => setCategoriesDialogShow(false)}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Offcanvas</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body> */}
      {SettingsDialogShow ? (
        <SettingsDialog
          show={SettingsDialogShow}
          onHide={() => setSettingsDialogShow(false)}
          user_info={user_info}
          creator_info={creator_info}
          user_info_id={user_info_id}
          callback={SettingsDialogCallback}
        />
      ) : null}

      {AiDialogShow ? (
        <AiDialog
          show={AiDialogShow}
          onHide={() => setAiDialogShow(false)}
          questions={AppSettings.questions2}
          user_info={user_info}
        />
      ) : null}

      {FlightStatusShow && (
        <FlightStatusDialog show={FlightStatusShow} onHide={() => setFlightStatusShow(false)} />
      )}

      {ClimateDialogParams && (
        <ClimateDialog
          show={!!ClimateDialogParams}
          onHide={() => dispatch(slice1Actions.setClimateDialogParams({ value: null }))}
          city={ClimateDialogParams.city}
          country={ClimateDialogParams.country}
          lat={ClimateDialogParams.lat}
          lon={ClimateDialogParams.lon}
        />
      )}
      {/* </Offcanvas.Body>
      </Offcanvas> */}

      {SectionsDialogShow ? (
        <SectionsDialog
          show={SectionsDialogShow}
          onHide={() => setSectionsDialogShow(false)}
          update_display={UpdateDisplay}
          mode={"edit"}
          callback={null}
        />
      ) : null}
      {ReviewDialogShow ? (
        <ReviewDialog
          show={ReviewDialogShow}
          onHide={() => setReviewDialogShow(false)}
          user_info={user_info}
          guide_info_id={guide_meta.guide_info_id}
          guide_info={guide_meta.guide_info}
        />
      ) : null}
      {showCommentsList ? (
        <CommentsListModal show={showCommentsList} onHide={() => setShowCommentsList(false)} />
      ) : null}
      {showGuideDiscussion ? (
        <GuideDiscussionModal show={showGuideDiscussion} onHide={() => setShowGuideDiscussion(false)} />
      ) : null}
      {showPolls ? <PollsModal show={showPolls} onHide={() => setShowPolls(false)} /> : null}
      {showExpenses ? <ExpensesModal show={showExpenses} onHide={() => setShowExpenses(false)} /> : null}
      {showTripMembers ? <TripMembersModal show={showTripMembers} onHide={() => setShowTripMembers(false)} /> : null}
      {showPhotoBookPreview ? (
        <PhotoBookPreviewModal show={showPhotoBookPreview} onHide={() => setShowPhotoBookPreview(false)} />
      ) : null}
      {GuideEditModalShow ? (
        <GuideEditModal
          show={GuideEditModalShow}
          onHide={() => setGuideEditModalShow(false)}
          guide_meta={guide_meta}
          guide_info={guide_meta.guide_info}
          guide_info_id={guide_meta.guide_info_id}
          user_info={user_info}
          mode={GuideEditModalMode}
          callback={GuideEditModalCallback}
          folder={imageFolder}
          setImageFolder={setImageFolder}
        />
      ) : null}
      {TripAIShow ? (
        <TripAI
          show={TripAIShow}
          onHide={() => setTripAIShow(false)}
          user_info={user_info}
          update_ui={updateUI}
          update_guide={updateGuide}
          set_schedule_name={SetScheduleName}
          ai_base_categories={AppSettings.AIBaseCategories}
          ai_categories={AppSettings.AICategories}
          clear_guide={_clearGuide}
          new_guide={newGuide}
          create_new_guide={createLocalGuide}
          GuideSettings={GuideSettings}
        />
      ) : null}
      {BuildMyTripWizardShow ? (
        <BuildMyTripWizard
            show={BuildMyTripWizardShow}
            onHide={() => { setBuildMyTripWizardShow(false); setBuildMyTripInitialTarget(undefined); setBuildMyTripInitialDestinations(undefined); setBuildMyTripReplaceDestinations(false); setBuildMyTripAutoStart(false); setBuildMyTripPickPlacesAuto(true); setBuildMyTripPaceMultiplier("1.3"); setBuildMyTripFromNudge(false); setBuildMyTripAutoOpenAI(false); setBuildMyTripInitialScheduleTarget(undefined); setBuildMyTripFromGuides(false); setBuildMyTripFromThisGuide(null); }}
            clear_guide={_clearGuide}
            create_new_guide={createLocalGuide}
            initialGuideTarget={buildMyTripInitialTarget}
            initialDestinations={buildMyTripInitialDestinations}
            replaceDestinations={buildMyTripReplaceDestinations}
            autoStart={buildMyTripAutoStart}
            autoStartPickPlacesAuto={buildMyTripPickPlacesAuto}
            autoStartPaceMultiplier={buildMyTripPaceMultiplier}
            fromDestinationsNudge={buildMyTripFromNudge}
            onSwitchToAI={() => { setBuildMyTripWizardShow(false); setTripAIShow(true); }}
            autoOpenAI={buildMyTripAutoOpenAI}
            initialScheduleTarget={buildMyTripInitialScheduleTarget}
            initialFromGuides={buildMyTripFromGuides}
            initialThisGuide={buildMyTripFromThisGuide}
          />
      ) : null}
      {WalkAIShow ? (
        <WalkAI
          show={WalkAIShow}
          onHide={() => setWalkAIShow(false)}
          update_ui={updateUI}
          update_guide={updateGuide}
        />
      ) : null}

      {GuideSettingsDialogShow ? (
        <GuideSettingsDialog show={GuideSettingsDialogShow} onHide={() => setGuideSettingsDialogShow(false)} />
      ) : null}
      {CategoriesDialogShow ? (
        <CategoriesDialog
          show={CategoriesDialogShow}
          onHide={() => setCategoriesDialogShow(false)}
          update_display={UpdateDisplay}
        />
      ) : null}
      {GroupsDialogShow ? (
        <GroupsDialog
          show={GroupsDialogShow}
          onHide={() => setGroupsDialogShow(false)}
          update_display={UpdateDisplay}
        />
      ) : null}
      {PlacesOfInterestShow ? (
        <PlacesOfInterest
          show={PlacesOfInterestShow}
          onHide={() => setPlacesOfInterestShow(false)}
          update_display={UpdateDisplay}
        />
      ) : null}
      {CustomIconsShow ? (
        <CustomIcons show={CustomIconsShow} onHide={() => setCustomIconsShow(false)} update_display={UpdateDisplay} />
      ) : null}
      {PackingListDialogShow ? (
        <PackingListDialog show={PackingListDialogShow} onHide={() => setPackingListDialogShow(false)} />
      ) : null}
      {PDFModalShow ? (
        <PDFModal
          show={PDFModalShow}
          htmlString={document.getElementById("home-content").innerHTML}
          onHide={() => setPDFModalShow(false)}
        />
      ) : null}
      {HTMLReaderModal ? (
        <HTMLReader html={HTMLContent} show={HTMLReaderModal} onHide={() => setHTMLReaderModal(false)} />
      ) : null}
      {ShowMultiselect ? (
        <MultiSelectModal
          show={ShowMultiselect}
          onHide={() => setShowMultiselect(false)}
          MultiselectItems={MultiselectItems}
          MultiselectSelectedItems={MultiselectSelectedItems}
          MultiselectMode={MultiselectMode}
          MultiselectCallback={handleContentFontZoomCallback}
          MultiselectTitle={MultiselectTitle}
          MultiselectSearchText={MultiselectSearchText}
        />
      ) : null}
      {KMLInputShow ? (
        <KMLInput
          show={KMLInputShow}
          onHide={() => { setKMLInputShow(false); setKMLPresetFiles(null); }}
          PromptModalTitle={"KML"}
          PromptModalMessage={"Import KML file"}
          PromptModalButtons={[{ Title: "CANCEL", Method: null }]}
          PromptModalInputs={[{ name: "Read file", value: "" }]}
          add_place_to_map={addPlaceToMap}
          file_type={KMLFileType}
          presetFiles={KMLPresetFiles}
        />
      ) : null}
      {GuideTranslateShow ? (
        <GuideTranslate
          show={GuideTranslateShow}
          onHide={() => setGuideTranslateShow(false)}
          update_ui={updateUIAndHome}
        />
      ) : null}
      {webPhotoGroupDialog}
      <MultiSelectModal
        show={_ShowMultiselect}
        onHide={() => dispatch(slice1Actions.setShowMultiselect({ value: false }))}
        MultiselectItems={_MultiselectItems}
        MultiselectSelectedItems={_MultiselectSelectedItems}
        MultiselectMode={_MultiselectMode}
        MultiselectCallback={_MultiselectCallback}
        MultiselectTitle={_MultiselectTitle}
        MultiselectSearchText={_MultiselectSearchText}
      />
      <GeoCharts
        show={GeoChartsShow}
        data={GeoChartsData}
        onHide={() => setGeoChartsShow(false)}
      />
    </>
  );
};

export default MobileBottomNavBar;
